{
  "data": {
    "blog": {
      "apply_plan_settings": "https://www.planfred.com/en/blog/apply-settings-from-last-plan",
      "daily_upload_alert": "https://www.planfred.com/en/blog/upload-notifier-daily-and-rightclick-menu",
      "enhanced_manuals": "https://www.planfred.com/en/blog/planfred-updates-its-user-guides",
      "features_2021": "https://www.planfred.com/en/blog/this-was-2021-in-features",
      "task_location": "https://www.planfred.com/en/blog/localize-tasks-even-more-precisely-directly-on-the-plan",
      "tasks_is_here": "https://www.planfred.com/en/blog/planfreds-tasks-is-here",
      "top_categories": "https://www.planfred.com/en/blog/top-categories-break-down-projects-into-objects"
    },
    "email_support": "support{'@'}planfred.com",
    "pf_links": {
      "blog_features": "https://www.planfred.com/en/blog/?category=features",
      "clipboard": "https://www.planfred.com/en/manual/#Clipboard%20–%20Create%20multiple%20plans%20or%20documents",
      "faq": "https://www.planfred.com/en/frequently-asked-questions/",
      "faq_project_transfer": "https://www.planfred.com/en/manual/#Project%20transfer%20–%20change%20of%20project%20owner",
      "impressum": "https://www.planfred.com/en/imprint-agb-gmbh/",
      "in_app_support": "https://calendly.com/planfred/in-app-support-de",
      "manual_approvals": "https://www.planfred.com/en/manual/#Approval/Review%20of%20plans%20and%20documents",
      "manual_compare_indexes": "https://www.planfred.com/en/manual/#Compare%20indexes",
      "manual_project_transfer": "https://www.planfred.com/en/manual/#Project%20transfer%20%E2%80%93%20change%20of%20project%20owner",
      "manual_tips": "https://www.planfred.com/en/manual/",
      "manual_update_plans": "https://www.planfred.com/en/manual/#Update%20multiple%20plans%20automatically",
      "personal_support": "https://www.planfred.com/en/contact/",
      "planfred_app_registration": "https://app.planfred.com/registration",
      "planfred_website": "https://www.planfred.com",
      "privacy_policy": "https://www.planfred.com/en/privacy/",
      "your_project_in_5_steps": "https://www.planfred.com/en/help/your-project-organized-in-a-few-steps",
      "your_project_in_5_steps_documents": "https://www.planfred.com/en/help/your-project-organized-in-a-few-steps#neues-dokument-anlegen-dokument-erstmalig-hochladen",
      "your_project_in_5_steps_participants": "https://www.planfred.com/en/help/your-project-organized-in-a-few-steps#beteiligte-zum-projekt-einladen-berechtigungen",
      "your_project_in_5_steps_plans": "https://www.planfred.com/en/help/your-project-organized-in-a-few-steps#neuen-plan-anlegen-plan-erstmalig-hochladen"
    },
    "phone_number": "+43 1 9974470-2"
  },
  "enterprise": {
    "apg_planserver": {
      "accountActivationTerms": {
        "account_page_download_headline": "Legal terms",
        "checkboxLabel": "I confirm that I have read the instructions of the lapel for the use of the PLANFRED data platform as amended and that they will be complied with.",
        "download_specifications": "Download legal terms",
        "download_terms_file_path": "/static/img/email/apgplanserverat/APG_UAW_Planverwaltung-REVERS_2021-07-21.pdf",
        "error_message": "Accept the terms."
      },
      "monthly_project_overview_report": {
        "can_approve_revisions": "Plan review permission",
        "company": "Company",
        "email": "Email (User account)",
        "email_subject": "APG-Planserver project overview",
        "email_title": "APG-Planserver",
        "from": "{appName} Project-participants-report",
        "last_project_access": "Last project access",
        "monthly_project_overview": "Monthly project overview",
        "monthly_report_title": "APG-planfred-monthly-report",
        "name": "Name",
        "participants_list_title": "APG-planfred-participants-list",
        "permission": "Permission",
        "phone": "Phone",
        "project_admin_at_project": "Project administrator at project",
        "project_admins": "Project administrators",
        "project_owner": "Project owners",
        "project_owner_at_project": "Project owner at project",
        "project_participant_at_project": "Project participant at project",
        "project_participant_silent_at_project": "Project participant without login at project",
        "project_participants": "Project participants",
        "project_participants_silent": "Participants without login",
        "project_title": "Project-title",
        "projects_list_title": "APG-planfred-project-list",
        "roles": "Role"
      },
      "password_rules": {
        "has_cap_char": "… contain at least one capital letter",
        "has_low_char": "… contain at least one lower case letter",
        "has_number": "… contain at least one number",
        "has_special_char": "… contain at least one special character",
        "is_gt_11": "… have at least 10 characters",
        "your_password": "Your password must …"
      }
    },
    "klg_planserver": {
      "accountActivationTerms": {
        "account_page_download_headline": "Legal terms",
        "checkboxLabel": "I accept the terms of the KLG Planserver.",
        "download_specifications": "Download legal terms",
        "download_terms_file_path": "/static/img/email/klgplanserverde/Vorgaben_klg-planserver.de_Version_2.pdf",
        "error_message": "Accept the terms."
      }
    }
  },
  "feature": {
    "company_dashboard": {
      "send_to_additional_admins": "Send to additional admins",
      "title": "Company administration",
      "hint": "Central management of all projects and user accounts for the domain <strong>{domain}</strong>.",
      "projects_tab": "Projects",
      "users_tab": "User accounts",
      "no_projects": "No projects found.",
      "no_users": "No users found.",
      "loading": "Loading...",
      "load_error": "Error loading data.",
      "project_title": "Project Name",
      "owner_name": "Owner",
      "owner_company": "Owner Company",
      "participant": "Participants",
      "project_created": "Created",
      "take_ownership": "Take Ownership",
      "take_ownership_title": "Take over project ownership?",
      "take_ownership_confirm": "Confirm Take Ownership",
      "take_ownership_confirm_message": "Are you sure you want to take ownership of the project „<strong>{projectTitle}</strong>“ from <strong>{currentOwnerName} ({currentOwnerEmail})</strong>?",
      "take_ownership_error": "Error transferring ownership.",
      "take_all_project_ownership": "Take all project ownership",
      "take_all_project_ownership_question": "Are you sure you want to take ownership of all below projects?",
      "take_all_project_ownership_confirm": "Confirm Take all project ownership",
      "ownership_taken_by_you": "Ownership taken",
      "user_email": "Email",
      "user_name": "Name",
      "user_company": "Company",
      "user_last_login": "Last Login",
      "user_last_login_never": "Never",
      "user_active": "Active",
      "user_status": "Status",
      "user_status_active": "Enabled",
      "user_status_inactive": "Disabled",
      "disable_user": "Disable user account",
      "deactivate_user": "Deactivate User",
      "enable_user": "Enable user account",
      "enable_title": "Enable user account?",
      "enable_confirm": "Confirm Enable",
      "enable_confirm_message": "Are you sure you want to enable the account of <strong>{userName} ({userEmail})</strong>?",
      "disable_users_preview": "This will disable the selected user accounts.",
      "disable_title": "Disable user account?",
      "disable_confirm": "Confirm Disable",
      "disable_confirm_message": "Are you sure you want to disable the account of <strong>{userName} ({userEmail})</strong>?",
      "disable_owner_warning": "This user is owner of one or more projects. Take ownership before disabling.",
      "user_delete": "Trash selected user from projects",
      "users_delete": "Trash selected users from projects",
      "user_disable": "Disable selected user",
      "users_disable": "Disable selected users",
      "user_enable": "Enable selected user",
      "users_enable": "Enable selected users",
      "user_take_ownership": "Take ownership of the selected user's projects",
      "users_take_ownership": "Take ownership of the selected users' projects",
      "users_selected_status": "{selectedCount} of {totalCount} selected",
      "cannot_update_user": "This user cannot be updated",
      "cannot_update_users": "{filteredCount} of {totalCount} users cannot be updated",
      "trash_participants_from_projects": "Trash participants from projects",
      "trash_user": "Trash user",
      "trash_one_user": "Trash 1 user",
      "trash_x_users": "Trash {counter} users",
      "update_one_user": "Update 1 user",
      "update_x_users": "Update {counter} users",
      "enable_one_user": "Enable 1 user",
      "enable_x_users": "Enable {counter} users",
      "disable_one_user": "Disable 1 user",
      "disable_x_users": "Disable {counter} users",
      "delete_users_preview": "Trash selected users as participants from their projects.",
      "delete_users_error": "Error removing participants from projects. Please try again.",
      "delete_user_no_projects": "No project participation will be removed for this user.",
      "delete_user_no_project_participation_warning": "This user is not a participant in any project.",
      "delete_user_not_project_participant_warning": "This user is not participating in this project.",
      "trash_participants_skipped_projects_label": "The following projects will be skipped:",
      "trash_project_owner_warning": "Project owners cannot be trashed from their projects.",
      "delete_disabled_participant_warning": "Disabled participants cannot be updated.",
      "delete_disabled_user_warning": "Disabled users cannot be updated.",
      "enable_active_user_warning": "Active users cannot be updated.",
      "delete_user_excluded_projects_warning": "You do not have owner or admin access to this project.",
      "cannot_delete_own_account": "You cannot trash yourself from projects.",
      "cannot_disable_own_account": "You cannot disable your own account.",
      "cannot_take_ownership_own_account": "You cannot take ownership of your own projects.",
      "take_ownership_selected_preview": "Transfer project ownership of the selected users.",
      "take_ownership_selected_projects_label": "Take ownership of {count} project(s)",
      "take_ownership_user": "Take ownership from user",
      "take_ownership_one_user": "Take ownership from 1 user",
      "take_ownership_x_users": "Take ownership from {counter} users",
      "take_ownership_no_projects": "No owned projects were found for the selected users.",
      "take_ownership_load_error": "Failed to load owned projects. Please try again.",
      "remove_from_project_btn": "Trash participant",
      "remove_from_project_title": "Remove participant from project?",
      "remove_from_project_confirm": "Confirm removal",
      "remove_from_project_confirm_message": "Are you sure you want to remove <strong>{userName} ({userEmail})</strong> as a participant from the project „<strong>{projectTitle}</strong>“?",
      "remove_from_project_error": "Error removing user from project.",
      "trash_from_all_projects_btn": "Trash from all projects",
      "trash_from_all_projects_question": "Are you sure you want to trash <strong>{userName} ({userEmail})</strong> as a participant from all projects?",
      "trash_from_all_projects_confirm": "Trash from all projects",
      "toggle_enabled_error": "Error updating account status.",
      "cancel": "Cancel",
      "owner_email": "Owner Email",
      "no_project_access": "No project access",
      "domain": "Domain",
      "view_projects_btn": "Participating projects",
      "view_projects_role_label": "Role",
      "notify_owners_btn": "Notify project admins",
      "notify_owners_message": "Contact the relevant project administrators by email",
      "notify_owners_create_message": "Create message",
      "notify_owners_title": "Notify project admins",
      "notify_owners_loading": "Loading projects...",
      "notify_owners_load_error": "Failed to load projects. Please try again.",
      "notify_owners_no_projects": "There are no owners or admins available to notify for this user's projects.",
      "notify_owners_subject_label": "Subject",
      "notify_owners_projects_label": "Notify recipients",
      "notify_owners_confirm": "Send notifications",
      "notify_owners_submit_error": "Error sending notifications. Please try again.",
      "user_account_participating_projects_headline": "Internal project participations",
      "external_projects_headline": "External project participations",
      "user_account_participating_projects_empty": "No internal project participations",
      "notify_owners_subject_prefix": "{userEmail} –",
      "notify_owners_default_subject_suffix": "Project participant update",
      "notify_owners_successfully_sent_to_one": "Notification successfully sent to:",
      "notify_owners_successfully_sent_to_many": "Notifications successfully sent to:",
      "notify_owners_delivery_failed_to_one": "Delivery failed for the following recipient:",
      "notify_owners_delivery_failed_to_many": "Delivery failed for the following recipients:",
      "external_projects_info_single": "There is 1 participation in projects owned by external companies",
      "external_projects_info_multiple": "There are multiple participations in projects owned by external companies",
      "external_projects_none": "No external project participations"
    },
    "account": {
      "billing_data": {
        "active_subscription_until": "Active subscription until {subscriptionEndDate} - will get renewed automatically",
        "add_credit_card_data": "Enter Owner and credit card number.",
        "add_new_credit_card": "Add new credit card",
        "additional_invoice_information": "Additional information on accounting:",
        "address": "Invoice address",
        "billing_address": "Billing address",
        "city": "City",
        "company": "Company",
        "country": "Country",
        "credit_card": "Credit Card",
        "credit_card_could_not_get_verified": "This credit card could not get verified. Try another credit card.",
        "edit_subscription": "Edit plan settings",
        "error": {
          "city_required": "Enter a city name.",
          "company_required": "Enter a company.",
          "country_required": "Enter a country.",
          "email_invalid": "Enter a valid email address.",
          "email_required": "Enter an email address.",
          "plan_not_allowed_for_user": "Please select a sufficient plan.",
          "save_error": "An error occurred while saving!",
          "street_required": "Enter an address.",
          "uid_required": "Enter a UID number.",
          "zip_required": "Enter a zip number."
        },
        "existing_credit_card": "Existing credit card: •••• •••• •••• {last4}",
        "invoice_recipient": "Send order confirmation to",
        "no_company_name": "Enter the company name.",
        "no_payment_method_defined_yet": "No payment method defined yet",
        "payment_method": "Payment method",
        "payment_method_creation_server_error": "There was an error saving your payment method. Contact our support.",
        "payment_method_owner": "Name on credit card",
        "save_subscription": "Save",
        "sepa": "SEPA Direct Debit",
        "street": "Address",
        "uid": "UID-Number",
        "uid_not_valid": "Your VAT number is not valid. Check it again or contact our support if you need the VAT number on your invoice",
        "zip": "ZIP"
      },
      "company_wide_account": {
        "info": "Your user account is included in the company plan of <strong>{'@'}{domain}</strong>.",
        "support_link": "If you have questions regarding the billing contact our accounting via <a href=\"mailto:buchhaltung{'@'}planfred.com?subject=Company billing: {'@'}{domain}\">buchhaltung{'@'}planfred.com</a>."
      },
      "delete_account": {
        "account_cannot_be_deleted": "Your user account cannot be deleted yet!",
        "close_account_deletion": "Close account deletion",
        "delete_account": "Delete account",
        "delete_account_forever": "Permanently delete user account",
        "delete_error": "An error occurred while deleting the account!",
        "enter_delete_to_confirm": "Confirm the deletion by entering the word 'delete'",
        "goto_project_settings": "Project settings",
        "header_can_not_delete_account": "Your user account cannot be deleted yet",
        "leave_projects_participating": "Leave selected projects",
        "project_cancellation_request_sent": "The selected project owners have been notified. Once you have been removed from a project it will no longer appear in this list.",
        "projects_owning_view_header": "You still have your own projects",
        "projects_owning_view_message": "Archive and delete your own projects in the respective project settings.",
        "projects_participating_view_header": "You are still participating in projects",
        "projects_participating_view_message": "Select all the projects you want to leave so that we can notify the respective project owners.",
        "send_error": "An error occurred while sending project cancellation!",
        "to_projectlist": "To project list",
        "warning_delete_projects": "Before you can delete your user account you have to delete your own projects!"
      },
      "plan_selection": {
        "approval_system": "Approval system",
        "backup_app": "Backup-app",
        "billing_method": {
          "annually": "Annual billing",
          "annually_hint": "1 month for free with annual billing!",
          "monthly": "Monthly billing"
        },
        "cancel_plan": "Quit plan",
        "cancel_plan_message_label": "Help us so that we can improve PLANFRED:",
        "cancel_unsubscribe": "Revoke plan cancellation",
        "document_vault": "Document access permission",
        "documents": "Documents feature",
        "email_support": "Email support",
        "fair_use_text": "The Fair Use Threshold for usage on 'Unlimited' storage space is 1TB",
        "free": {
          "for_free": "FREE",
          "free": "free",
          "no_own_projects": "0 own projects, ONLY project participations",
          "price": "€ 0"
        },
        "in_app_support": "InApp consulting via Screensharing",
        "is_enterprise_contract": "This server is an enterprise server.",
        "maxi": {
          "maxi": "Maxi",
          "price_per_month": "€ 235",
          "price_per_year": "€ 2,585"
        },
        "message_testphase_end": "You can then continue your projects seamlessly!",
        "midi": {
          "midi": "Midi",
          "price_per_month": "€ 75",
          "price_per_year": " € 825",
          "storage_space_v1": "30 GB Storage space",
          "storage_space_v2": "30 GB Storage space"
        },
        "mini": {
          "mini": "Mini",
          "price_per_month": "€ 25",
          "price_per_year": "€ 275",
          "projects": "1 Project",
          "storage_space_v1": "5 GB Storage space",
          "storage_space_v2": "5 GB Storage space"
        },
        "no_comment": "No comment",
        "not_selectable": "Not selectable",
        "not_suitable": "Not suitable for me",
        "online_course": "Online training",
        "package_selection": "Plan selection",
        "per_month": "Monthly",
        "per_year": "Annually",
        "personal_consultant": "Personal contact with 20 years of construction project experience",
        "phone_support": "Phone support <nobr>for all users</nobr>",
        "photolog": "Photo documentation",
        "plans": "Plans feature",
        "please_contact_support_message": "If you have any questions about the contract, contact buchhaltung{'@'}planfred.com",
        "prime": {
          "price_per_month": "€ 385",
          "price_per_year": "€ 4,235",
          "prime": "Prime"
        },
        "project_completed": "Project is completed",
        "project_support": "Project organization support",
        "tasks": "Tasks feature",
        "tax": "All prices are plus statutory VAT.",
        "trial_period_ended": "Your PLANFRED test phase ended {date}!",
        "trial_period_ends": "Your PLANFRED test phase ends {date}!",
        "unlimited_admin": "Admins unlimited",
        "unlimited_projects": "Projects unlimited",
        "unlimited_storage": "Storage space unlimited<sup>1)</sup>",
        "unlimited_user": "Users unlimited",
        "unsubscribe_button_anually": "Quit plan",
        "unsubscribe_button_monthly": "Quit plan with {unsubscribeDate}",
        "unsubscribe_message_annually": "You have quitted your plan – our support will contact you soon!",
        "unsubscribe_message_monthly": "You canceled your plan with deadline {unsubscribeDate}!"
      },
      "projects_participating": {
        "info_unlimited": "Participating projects are unlimited and free.",
        "project_count": "Projects",
        "projects_participating": "Participating projects"
      },
      "projects_user": {
        "midi_storage_15": "You have exceeded the storage limit of 15 GB",
        "midi_storage_25": "You have exceeded the storage limit of 25 GB",
        "midi_storage_30": "You have exceeded the storage limit of 30 GB",
        "mini_projects": "You only have one project included in your MINI plan.",
        "mini_storage_1": "You have exceeded the limit of 1 GB",
        "mini_storage_5": "You have exceeded the limit of 5 GB",
        "mini_storage_projects": "You have exceeded the storage limit of 1 GB and more than 1 project",
        "my_projects": "my projects",
        "of": "of",
        "project_count": "Projects",
        "projects_participated": "Project participations",
        "projects_user_title": "My projects",
        "to_projectlist": "To project list",
        "upgrade_package": "Upgrade plan",
        "upgrade_title": "Plan upgrade recommended",
        "used_storage": "Storage space"
      },
      "switch_language": "Switch language",
      "title": "Account",
      "trial_period_banner": {
        "choose_plan": "Select plan",
        "continue_working_if_plan_selected": "If you would like to order PLANFRED, select the desired plan (MINI, MIDI, MAXI or PRIME). This enables you to continue working on your projects seamlessly.",
        "extend_test_phase": "Extend test phase?",
        "trial_period_ended": "Your PLANFRED test phase ended {date}!",
        "trial_period_ends": "Your PLANFRED test phase ends {date}!"
      },
      "user_data": {
        "change_user_company": "Edit user company",
        "change_user_data": "Edit user profile",
        "change_user_name": "Edit user name",
        "company": "Company",
        "company_placeholder": "Construction Inc",
        "email": "Email address",
        "email_placeholder": "alex.smith{'@'}construction-inc.com",
        "error": {
          "company_required": "Enter a company.",
          "email_cant_be_changed": "The email address cannot be changed!",
          "first_name_required": "Enter a firstname.",
          "last_name_required": "Enter a lastname.",
          "save_error": "An error occurred while saving!"
        },
        "first_name": "First Name",
        "first_name_placeholder": "Alex",
        "last_name": "Last Name",
        "last_name_placeholder": "Smith",
        "name": "Name",
        "user_account": "User account",
        "user_data": "User data"
      },
      "user_security": {
        "change_password": "Change password",
        "error": {
          "password_required": "Enter a password.",
          "recovery_code_required": "Enter your recovery code.",
          "save_error": "An error occurred while saving!",
          "save_error_old_password_invalid": "Your current password is invalid.",
          "two_factor_code_required": "Enter your authenticator code."
        },
        "new_password_label": "New password:",
        "old_password_label": "Current password:",
        "password_label": "Password:",
        "security": "Account security"
      },
      "user_signature": {
        "allowed_upload_file_types": "Only .jpeg, .jpg, and .png files are supported.",
        "change_signature": "Change signature",
        "create_signature": "Create signature template",
        "file_upload_error": "There was an error uploading the file. \nTry again.",
        "image_file_size_upload_error": "Signature image are limited to 100kb filesize in order to keep your emails loading fast.",
        "info_signature_image": "Add your logo to your signature (Permitted file formats: .jpg or .png, size limited to 100Kb). Just click on the paper clip icon at the top.",
        "signature": "Signature"
      },
      "user_two_factor_authentication": {
        "disable": "Deactivate Two-factor authentication",
        "label": "Two-factor authentication",
        "message_activated": "Two-factor authentication is enabled.",
        "message_deactivated": "Two-factor authentication is disabled.",
        "off": "Off",
        "on": "On",
        "password_invalid": "Invalid password",
        "provide_password": "Please provide your password",
        "request": "Activate Two-factor authentication",
        "disable_warning_projects_require_2fa": "You are participating in projects that require two-factor authentication. If you deactivate it, you will lose access to these projects:"
      }
    },
    "activities": {
      "activities_loading": "Activities loading ...",
      "activity_detail": "Activity detail",
      "category_selector": {
        "all": "All",
        "approval": "Review",
        "category": "Category",
        "downloads": "Download",
        "other": "Other",
        "photos": "Photos",
        "receive": "Receiving",
        "sent": "Sent",
        "tasks": "Tasks",
        "uploads": "Upload"
      },
      "filter_participant_role": "Filter \"Participant/Role\"",
      "index": "Index",
      "list_header_description": "Description",
      "list_header_time": "Date/Time",
      "list_header_type": "Type",
      "loading": "Loading …",
      "loading_error": "ERROR",
      "no_activities_for_participant_message": "There are currently no activities by those participants.",
      "no_activities_found": "There are no activities in the selected time period.",
      "no_activities_found_with_filter": "No activities with the current filter could be found in this time period.",
      "participant_role": "Participants/Roles",
      "plans_documents": "Plans/Documents",
      "print": {
        "activities_list": "Activities",
        "amount": "Amount:",
        "categories": "Categories:",
        "category": "Category:",
        "date_from_to": "{startDate} - {endDate}",
        "multiple_activities": "{activitiesLength} Activities",
        "one_activity": "1 Activity",
        "participant": "Participants:",
        "period": "Time Period:",
        "print_overlay_is_being_prepared": "Preparing list of activities print … {renderedItemsLength} / {allItemsLength}",
        "role": "Role:"
      },
      "print_list": "Print list of activities",
      "range_picker": {
        "period": "Time Period",
        "project_start": "Project start",
        "today": "Today",
        "x_days": "{x} Days"
      },
      "render_error": "This activity cannot be displayed.",
      "renderer": {
        "get_approval_comment_attachment": {
          "has_downloaded": "{participant} has received the comment attachment {attachmentName} of plan {planLink}.",
          "has_downloaded_first_download": "{participant} has received the comment attachment {attachmentName} of plan {planLink} for the first time.",
          "has_downloaded_latest_download": "{participant} has received the comment attachment {attachmentName} of plan {planLink} last time."
        },
        "get_document_approval_comment_attachment": {
          "has_downloaded": "{participant} has received the comment attachment {attachmentName} of document {documentLink}.",
          "has_downloaded_first_download": "{participant} has received the comment attachment {attachmentName} of document {documentLink} for the first time.",
          "has_downloaded_latest_download": "{participant} has received the comment attachment {attachmentName} of document {documentLink} last time."
        },
        "get_document_revision": {
          "has_downloaded": "{participant} has received the file {fileName} of document {documentLink}.",
          "has_downloaded_first_download": "{participant} has received the file {fileName} of document {documentLink} for the first time.",
          "has_downloaded_latest_download": "{participant} has received the file {fileName} of document {documentLink} last time."
        },
        "get_plan_revision_dwg": {
          "has_downloaded_plan": "{participant} has received the CAD file {fileName} of plan {planLink}.",
          "has_downloaded_plan_first_download": "{participant} has received the CAD file {fileName} of plan {planLink} for the first time.",
          "has_downloaded_plan_latest_download": "{participant} has received the CAD file {fileName} of plan {planLink} last time."
        },
        "get_plan_revision_pdf": {
          "has_downloaded_plan": "{participant} has received the print file {fileName} of plan {planLink}.",
          "has_downloaded_plan_first_download": "{participant} has received the print file {fileName} of plan {planLink} for the first time.",
          "has_downloaded_plan_latest_download": "{participant} has received the print file {fileName} of plan {planLink} last time."
        },
        "patch_document_author": {
          "has_changed_author": "{participant} has changed the author of the document {documentLink} from {authorParticipantOld} to {authorParticipantNew}."
        },
        "patch_document_permission": {
          "administrators": "Administrators",
          "creator": "Author",
          "has_changed_from_public_to_restricted": "{participant} has changed the access permission for the document {documentLink} from PUBLIC to VISIBLE only for {restrictedParticipants}.",
          "has_changed_from_restricted_to_public": "{participant} has changed the access permission for the document {documentLink} from VISIBLE only for {restrictedParticipants} to PUBLIC.",
          "has_changed_from_restricted_to_restricted": "{participant} has changed the access permission for the document {documentLink} from VISIBLE only for {restrictedParticipantsOld} to VISIBLE only for {restrictedParticipantsNew}."
        },
        "patch_document_permission_download_link": {
          "has_disabled": "{changerParticipant} has disabled {targetParticipant}'s download link for {documentLink}.",
          "has_enabled": "{changerParticipant} has activated the download link from {targetParticipant} for {documentLink}."
        },
        "patch_document_revision_approval": {
          "approval_cancelled": "This document review has been revoked.",
          "approval_done": "This document review is finished now!",
          "approval_not_done": "This document review is not finished yet!",
          "has_changed_approval": "{participant} has changed review in document {documentLink} for the revision {documentLinkRevision}.",
          "revision_approved": "This document version is approved!",
          "revision_not_approved": "This document version is NOT approved!"
        },
        "patch_document_revision_approval_date": {
          "has_changed_approval_date": "{participant} has changed the review date in document {documentLink} for the revision {documentLinkRevision} from {oldApprovalDate} to {newApprovalDate}.",
          "has_changed_approval_date_short": "{participant} has changed the review date from {oldApprovalDate} to {newApprovalDate}.",
          "has_introduced_approval_date": "{participant} has set the review date in document {documentLink} for the revision {documentLinkRevision} to {newApprovalDate}.",
          "has_introduced_approval_date_short": "{participant} has set the review date to {newApprovalDate}.",
          "has_removed_approval_date": "{participant} has removed the review date in document {documentLink} for the revision {documentLinkRevision}.",
          "has_removed_approval_date_short": "{participant} has removed the review date."
        },
        "patch_document_top_categories_enabled": {
          "has_disabled_top_categories": "{participant} has disabled document top categories.",
          "has_enabled_top_categories": "{participant} has enabled documents top categories. "
        },
        "patch_document_top_category": {
          "has_changed_category": "{participant} has changed the top category for {documentLink} from {oldCategory} to {newCategory}."
        },
        "patch_document_trash": {
          "has_deleted_document": "{participant} has deleted the document {documentLink}.",
          "has_restored_document": "{participant} has restored the document {documentLink}."
        },
        "patch_documents_tagging_restricted_for_users": {
          "has_disabled_documents_tagging_restricted_for_users": "{participant} has issued project participants the right to create document tags.",
          "has_enabled_documents_tagging_restricted_for_users": "{participant} has revoked project participants the right to create document tags."
        },
        "patch_photo_album": {
          "has_changed_album": "{participant} has changed the photo album for photo {photoLink} from {oldAlbum} to {newAlbum}."
        },
        "patch_photo_author": {
          "has_changed_author": "{participant} has changed the author of the photo {photoLink} from {authorParticipantOld} to {authorParticipantNew}."
        },
        "patch_photo_description": {
          "has_changed_description": "{participant} has modified the description of photo {photoLink}.",
          "has_added_description": "{participant} has added a description to photo {photoLink}.",
          "has_removed_description": "{participant} has removed the description of photo {photoLink}."
        },
        "patch_photo_file": {
          "has_updated_file": "{participant} has annotated the photo {photoLink}."
        },
        "patch_photo_location": {
          "has_changed_location": "{participant} has changed the following locatization properties of the photo {photoLink}:",
          "has_introduced_location": "{participant} has added a location to the photo {photoLink}.",
          "has_removed_location": "{participant} has removed the location of photo {photoLink}."
        },
        "patch_photo_location_pin_position": {
          "has_changed_position": "{participant} changed the position of pin {pinId} in the photo {photoLink}."
        },
        "patch_photo_title": {
          "has_changed_title": "{participant} has changed the title of photo {photoLink} from „{oldTitle}“ to„ {newTitle}“.",
          "has_introduced_title": "{participant} has added the title „{newTitle}“ to photo {photoLink}.",
          "has_removed_title": "{participant} has removed the title of photo {photoLink}."
        },
        "patch_photo_trashed": {
          "has_deleted_photo": "{participant} has DELETED the photo {photoLink}.",
          "has_restored_photo": "{participant} has RESTORED the photo {photoLink}."
        },
        "patch_plan_author": {
          "has_changed_author": "{participant} has changed the author of the plan {planLink} from {authorParticipantOld} to {authorParticipantNew}."
        },
        "patch_plan_revision_approval": {
          "approval_cancelled": "This Plan review has been revoked.",
          "approval_done": "This plan review is finished now!",
          "approval_not_done": "This plan review is not finished yet!",
          "has_changed_approval": "{participant} has changed review in plan {planLink} for the revision {planLinkRevision.",
          "revision_approved": "This plan index is approved!",
          "revision_not_approved": "This plan index is NOT approved!"
        },
        "patch_plan_revision_approval_date": {
          "has_changed_approval_date": "{participant} has changed the review date in plan {planLink} for the revision {planLinkRevision} from {oldApprovalDate} to {newApprovalDate}.",
          "has_changed_approval_date_short": "{participant} has changed the review date from {oldApprovalDate} to {newApprovalDate}.",
          "has_introduced_approval_date": "{participant} has introduced a review date in plan {planLink} for the revision {planLinkRevision} to {newApprovalDate}.",
          "has_introduced_approval_date_short": "{participant} has introduced a review date to {newApprovalDate}.",
          "has_removed_approval_date": "{participant} has removed the review date in plan {planLink} for the revision {planLinkRevision}.",
          "has_removed_approval_date_short": "{participant} has removed the review date."
        },
        "patch_plan_top_categories_enabled": {
          "has_disabled_top_categories": "{participant} has disabled plan top categories.",
          "has_enabled_top_categories": "{participant} has enabled plans top categories."
        },
        "patch_plan_top_category": {
          "has_changed_category": "{participant} has changed the top category for {planLink} from {oldCategory} to {newCategory}."
        },
        "patch_plan_trash": {
          "has_deleted_plan": "{participant} has deleted the plan {planLink}.",
          "has_restored_plan": "{participant} has restored the plan {planLink}."
        },
        "patch_plans_tagging_restricted_for_users": {
          "has_disabled_plans_tagging_restricted_for_users": "{participant} has issued project participants the right to create plan tags.",
          "has_enabled_plans_tagging_restricted_for_users": "{participant} has revoked project participants the right to create plan tags."
        },
        "patch_project_two_factor_auth_required": {
          "enabled": "{participant} has enabled two-factor authentication requirement for this project.",
          "disabled": "{participant} has disabled two-factor authentication requirement for this project."
        },
        "patch_project_location_is_enabled": {
          "disabled_location_property": "{participant} has activated the location property „{locationLabel}“.",
          "enabled_location_property": "{participant} has deactivated the location property „{locationLabel}“."
        },
        "patch_project_location_label": {
          "did_rename": "{participant} has changed the label of the location property „{oldLocationLabel}“ to „{newLocationLabel}“."
        },
        "patch_task_assignee_user_id": {
          "has_changed_assignee": "{participant} has assigned the task {taskLink} to {newAssigneeParticipant}.",
          "has_changed_assignee_to_unknown": "{participant} has assigned the task {taskLink} to another participant."
        },
        "patch_task_comment_files": {
          "has_deleted_files": "{participant} has removed all files of a comment in the task {taskLink}.",
          "has_updated_files": "{participant} has updated the files of a comment in the task {taskLink}."
        },
        "patch_task_comment_message": {
          "has_changed_comment": "{participant} has modified a comment in the task {taskLink}."
        },
        "patch_task_description": {
          "has_changed_description": "{participant} has modified the description of task {taskLink}.",
          "has_added_description": "{participant} has added a description to task {taskLink}.",
          "has_removed_description": "{participant} has removed the description of task {taskLink}."
        },
        "patch_task_due_date": {
          "has_changed_date": "{participant} has changed the due date for task {taskLink} from {oldDueDate} to {newDueDate}.",
          "has_introduced_date": "{participant} has added the due date for task {taskLink} to {newDueDate}.",
          "has_removed_date": "{participant} has removed the due date from task {taskLink}."
        },
        "patch_task_files": {
          "has_deleted_files": "{participant} has removed all files of the task {taskLink}.",
          "has_deleted_files_task_detail_page": "All files removed by {participant}.",
          "has_updated_files": "{participant} has updated the files of the task {taskLink}."
        },
        "patch_task_location": {
          "has_changed_location": "{participant} has changed the following locatization properties of the task {taskLink}:",
          "has_introduced_location": "{participant} has added a location to the task {taskLink}.",
          "has_removed_location": "{participant} has removed the location of task {taskLink}."
        },
        "patch_task_location_pin_position": {
          "has_changed_position": "{participant} changed the position of pin {pinId} in the task {taskLink}."
        },
        "patch_task_title": {
          "has_changed_title": "{participant} has changed the title of task {taskLink} from „{oldTitle}“ to„ {newTitle}“.",
          "has_introduced_title": "{participant} has added the title „{newTitle}“ to task {taskLink}.",
          "has_removed_title": "{participant} has removed the title of task {taskLink}."
        },
        "patch_task_trashed": {
          "has_deleted_task": "{participant} has DELETED the task {taskLink}.",
          "has_restored_task": "{participant} has RESTORED the task {taskLink}."
        },
        "patch_task_type": {
          "has_changed_type": "{participant} has changed the task category for task {taskLink} from {oldType} to {newType}."
        },
        "post_approval": {
          "has_requested_approval": "{participant} has requested review in plan {planLink} for the revision {planLinkRevision}."
        },
        "post_approval_comment": {
          "has_added_correction": "{participant} has attached a comment to the review in revision {planLinkRevision} in plan {planLink}."
        },
        "post_document": {
          "has_created_document": "{participant} has created the document {documentLink}.",
          "has_created_document_via_import": "{participant} has created the document {documentLink} via import."
        },
        "post_document_approval": {
          "has_requested_approval": "{participant} has requested review in document {documentLink} for the version {documentLinkRevision}."
        },
        "post_document_approval_comment": {
          "has_added_correction": "{participant} has attached a comment to the review in version {documentLinkRevision} in document {documentLink}."
        },
        "post_document_revision": {
          "has_uploaded_index": "{participant} has uploaded the new document version {documentLink}.",
          "has_uploaded_index_via_import": "{participant} has uploaded the new document version {documentLink} via import."
        },
        "post_document_tag": {
          "has_changed_tags": "{participant} has changed the tags of document {documentLink}: {diff}"
        },
        "post_photo": {
          "has_created_photo": "{participant} has created the photo {photoLink}."
        },
        "post_photo_tag": {
          "has_changed_tags": "{participant} has changed the tags of photo {photoLink}: {diff}"
        },
        "post_plan": {
          "has_created_plan": "{participant} has created the plan {planLink}.",
          "has_created_plan_via_import": "{participant} has created the plan {planLink} via import."
        },
        "post_plan_revision": {
          "has_uploaded_index": "{participant} has uploaded the new plan index {planLink}.",
          "has_uploaded_index_via_import": "{participant} has uploaded the new plan index {planLink} via import."
        },
        "post_plan_tag": {
          "has_changed_tags": "{participant} has changed the tags of plan {planLink}: {diff}"
        },
        "post_project": {
          "has_created_project": "{participant} created this project."
        },
        "post_project_invitation": {
          "added": "{changerParticipant} has added {addedParticipant} to project.",
          "added_participant": "{changerParticipant} has added {addedParticipant} as a participant with project access.",
          "added_participant_admin": "{changerParticipant} has added {addedParticipant} as admin.",
          "added_participant_silent": "{changerParticipant} has added {addedParticipant} as an external participant without project access."
        },
        "post_task_comment": {
          "has_added_comment": "{participant} has added a comment to the task {taskLink}.",
          "has_added_comment_and_changed_state": "{participant} has added a comment to the task {taskLink} and updated the state from „{stateOld}“ to „{stateNew}“."
        },
        "post_task_published": {
          "has_published_task": "{participant} has PUBLISHED task {taskLink}. Note: Automatic email notification to the assignee at the next full hour."
        },
        "post_task_tag": {
          "has_changed_tags": "{participant} has changed the tags of task {taskLink}: {diff}"
        },
        "put_approve_document_revision": {
          "approval_not_done": "This review is not finished yet!",
          "has_approved": "{participant} has approved the document {documentLink}.",
          "has_rejected": "{participant} has commented the document {documentLink}.",
          "revision_approved": "This document version is approved!",
          "revision_not_approved": "This document version is NOT approved!"
        },
        "put_approve_plan_revision": {
          "approval_not_done": "This review is not finished yet!",
          "has_approved": "{participant} has approved the plan {planLink}.",
          "has_rejected": "{participant} has commented the plan {planLink}.",
          "revision_approved": "This plan index is approved!",
          "revision_not_approved": "This plan index is NOT approved!"
        },
        "put_document_name": {
          "has_changed_name": "{participant} has renamed the document {oldDocumentName} to {documentLink}.",
          "has_changed_name_by_planfred_migration": "PLANFRED has renamed the document {oldDocumentName} in course of a data migration to {documentLink}. Document numbers now have to be unique within a project - same as for plan numbers."
        },
        "put_document_phase": {
          "has_changed_phase": "{participant} has changed the document folder for {documentLink} from {oldPhasetag} to {newPhasetag}."
        },
        "put_participant_address": {
          "has_changed_address": "{changerParticipant} has changed the participant’s {targetParticipant} address to {newAddress}.",
          "has_removed_address": "{changerParticipant} has deleted the address of the participant {targetParticipant}."
        },
        "put_participant_company": {
          "has_changed_company": "{changerParticipant} has changed the participant’s {targetParticipant} company to {newCompany}."
        },
        "put_participant_name": {
          "has_changed_name": "{changerParticipant} has changed the name of the participant {targetParticipant}."
        },
        "put_participant_phone": {
          "has_changed_phone": "{changerParticipant} has changed the participant’s {targetParticipant} telephone number to {newPhone}.",
          "has_removed_phone": "{changerParticipant} has deleted the telephone number of the participant {targetParticipant}."
        },
        "put_participant_role": {
          "has_changed_role": "{changerParticipant} has changed the role of the participant {targetParticipant} to {newRole}.",
          "has_removed_role": "{changerParticipant} has deleted the role of the participant {targetParticipant}."
        },
        "put_participant_update_alert_status": {
          "activated": "{changerParticipant} has activated the upload notifier of the participant {targetParticipant} in this project (Interval: {interval}).",
          "changed_interval": "{changerParticipant} has changed the interval of the upload notifier of participant {targetParticipant} in this project from {oldInterval} to {newInterval}.",
          "deactivated": "{changerParticipant} has deactivated the upload notifier of the participant {targetParticipant} in this project.",
          "self_activated": "{changerParticipant} has activated the own upload notifier in this project (Interval: {interval}).",
          "self_changed_interval": "{changerParticipant} has changed the interval of the own upload notifier in this project from {oldInterval} to {newInterval}.",
          "self_deactivated": "{changerParticipant} has deactivated the own upload notifier in this project."
        },
        "put_plan_name": {
          "has_changed_name": "{participant} has renamed the plan {oldPlanName} to {planLink}.",
          "has_changed_name_by_planfred_migration": "PLANFRED has renamed the plan {oldPlanName} in course of a data migration to {planLink}. Plan numbers have to be unique within a project."
        },
        "put_plan_phase": {
          "has_changed_phase": "{participant} has changed the plan folder for {planLink} from {oldPhasetag} to {newPhasetag}."
        },
        "patch_company_take_ownership": {
          "has_taken_ownership": "{newOwner} took over ownership of this project from {previousOwner} as company admin."
        },
        "put_project_ownership_accept": {
          "has_accepted_transfer": "{newParticipant} has accepted the transfer of the project from {oldParticipant} and is now the new project owner."
        },
        "put_project_participant_can_approve_revisions": {
          "has_disabled": "{changerParticipant} has revoked {targetParticipant} permission for plan review.",
          "has_enabled": "{changerParticipant} has issued {targetParticipant} permission for plan review."
        },
        "put_project_participant_enabled": {
          "has_disabled": "{changerParticipant} has locked {targetParticipant} for this project.",
          "has_enabled": "{changerParticipant} has unlocked {targetParticipant} for this project."
        },
        "put_project_participant_permission": {
          "has_changed_permission_to_admin": "{changerParticipant} has changed the participant status from {targetParticipant} to project administrator.",
          "has_changed_permission_to_participant": "{changerParticipant} has changed the participant status from {targetParticipant} to project participant.",
          "has_changed_permission_to_silent": "{changerParticipant} has changed the participant status from {targetParticipant} to participant without login."
        },
        "put_project_title": {
          "has_changed_title": "{participant} has changed the project title to {projectTitle}."
        },
        "send_mixed": {
          "documents": {
            "document": "the document {documentLinks}",
            "documents": "{documentCountLink}",
            "print_documents": "the documents {documentLinks}",
            "x_documents": "{documentCount} documents"
          },
          "plans": {
            "plan": "sent the plan {planLinks}",
            "plan_pdf": "only sent the print file of the plan {planLinks}",
            "plans": "sent {planCountLink}",
            "plans_pdf": "only sent the print file of the plans {planCountLinkDative}",
            "print_plans": "sent the plans {planLinks}",
            "print_plans_pdf": "only sent the print file of the plans {planLinks}",
            "x_plans": "{planCount} plans",
            "x_plans_dative": "{planCount} plans"
          },
          "sent_documents_to_person": "{senderParticipant} has {documentsTranslation} to the following person: {receiverParticipants}",
          "sent_documents_to_persons": "{senderParticipant} has {documentsTranslation} to the following persons: {receiverParticipants}",
          "sent_plans_and_documents_to_person": "{senderParticipant} has {plansTranslation} and {documentsTranslation} to the following person: {receiverParticipants}",
          "sent_plans_and_documents_to_persons": "{senderParticipant} has {plansTranslation} and {documentsTranslation} to the following persons: {receiverParticipants}",
          "sent_plans_to_person": "{senderParticipant} has {plansTranslation} to the following person: {receiverParticipants}",
          "sent_plans_to_persons": "{senderParticipant} has {plansTranslation} to the following persons: {receiverParticipants}"
        },
        "send_revision_doc": {
          "print_sent_documents_to_person": "{senderParticipant} has sent the documents {documentLinks} to the following person: {receiverParticipants}",
          "print_sent_documents_to_persons": "{senderParticipant} has sent the documents {documentLinks} to the following persons: {receiverParticipants}",
          "sent_document_to_person": "{senderParticipant} has sent the document {documentLinks} to the following person: {receiverParticipants}",
          "sent_document_to_persons": "{senderParticipant} has sent the document {documentLinks} to the following persons: {receiverParticipants}",
          "sent_documents_to_person": "{senderParticipant} has sent {documentCountLink} to the following person: {receiverParticipants}",
          "sent_documents_to_persons": "{senderParticipant} has sent {documentCountLink} to the following persons: {receiverParticipants}",
          "x_documents": "{documentCount} documents"
        },
        "send_revision_plan": {
          "print_sent_plans_pdf_to_person": "{senderParticipant} has sent only the print files for the plans {planLinks} to the following person: {receiverParticipants}",
          "print_sent_plans_pdf_to_persons": "{senderParticipant} has sent only the print files for the plans {planLinks} to the following persons: {receiverParticipants}",
          "print_sent_plans_to_person": "{senderParticipant} has sent the plans {planLinks} to the following person: {receiverParticipants}",
          "print_sent_plans_to_persons": "{senderParticipant} has sent the plans {planLinks} to the following persons: {receiverParticipants}",
          "sent_plan_pdf_to_person": "{senderParticipant} has only sent the print file of the plan {planLinks} to the following person: {receiverParticipants}",
          "sent_plan_pdf_to_persons": "{senderParticipant} has only sent the print file of the plan {planLinks} to the following persons: {receiverParticipants}",
          "sent_plan_to_person": "{senderParticipant} has sent the plan {planLinks} to the following person: {receiverParticipants}",
          "sent_plan_to_persons": "{senderParticipant} has sent the plan {planLinks} to the following persons: {receiverParticipants}",
          "sent_plans_pdf_to_person": "{senderParticipant} has sent only the print files for {planCountLink} to the following person: {receiverParticipants}",
          "sent_plans_pdf_to_persons": "{senderParticipant} has sent only the print files for {planCountLink} to the following persons: {receiverParticipants}",
          "sent_plans_to_person": "{senderParticipant} has sent {planCountLink} to the following person: {receiverParticipants}",
          "sent_plans_to_persons": "{senderParticipant} has sent {planCountLink} to the following persons: {receiverParticipants}",
          "x_plans": "{planCount} plans",
          "x_plans_dative": "{planCount} plans"
        },
        "send_project_invitation": {
          "has_invited": "{changerParticipant} has sent a project invitation by email to {addedParticipant}.",
          "has_reinvited": "{changerParticipant} has sent another project invitation by email to {addedParticipant}."
        },
        "send_task_reminder": {
          "has_sent_reminder": "{participant} has sent a reminder to {assigneeParticipant}.",
          "has_sent_reminder_for_task": "{participant} has sent a reminder for task {taskLink} to {assigneeParticipant}."
        }
      },
      "resend": {
        "document": {
          "multiple": "Send or download these documents",
          "single": "Send or download this document"
        },
        "plan": {
          "multiple": "Send or download these plans",
          "single": "Send or download this plan"
        }
      },
      "search_hits_multiple": "{x} activities",
      "search_hits_one": "1 activity",
      "send_detail": {
        "activities_load_error": "Send and download status could not be loaded",
        "activities_update_error": "Send and download status could not be updated",
        "only_pdf": "Only PRINT-FILES sent",
        "sent_document_revisions": "Sent documents:",
        "sent_plan_revisions": "Sent plans:",
        "sent_to": "Sent to:",
        "show_recipients_list": "Recipients list is shown in email",
        "table_participants": {
          "bounced_message": "The email was rejected by the recipient's mail server.",
          "delivered": "Delivered",
          "downloaded": "Downloaded",
          "processing": "In delivery",
          "send_failed": "Not delivered",
          "send_failed_message": "Sending the email failed.",
          "status": "Status",
          "undeliverable": "Undeliverable",
          "unknown": "Unknown",
          "unknown_message": "There is no delivery confirmation for this email. Whether it was delivered is unknown."
        },
        "upload": "Upload"
      },
      "sent_message": "Sent message:",
      "sent_message_not_provided": "No message sent.",
      "show": "Show",
      "show_all_activities": "Show all activities in the selected time period",
      "unknown_participant": "PLANFRED",
      "version": "Version"
    },
    "agb": {
      "accept_agb_before_getting_owner": "You have to accept our T&Cs and GDPR in order to be able to become a project owner!",
      "confirm": "confirm",
      "confirm_server_error": "The confirmation could not be sent – try again.",
      "i_accept_terms": "I have read and agree to the",
      "i_read_privacy_policy": "I have read and agree to the",
      "jump_to_privacy_policy": "terms and conditions",
      "jump_to_terms": "privacy policy",
      "modal": {
        "cancel": "I don’t want to use PLANFRED",
        "dear_user": "Dear PLANFRED user,",
        "dsgvo_image_alt": "Label „GDPR-conform“",
        "dsgvo_image_path": src/assets/img/badge-eu-dsgvo_en.svg",
        "may_we_have_your_attention": "May we have your attention briefly to discuss the GDPR?",
        "new_dsgvo_since_2018": "On 25 May, 2018 the European General Data Protection Regulation (GDPR) entered into force.",
        "planfred_supports_dsgvo_since_ever": "PLANFRED has practically supported its fundamental principles since the beginning, and naturally, we are also obligated to make adjustments to our contracts.",
        "please_confirm": "On the basis of the GDPR, we have updated the following documents in terms of legal data protection and request you to confirm them:",
        "submit": "Continue as usual",
        "submit_server_error": "Sorry, an error occurred – try again."
      },
      "please_accept_privacy_policy": "Confirm our data protection provisions",
      "please_accept_terms": "Accept our general terms and conditions"
    },
    "auth": {
      "app_promotion_text": "Get the PLANFRED App!",
      "back_to_login": "back to login",
      "check_spam_folder": "If you do not receive an email within the next two minutes, check your spam folder.",
      "check_your_mailbox": "Check your inbox!",
      "confirm": {
        "error_token_invalid": "The activations token for the email '{email}' is invalid.",
        "error_token_invalid_sent_mail": "We have sent you a new activation link at '{email}'.",
        "form": {
          "submit_label": "Create password",
          "submit_label_subline": "and activate user account"
        },
        "headline_activate_account": "Activate User Account",
        "headline_link_expired": "The activation link is invalid.",
        "subline_new_email": "New email in your inbox!"
      },
      "email_address": "Email address",
      "error_password_validation": "Your password must be at least min. 8 characters long!",
      "forgot_password": {
        "enter_email": "Simply enter your email address so that we may send you instructions on changing your password.",
        "error": "Check your email address and try again.",
        "form": {
          "email_error_required": "Complete this field.",
          "submit_label": "Request new password"
        },
        "headline_forgot_password": "Forgot password?",
        "mail_sent_to_create_pwd": "We have sent you instructions for changing your password at '{email}'"
      },
      "forgot_password_confirm": {
        "create_your_pwd_here": "You may create a new password for your user account here.",
        "error_token_invalid_sent_mail": "We have sent you a new reset link at '{email}'.",
        "form": {
          "submit_label": "Create new password"
        },
        "headline_create_pwd": "Create new password",
        "headline_link_expired": "The password link is invalid."
      },
      "login": {
        "demoproject_will_be_opened": "Opening demo server …",
        "forgot_password": "Forgot password?",
        "form": {
          "general_server_error": "An error occurred while logging in. Try again later!",
          "password_label": "Password:",
          "submit_error_invalid_credentials_explanation": "Check your email and password and try again.",
          "submit_error_login_failed": "Login failed",
          "submit_error_rate_limited": "Too many attempts",
          "submit_error_rate_limited_explanation": "Please wait a few minutes and try again.",
          "submit_error_rate_limited_explanation_minutes": "Please wait about {minutes} min and try again.",
          "submit_label": "Login"
        },
        "headline_login": "Login",
        "need_help": "Need help?",
        "no_account_yet": "Don't have an account?",
        "no_login_yet": "No login yet?",
        "no_two_factor_device": "No 2-factor device available?",
        "register_for_free": "Sign up for free",
        "session_expired_enter_credentials": "Enter email and password to continue.",
        "session_expired_error": "Your session expired!",
        "totp_form": {
          "auth_code_label": "Authentication code:",
          "recovery_code_label": "Recovery key:",
          "step1_authapp_recommendation": "Recommended auth apps: {authy}, {googleauthenticator}",
          "step1_connect_with_authapp": "1. Connect your account with an authentication app",
          "step1a_scan_qr_code": "Scan QR code with authenticator app",
          "step1b_copy_paste_code": "Paste code manually into authenticator app",
          "step2_enter_authcode": "2. Enter the 6-digit code of your authentication app",
          "subline_enter_authcode": "Enter the 6-digit code of your authentication app",
          "subline_enter_recoverycode": "Enter the 25-digit recovery key",
          "submit_error_invalid_totp_explanation": "Enter the current code.",
          "submit_error_rate_limited_explanation": "Too many code attempts. Please wait a few minutes and try again.",
          "submit_error_rate_limited_explanation_minutes": "Too many code attempts. Please wait about {minutes} min and try again.",
          "validation_error_6_digits": "The code has to contain 6 digits."
        },
        "use_recovery_code": "Use recovery key",
        "use_authenticator_code": "Use authenticator code"
      },
      "password": "Password",
      "password_input_description_with_email": "User Name: {email}",
      "password_input_label": "Password (min. length is 8 characters)",
      "please_enter_a_password": "Enter a valid password.",
      "please_enter_a_valid_email_address": "Enter a valid email address.",
      "registration": {
        "form": {
          "company_error_required": "Enter your company.",
          "company_label": "Company:",
          "email_error_required": "Enter a email address.",
          "first_name_error_required": "Enter your firstname.",
          "first_name_label": "First Name:",
          "last_name_error_required": "Enter your lastname.",
          "last_name_label": "Last Name:",
          "submit_label": "Register without obligation"
        },
        "headline_registration": "Registration",
        "no_payment_mandatory": "100% free to try. No credit card required.",
        "subline_test_30_days": "Start Your 30 Day Free Trial Today!"
      },
      "registration_sent": {
        "back_to_login": "to login",
        "check_spam_folder": "Please check your spam folder if you do not receive an email within 2 minutes.",
        "headline_registration": "Thank you for joining PLANFRED!",
        "headline_token_expired": "Activation link expired!",
        "mail_sent_new_activation_link": "The activation link used has already expired. We have sent you a new email at '{email}'.",
        "mail_sent_to_create_pwd": "We have sent a confirmation email to '{email}' with instructions to create your login.",
        "subline_new_email": "New email in your inbox!"
      },
      "request_new_password": "Request new password",
      "server_error": "An error occurred. Try again in another browser or contact our support!",
      "two_step_auth_activation": {
        "totp_invalid": "The provided code is invalid. Provide a current code again.",
        "validating": "We are validating your code …"
      }
    },
    "backup_app": {
      "createdDate": "This project backup was created on {DATE} at {TIME}."
    },
    "banner_browser_update": {
      "alternative_browser": "As alternative we recommend:",
      "description": "Install a modern browser in order to be able to use all features.",
      "download_here": "Download here:",
      "headline": "Upgrade your browser!"
    },
    "components": {
      "banner_browser_outdated": {
        "browser_is_outdated": "You have a legacy and unsafe version of Internet Explorer installed!",
        "contact_our_support": "Contact our support",
        "ie_successor": "Successor of the Internet Explorer:",
        "in_five_minuted_up_to_date": "Get up-to-date again in 5 minutes.",
        "install_new_browser": "Install one of the latest browsers to keep the seamless PLANFRED experience also for future updates.",
        "microsoft_edge": "Microsoft Edge",
        "mozilla_firefox": "Mozilla Firefox",
        "or_use_alternative": "As an alternative we recommend:",
        "still_problems": "Already upgraded but still having problems?"
      },
      "banner_demoserver": {
        "create_first_project": "Create first own project",
        "daily_reset": "All changes are reset daily. Instead you can register and work on your own project.",
        "learn_more_about_planfred": "Learn more about PLANFRED",
        "you_are_on_demoserver": "You are now using the public demo app!"
      },
      "base_date_picker": {
        "chosen_date_in_project_timezone": "Selected date in project time: {date}",
        "current_project_time": "Current project time: {date}",
        "please_select_start_and_end_date": "Select start and end date.",
        "project_timezone_different_than_local_timezone": "Attention! Your local time is different than the project time. We display the time in your local time."
      },
      "modal_changelog": {
        "load_error": "The changelog could not be loaded.",
        "retry": "Try again"
      },
      "modal_demoserver": {
        "continue_projects_after_trial": "The projects you created may be continued seamlessly following expiry of the test phase.",
        "create_first_project": "Start with your own project",
        "data_doesnt_get_deleted": "No data will be deleted automatically!",
        "free_for_30_days": "Use the full functionality for 30 days free of charge",
        "learn_more_about_planfred": "Learn more about PLANFRED",
        "many_satisfied_customers": "More than {counter} satisfied users already benefit from PLANFRED",
        "no_binding_guaranteed": "Guaranteed non-binding – NO obligation after the test phase",
        "no_installation_required": "No installation, no training – immediately available for use!",
        "start_own_project": "Start your own project right away!"
      },
      "modal_two_factor_auth_disabled": {
        "continue_without": "Continue without Two-factor authentication",
        "is_not_active": "Two-factor authentication is NOT active.",
        "reactivate": "Reactivate Two-factor authentication",
        "server_error": "Your selection could not be saved – try again."
      },
      "modal_two_factor_recovery_code": {
        "already_noted_down_recovery_code": "Key already noted",
        "click_to_copy_code": "Click to copy recovery key",
        "copied_to_clipboard": "Recovery key {recoveryCode} copied to clipboard",
        "copy_before_continue": "Before you can finish, you must copy the recovery key.",
        "copy_or_print_before_continue": "Before you can finish, you must copy or print the recovery key.",
        "copy_recovery_code": "Copy",
        "finish": "Finish",
        "follow_instructions_if_password_lost": "If you forgot your password, follow the instructions here: {forgotPasswordLink}",
        "print_recovery_code": "Print",
        "store_recovery_key": "WARNING: Store your recovery key safely!",
        "two_factor_auth_active": "Two-factor authentication is active now.",
        "use_recovery_key_is_phone_lost": "If you lost access to your Two-factor authentication device (e.g. Smartphone),<br>you can ONLY login to PLANFRED by using your recovery key."
      },
      "signature_edit": {
        "create_signature_template": "Create signature",
        "edit_header_label": "Edit signature template:",
        "edit_signature_template": "Edit signature template",
        "save_and_apply": "save",
        "server_error": "An error occurred while saving signature – try again."
      },
      "text_blocks": {
        "category": {
          "document-approval": {
            "new_textblock_title": "Text snippet for document review",
            "textblocks_list_title": "Text snippets for document review"
          },
          "document-approval-request": {
            "new_textblock_title": "Text snippet for document review request",
            "textblocks_list_title": "Text snippets for document review request"
          },
          "document-revision": {
            "new_textblock_title": "Text snippet for document upload",
            "new_textblock_titletextblocks_list_title": "Text snippets for document upload"
          },
          "document-send": {
            "new_textblock_title": "Text snippet for document dispatch",
            "textblocks_list_title": "Text snippets for document dispatch"
          },
          "invite-participant": {
            "new_textblock_title": "Text snippet for participant invitation",
            "textblocks_list_title": "Text snippets for participant invitation"
          },
          "photo-description": {
            "new_textblock_title": "Text snippet for photo description",
            "textblocks_list_title": "Text snippets for photo description"
          },
          "plan-approval": {
            "new_textblock_title": "Text snippet for plan review",
            "textblocks_list_title": "Text snippets for plan review"
          },
          "plan-approval-request": {
            "new_textblock_title": "Text snippet for plan review request",
            "textblocks_list_title": "Text snippets for plan review request"
          },
          "plan-revision": {
            "new_textblock_title": "Text snippet for plan upload",
            "new_textblock_titletextblocks_list_title": "Text snippets for plan upload"
          },
          "plan-send": {
            "new_textblock_title": "Text snippet for plan send",
            "textblocks_list_title": "Text snippets for plan send"
          },
          "task-description": {
            "new_textblock_title": "Text snippet for task description",
            "textblocks_list_title": "Text snippets for task description"
          },
          "task-new-comment": {
            "new_textblock_title": "Text snippet for task comments",
            "textblocks_list_title": "Text snippets for task comments"
          },
          "task-send": {
            "new_textblock_title": "Text snippet for task reminder",
            "textblocks_list_title": "Text snippets for task reminder"
          }
        },
        "create_text_block": "Create text snippet",
        "edit_block_abort_btn": "cancel",
        "edit_block_delete_btn": "Delete text snippet",
        "edit_block_save_btn": "save",
        "edit_block_section_title": "Edit text snippet",
        "edit_block_title_placeholder": "Name of the text snippet",
        "error_deleting_textblocks": "An error occurred when deleting text snippet – try again.",
        "error_loading_textblocks": "Failed to load text snippet.",
        "error_saving_textblocks": "An error occurred – try again.",
        "form_validation_error_textblocks": "Fill in both fields.",
        "save_text_block": "Create",
        "textblocks": "Text snippets",
        "textblocks_empty_list_message": "No text snippets available",
        "textblocks_success_message": "Text snippet added."
      }
    },
    "download": {
      "continue_in_project": "continue to project",
      "download_file_type": "Download {fileType}",
      "download_files": "Download files ({fileSize})",
      "download_link_deactivated": "Email access is disabled.",
      "download_not_possible": "This download is not available!",
      "download_settings_title": "Download",
      "external_per_email": "External participants",
      "file_list": "File list",
      "files_not_accessible": "This download is not possible as you don't have access to any of these files.",
      "folder_original": "Folder/Original",
      "folder_standard": "Folder/Standard",
      "folder_with_file_names_prefixed": "Folder and file name including prefixed plan/document number",
      "folder_with_original_file_names": "Folder and file name",
      "gdpr_legal_logging_hint": "Downloads are logged!",
      "getting_uploaded": "Uploading … ({fileSize})",
      "message_download_link_expired": "Email access has expired.",
      "only_download_print_file": "Download PRINT FILE only",
      "only_download_print_files": "Download PRINT FILES only",
      "open_file": "Open {x}",
      "original_file_names_without_folder": "Just the file",
      "per_email": "Via email",
      "percentage_done": "{percentage} %",
      "preview_file_list": "'File list' preview",
      "preview_folder_original": "'Folder/Original' preview",
      "preview_folder_standard": "'Folder/Standard' preview",
      "select_folder_structure": "Choose a preferred folder structure",
      "server_error_download_expired": "The download URL is older than 120 days.",
      "server_error_download_expired_auth": "The download URL has expired.",
      "server_error_not_found": "The used download URL is invalid.",
      "server_error_participant_disabled": "Your access to the project has been revoked.",
      "server_error_project_deleted": "The project has been deleted by the project owner.",
      "server_error_unknown": "An unknown error occurred. Reload the page."
    },
    "emails": {
      "customer_slogan": "PLANFRED – Plans always up-to-date!",
      "footer_logo_alt": "PLANFRED Logo – Plans always up-to-date!",
      "footer_slogan": "Project hub",
      "privacy_hint": "Information on data protection and right of withdrawal."
    },
    "export": {
      "documents_list": "Documentlist",
      "metadata": {
        "active_filters": "Filters:",
        "address": "Address:",
        "date": "Date:",
        "owner": "Project owner:",
        "project": "Project:"
      },
      "participants_list": "Participantlist",
      "plans_list": "Planlist",
      "tasks_list": "Tasklist"
    },
    "file_auto_assign": {
      "adapt_plans_or_files_in_clipboard": "If necessary, adapt existing plans or add / delete files in the clipboard.",
      "add_comment": "Add note",
      "auto_update_plans": "Automatic plan update …",
      "auto_update_plans_headline": "Automatically update plans",
      "cad_file_missing": "CAD file missing",
      "check_assignment_and_confirm": "Check assignment and confirm selection",
      "check_suggestions_and_confirm": "Check suggestions and confirm selection",
      "choose_plans_enter_index_confirm_update": "Select plans - enter index per plan - confirm update",
      "detected_plan_name_in_file_name": "File name contains plan number",
      "detected_similarity_to_file_name": "Detected similarity to the file name of a revision",
      "detected_similarity_to_plan_name": "Detected similarity to plan number",
      "enter_index": "Enter index",
      "error_cannot_mix_print_and_dwg_files": "If there are both PRINT and CAD files in the clipboard, individual assignment of CAD files is not possible.",
      "error_could_not_create_revision": "The revision could not be created. Please try again or contact our support.",
      "error_could_not_load_suggestions": "Suggestions could not be loaded. Contact our support.",
      "error_file_is_not_print_or_dwg": "File is not a PRINT/CAD file and cannot be assigned to a plan.",
      "error_multiple_dwg_files": "The index package contains several CAD files with the same name. Delete one of the duplicates in the clipboard.",
      "error_multiple_index_packages_for_plan": "No processing possible because there are several matching index packages for this plan.",
      "error_multiple_plans_for_index_package": "No processing possible because the index package can be assigned to multiple plans.",
      "error_multiple_print_files": "The index package contains several print files with the same name. Delete one of the duplicates in the clipboard.",
      "error_no_plan_found_for_files": "No suitable plan was found for this index package.",
      "feature_hint": "Manual ”Update multiple plans automatically“",
      "file_assignment_completed": "File assignment from clipboard completed",
      "jump_to_inputs": "Jump to the input field",
      "manual_link": "https://www.planfred.com/en/manual/#Update%20multiple%20plans%20automatically",
      "manual_link_text": "Go to manual “S10 Update multiple plans automatically“",
      "not_assignable": "Not assignable",
      "one_plan_without_index": "1 selected plan without index!",
      "plan_label_name": "Plan number / Code:",
      "print_file_missing": "PRINT file missing",
      "report_problem_for_auto_file_assignment": "Report a problem with automatic file assignment",
      "select_plan_to_update": "To update, select a plan",
      "suggestions": "Suggestions",
      "suggestions_for_x_of_y_files": "There are suggestions for {x} of {y} files.",
      "unique_assignment": "Clear Assignment",
      "update_more_plans": "Update more plans",
      "warning_upload_currently_running": "Upload currently running.",
      "which_problem_did_occur": "What problems did you encounter during the assignment?",
      "which_problem_did_occur_debug_data_hint": "Debug data will be sent to Planfred.",
      "x_of_y_files_can_be_assigned": "{x} of {y} files can be assigned clearly.",
      "x_of_y_files_without_assignment": "{x} of {y} files cannot be assigned to a plan.",
      "x_plans_without_index": "{x} plans without index selected!"
    },
    "filter": {
      "delete_search_field": "Clear search window",
      "messagebox": {
        "multiple_match": "Only {filteredItemsLength} of {allItemsLength} {itemTypeDative} listed with the current filter settings.",
        "no_match": "No {itemType} could be found with the current filter settings.",
        "one_match": "Only 1 of {allItemsLength} {itemTypeDative} listed with the current filter settings.",
        "reset_filter_settings": "Reset all filter settings"
      },
      "no_participants_available_for_documents": "Authors are displayed as soon as a document has been uploaded with a participant as the author.",
      "no_participants_available_for_documents_permission": "Participants are displayed as soon as a document with restricted permission has assigned a participant.",
      "no_participants_available_for_plans": "Authors are displayed as soon as a plan has been uploaded with a participant as the author.",
      "ownership": {
        "all_projects": "All projects",
        "all_projects_short": "All",
        "owner": "Own projects",
        "owner_short": "Owner",
        "participant": "Project participation",
        "participant_short": "Involved"
      },
      "roles": {
        "nothing_uploaded_from_role": "Roles are being displayed here after the first upload"
      },
      "roles_and_participants_available_after_approval": "There are currently no open reviews.",
      "search": "Search:",
      "search_hits_x_of_y": "{filteredItemsLength} of {allItemsLength}",
      "show_all": "Show all",
      "tags": {
        "no_tags_assigned": "No tags assigned yet"
      },
      "text_search_placeholder": "Search:  Term-A + \"Term B\""
    },
    "item": {
      "approval_done": "Review finished",
      "approval_status": {
        "approved": "Approved",
        "notrequested": "Not requested",
        "obsolete": "Review no longer required",
        "pending": "Review requested",
        "pending_short": "Requested",
        "rejected": "Commented"
      },
      "author": {
        "document_label_assign_to_other_author": "Edit document author",
        "document_label_author": "Author:",
        "edit_server_error": "An error occurred while saving the author. Author could not be changed.",
        "label_role": "Role:",
        "plan_label_assign_to_other_author": "Edit plan creator",
        "plan_label_author": "Plan creator:"
      },
      "detail": {
        "document_edit": "Edit document",
        "edit_name": "Edit number/content",
        "edit_permission": "Edit permission",
        "edit_phasetag": "Edit plan folder",
        "edit_phasetag_document": "Edit document folder",
        "edit_tags": "Edit tags",
        "edit_top_categories": "Edit top category",
        "number_content": "Number/Content",
        "plan_edit": "Edit plan"
      },
      "document_mailer": {
        "add_documents": "Add documents",
        "add_participant": "Add recipient",
        "add_plans": "Add plans",
        "change_documents_selection": "Change documents selection",
        "change_plans_selection": "Change plans selection",
        "choose_participants": "Choose participants for new recipient group",
        "delete_group": "Delete group",
        "delivery_failed_for_participant": "The delivery failed for participant:",
        "delivery_failed_for_participants": "The delivery failed for participants:",
        "document_default_subject": "1 new document for you",
        "document_successfully_sent_to": "Document successfully sent to:",
        "documents_default_subject": "{number} new documents for you",
        "documents_subject_prefix": "{projectTitle} - Documents shipping:",
        "documents_successfully_sent_to": "Documents successfully sent to:",
        "edit_group": "Edit recipient group",
        "edit_recipient": "Edit recipient",
        "edit_recipients_list": "Edit recipients",
        "email_already_exists": "This email address is already in use in this project.",
        "email_already_exists_disabled": "This email address is already in use in this project, but is disabled.",
        "headline_recipients_and_settings": " - Recipients and settings",
        "new_group": "Create recipient group",
        "no_name": "Title recipients selection",
        "no_participants_selected": "Select recipients",
        "one_documents": "1 document",
        "one_plans": "1 plan",
        "participants_locked": "This participant got locked:",
        "pdf-only-option-active-item-without-cad-file-warning": "You have selected plans that do not contain a PRINT file. The option 'Restrict access to PRINT-FILES' requires that all plans you want to send contain a PRINT file.",
        "plan_default_subject": "1 new plan for you",
        "plan_includes_only_print_file": "This plan only contains a PRINT FILE. The 'send PRINT FILE only' option restricts the download to the PRINT FILE, even if a CAD FILE has been added subsequently.",
        "plan_successfully_sent_to": "Plan successfully sent to:",
        "plans_default_subject": "{number} new plans for you",
        "plans_includes_only_print_files": "Plans only include print files",
        "plans_subject_prefix": "{projectTitle} - Plan shipping:",
        "plans_successfully_sent_to": "Plans successfully sent to:",
        "recipient": "Recipient",
        "recipients": "Recipients",
        "recipients_group_title": "Title:",
        "recipients_list": "Recipients",
        "recipients_list_label": "Recipients:",
        "save_time_with_recipient_groups": "Same recipients all the time? Save time by using recipient groups!",
        "select_recipients": "Select recipients",
        "send": "Send",
        "send_document": "Send document",
        "send_document_to": "Send document to …",
        "send_documents_to": "Send {count} documents to …",
        "send_only_print_file": "Send PRINT file only",
        "send_only_print_files": "Send PRINT files only",
        "send_plan": "Send plan",
        "send_plan_to": "Send plan to …",
        "send_plans_to": "Send {count} plans to …",
        "send_to_additional_participants": "Send to additional participants",
        "send_to_externals": "To “participants without login”:",
        "send_to_me": "Always send a copy to me too",
        "send_to_me_participant_label": "Copy to me",
        "send_to_new_externals": "Additional recipients:",
        "send_to_project_participants": "To project participants:",
        "sending_options": "Sending options:",
        "server_error": "An error occurred while saving the request – try again.",
        "server_error_send": "An error occurred while sending.",
        "show_disabled_participant": "Show disabled participant",
        "show_external_disabled_email": "Show disabled 'participant without login'",
        "show_recipients_list": "Show recipients list in email",
        "subject": "Subject:",
        "subject_suffix": "Subject suffix",
        "tasks_subject_prefix": "{projectTitle} - Tasks shipping:",
        "to_group": "Recipient group",
        "to_groups": "Recipient groups",
        "warning": "ATTENTION!",
        "x_documents": "{count} documents",
        "x_plans": "{count} plans",
        "you_are_sending_multiple_restricted_items": "You are sending {count} documents with restricted access!",
        "you_are_sending_one_restricted_item": "You are sending a document with restricted access!"
      },
      "document_name": {
        "edit_server_error": "An error occurred while saving the document name/content. Document name/content could not be saved.",
        "label_content": "Document content:",
        "label_current_version": "Current version:",
        "label_first_index": "First version:",
        "label_first_index_max_char": "Version (max.6 characters):",
        "label_name": "Document number/code:",
        "label_name_long": "Document number/code:",
        "label_version": "Version:",
        "placeholder_content": "Document content",
        "placeholder_index": "Version",
        "placeholder_name": "Document number/code",
        "validation_not_available": "This document number/code is already in use in this project.",
        "validation_required": "Enter a document number/code.",
        "validation_update_existing_item": "Update the existing document {itemName}"
      },
      "document_not_available": "Document not available",
      "document_permission": {
        "access_permission": "Access permission:",
        "admin_auto_access_hint": "Administrator always has access",
        "choose_participants": "Choose participants for new participants selection",
        "delete_group": "Delete selection",
        "edit_group": "Edit participants selection",
        "edit_server_error": "An error occurred while saving access permission. Access permission could not be changed.",
        "grant_these_participants_access": "Grant these participants access:",
        "new_group": "Create participants selection",
        "no_name": "Name the participants selection",
        "no_participants_selected": "Select participants",
        "only_accessible_for": "Only accessible by:",
        "participant": "Participant",
        "participants": "Participants",
        "public_document": "Public document",
        "restricted_document": "Secure document (Restrict permission)",
        "to_group": "Participants selection"
      },
      "document_permission_filter": {
        "public": "Public documents",
        "restricted": "Access restricted"
      },
      "download_link_access_date_label": "Access via email. \nExpires on",
      "download_link_access_list_header": "Participants without login with access via email:",
      "edit_server_error_documents_403": "Please reload the page. You have no more access for this document",
      "edit_server_error_plans_403": "Please reload the page. You have no more access for this plan.",
      "go_to_revision_approval": "… to review",
      "item_delete": "Delete {itemType}",
      "item_delete_server_error": "{itemType} could not be deleted.",
      "item_restore": "Restore {itemType}",
      "item_restore_name_already_exists": "WARNING: {itemType} „{itemName}“ already exists.",
      "item_restore_server_error": "{itemType} could not be restored.",
      "item_restricted_message": "You must not change this {itemType} because you are not in the role of the writer!",
      "item_update_label": "Update {itemType}",
      "maybe_no_permission_to_view_document": "Maybe you don't have the required permission to view this document.",
      "maybe_no_permission_to_view_plan": "Maybe you don't have the required permission to view this document.",
      "multi_action_selection_preview": {
        "documents": {
          "hide": "hide",
          "item_selected": "{count} selected document",
          "items_selected": "{count} selected documents",
          "show": "show"
        },
        "participant": {
          "hide": "hide",
          "item_selected": "{count} selected participant",
          "items_selected": "{count} selected participants",
          "show": "show"
        },
        "users": {
          "hide": "hide",
          "item_selected": "{count} selected user",
          "items_selected": "{count} selected users",
          "show": "show"
        },
        "plans": {
          "hide": "hide",
          "item_selected": "{count} selected plan",
          "items_selected": "{count} selected plans",
          "show": "show"
        },
        "tasks": {
          "hide": "hide",
          "item_selected": "{count} selected task",
          "items_selected": "{count} selected tasks",
          "show": "show"
        }
      },
      "new": {
        "create_document_in_parallel": "create another document in parallel",
        "create_new_document": "Upload new document",
        "create_new_plan": "Upload new plan",
        "create_plan_in_parallel": "create another plan in parallel",
        "create_server_error_document": "An error occurred while saving the document – try again.",
        "create_server_error_plan": "An error occurred while saving the plan – try again.",
        "created_document": "Document '{itemLink}' got created.",
        "created_plan": "Plan '{itemLink}' got created.",
        "document_description": "Document description",
        "document_name_already_exists": "Document could not be saved. There is already an existing document with the number '{itemName}'.",
        "enter_a_version": "Please provide a version.",
        "enter_an_index": "Enter an index.",
        "message_no_approvers_in_project_to_select": "For this option, at least one participant must have the plan review permission!",
        "no_index_comment": "No index note",
        "plan_description": "Plan description",
        "plan_name_already_exists": "Plan could not be saved. There is already an existing plan with the number '{itemName}'.",
        "save_and_create_document": "Save and upload new document",
        "save_and_create_plan": "Save and upload new plan",
        "select_document_properties": "Select document properties",
        "select_file": "Select file",
        "select_files": "Select files",
        "select_plan_properties": "Select plan properties",
        "separate_document_name_and_index": "Document number and version",
        "separate_name_and_index": "Separate plan number and index/state",
        "use_settings_from_document": "Use inputs from latest document",
        "use_settings_from_plan": "Use inputs from latest plan",
        "use_settings_from_task": "Use inputs from latest task"
      },
      "new_index": "New index",
      "new_version": "New version",
      "phasetag": {
        "document_label": "Document folder:",
        "document_validation_required": "Select a document folder.",
        "edit_server_error_documents": "An error occurred while saving the document folder. Document folder could not be saved.",
        "edit_server_error_plans": "An error occurred while saving the plan folder. Plan folder could not be saved.",
        "plan_label": "Plan folder:",
        "plan_validation_required": "Select a plan folder."
      },
      "plan_name": {
        "edit_server_error": "An error occurred while saving the plan name/content. Plan name/content could not be changed!",
        "label_content": "Plan content:",
        "label_current_index": "Current index:",
        "label_first_index": "First index:",
        "label_first_index_max_char": "Index/state (max. 6 characters):",
        "label_index": "Index:",
        "label_name": "Plan number/code:",
        "label_name_long": "<strong>Plan number / code</strong> (without index, state and date):",
        "placeholder_content": "Plan content",
        "placeholder_index": "Index",
        "placeholder_name": "Plan number/code",
        "validation_not_available": "This plan number is already in use in this project.",
        "validation_required": "Enter a plan number.",
        "validation_update_existing_item": "Update the existing plan {itemName}"
      },
      "plan_not_available": "Plan not available",
      "planfred_permissionsystem": "Permissions briefly explained",
      "revision": {
        "activity_log": {
          "changed_tags": "Tags changed by {participant}: {diff}",
          "deleted_from": "{itemType} DELETED by {participant}",
          "exported_to": "Index exported to project {projectTitle} by {participant}",
          "index_imported_from": "Index imported from project {projectTitle}",
          "item_imported_from": "{itemType} imported from project {projectTitle}",
          "restored_from": "{itemType} RESTORED by {participant}",
          "changed_name": "Renamed by {participant}: {oldName} → {newName}",
          "changed_phase": "Folder changed by {participant}: {oldPhase} → {newPhase}",
          "changed_author": "Author changed by {participant}: {oldAuthor} → {newAuthor}",
          "changed_top_category": "Top category changed by {participant}: {oldCategory} → {newCategory}",
          "plans": {
            "changed_name": "{participant} renamed the plan from \"{oldName}\" to \"{newName}\".",
            "changed_phase": "{participant} changed the plan folder from {oldPhasetag} to {newPhasetag}.",
            "changed_author": "{participant} changed the plan author from {authorParticipantOld} to {authorParticipantNew}."
          },
          "documents": {
            "changed_name": "{participant} renamed the document from \"{oldName}\" to \"{newName}\".",
            "changed_phase": "{participant} changed the document folder from {oldPhasetag} to {newPhasetag}.",
            "changed_author": "{participant} changed the document author from {authorParticipantOld} to {authorParticipantNew}."
          }
        },
        "add_approval": "Add review",
        "add_correction": "Add comment",
        "approval_attachment_label": "File attachment as approval confirmation",
        "approval_attachment_warning_text": "This attachment is used exclusively for transmitting the file (plan index/document version) with an approval stamp without correction annotations.",
        "approval_attachment_warning_title": "Attention:",
        "approval_cancelled_by": "Review revoked by {participant}",
        "approval_comment_message": "Review note:",
        "approval_date_label": "Review date:",
        "approval_done": "Review done.",
        "approval_edit_server_error": "An error occurred while saving the review – try again.",
        "approval_leave_review_dates_unchanged": "Leave review dates unchanged",
        "approval_message_warning_will_only_be_applied_to_new_approvals": "The review request message will only be applied to new approvals",
        "approval_mode_and": "ALL selected",
        "approval_mode_or": "ONE of the selected",
        "approval_not_finished": "This review has not been completed.",
        "approval_remove_due_date_label": "No due date",
        "approval_remove_due_date_warning": "Removes existing review dates.",
        "approval_request": "Review request:",
        "approval_request_message": "Message for review request:",
        "approval_requested_by": "Requested by {participant}",
        "approval_required": "This plan revision requires my review!",
        "approval_required_by": "Review required by:",
        "approval_required_from_all_participants": "Review is required by {bold} participants listed.",
        "approval_required_from_all_participants_bold": "ALL",
        "approval_required_from_one_participant": "Review is required by {bold} of the listed participants.",
        "approval_required_from_one_participant_bold": "ONE",
        "approval_required_from_this_participant": "Review is only required by this participant.",
        "approval_required_hint": "{participant} has requested a review from me.",
        "approval_required_hint_due_date_hint": "The review due date has expired since {date}!",
        "approval_set_review_date_to": "Set review date to…",
        "approval_status_approval": "Approval",
        "approval_status_correction": "Comment",
        "approval_with_remarks": "Approval with annotations",
        "approve_or_reject_index": "Approve/reject directly ...",
        "approve_or_reject_version": "Approve/reject this version BY MYSELF ...",
        "approver_label": "Reviewer/s:",
        "cad_file_missing": "CAD file missing",
        "choose_approval_status": "Select:",
        "choose_participants_for_approval": "Choose participants for review.",
        "comment": "Comment:",
        "comment_for_approval": "Note on approval:",
        "comment_for_index": "Index note:",
        "comment_for_rejection": "Comment on the requested review:",
        "comment_for_review": "Note:",
        "comment_for_version": "Version note:",
        "consider_the_corrections": "Note the review comment!",
        "consider_the_corrections_plural": "Note the review comments!",
        "correction_attachment": "Attachment:",
        "corrections_for_document_revision": "There are comments to this document version.",
        "corrections_for_plan_revision": "There are comments to this plan index.",
        "current_index": "Current index",
        "current_version": "Current version",
        "didnt_got_downloaded_yet": "has not been downloaded by anyone yet",
        "didnt_got_sent_yet": "has not been sent to anyone yet",
        "document_approval_got_revoked": "This document review has been revoked.",
        "document_comment": "Version note:",
        "document_revision_got_approved": "This document version has been approved.",
        "document_revision_waiting_for_my_approval": "This document version requires my review!",
        "download_file": "Download file",
        "download_plan": {
          "unauthorized_approved_hint": "File cannot be added to revision after approval has been completed.",
          "unauthorized_pending_approval_hint": "File cannot be added to revision during approval."
        },
        "download_server_error": "An error occurred while loading the file – try again.",
        "downloaded_by": "by {participant}",
        "downloaded_by_label": "Downloaded by",
        "downloaded_by_one_person": "1 person",
        "downloaded_by_x_persons": "{count} persons",
        "edit_approval": "Edit review",
        "edit_group": "Edit reviewer group",
        "error_download": "An error occurred while downloading the file – try again.",
        "imported_item_approved": "The approval was taken over during import",
        "index_history": "Index history",
        "index_requires_approval_from": "Review required of …",
        "item_copy_and_edit": "Copy and edit {itemType}",
        "label_index": "Index",
        "label_version": "Version",
        "last_index": "Last index: {lastIndex}",
        "last_version": "Last version: {lastIndex}",
        "link_add_approval": "Add review",
        "link_edit_approval": "Edit review",
        "message_from": "Message from {participant}:",
        "my_review": "My review",
        "new_group": "Create reviewer group",
        "no_approval_request": "No review message",
        "no_approval_required": "No review required",
        "no_approvers_in_project": "There are no reviewers in this project yet.",
        "no_reworked_index": "No superseded index available",
        "no_reworked_version": "No superseded version available",
        "not_downloaded_yet": "has not been downloaded by anyone yet",
        "one_participant_required_for_approval": "At least one participant must be selected for the review!",
        "only_first_download_listed": "Only the first and latest download is listed per person.",
        "only_print_file_sent": "only PRINT-FILE sent",
        "open_file": "Open file",
        "plan_approval_got_revoked": "This plan review has been revoked.",
        "plan_comment": "Index note:",
        "plan_revision_create_server_error": "An error occurred while creating the revision – try again.",
        "plan_revision_got_approved": "This plan index has been approved.",
        "plan_revision_waiting_for_my_approval": "This plan index requires my review!",
        "please_enter_a_plan_index": "Enter a plan index.",
        "please_select_a_review_result": "Please select a review result.",
        "print_file_missing": "PRINT file missing",
        "revision_is_approved_by_myself": "This revision is approved by me",
        "save_and_approve_by_myself_immediately": "Approve revision",
        "save_and_comment_by_myself_immediately": "Comment revision",
        "save_and_finish_approval": "Save and finish review",
        "save_and_request_approval": "Save and request review",
        "save_and_revoke_approval": "Save and revoke review",
        "save_approval_server_error": "An error occurred while saving the review. Review status could not be saved.",
        "save_approval_server_error_date_must_be_in_future": "The review date must be in the future.",
        "save_correction": "Save comment",
        "save_correction_server_error": "An error occurred while saving the comment – try again.",
        "save_correction_validation_error": "Add either a file or a comment.",
        "save_index": "Save index",
        "save_index_and_back_to_list": "Save index and return to list",
        "save_index_and_close": "Save index and close tab",
        "save_index_approval": "Send index approval",
        "save_version": "Save version",
        "save_version_and_back_to_list": "Save version and return to list",
        "save_version_and_close": "Save version and close tab",
        "sent_to_label": "Sent to",
        "sent_to_one_person": "1 participant",
        "sent_to_x_persons": "{count} participants",
        "submit_review": "Submit my review",
        "to_be_reviewed_by_me": "… to be reviewed by me",
        "to_groups": "Reviewers Group",
        "uploaded_by": "{fromNow} uploaded by {participant}",
        "version_history": "Version history",
        "version_requires_approval_from": "This version requires review by …"
      },
      "role": {
        "item_edit_server_error": "An error occurred while saving the role.",
        "label_role": "Role:",
        "new_role_placeholder": "New role",
        "no_role_assigned_yet": "No role assigned",
        "role": "Role",
        "unsaved_role_warning": "Add role “{role}” before saving."
      },
      "save_edit_top_category_error": "There was an error saving the top category.",
      "select_top_category": "Select a top category.",
      "tags": {
        "item_edit_server_error": "An error occurred while saving the tag selection.",
        "label_tags": "Tags:",
        "new_tag_placeholder": "New tag",
        "no_tags_assigned": "No tags assigned",
        "no_tags_defined_yet": "No tags created yet",
        "only_use_existing_tags": "Only predefined tags may be used in this project.",
        "unsaved_tag_warning": "Add tag “{tag}” before saving."
      },
      "task_mailer": {
        "delivery_failed_for_participant": "The delivery failed for participant:",
        "delivery_failed_for_participants": "The delivery failed for participants:",
        "modal_title": "Send reminder",
        "participants_locked": "This participant got locked:",
        "recipient": "Recipient:",
        "reminder": "Task-Reminder",
        "send_success_message": "Sent to:",
        "server_error_send": "An error occurred while sending.",
        "subject": "Subject:",
        "subject_prefix": "{projectTitle} - #{consecutiveNumber} {taskTitle}",
        "task_successfully_sent_to": "Task successfully sent to:",
        "tasks_successfully_sent_to": "Tasks sent to:"
      },
      "top_category": "Top category:",
      "upload_new_index": "Upload new index",
      "upload_new_version": "Upload new version",
      "your_role_is_not_allowed_to_update_document": "Your role {userRole} is not allowed to update documents from other roles.",
      "your_role_is_not_allowed_to_update_plan": "Your role {userRole} is not allowed to update plans from other roles."
    },
    "item_list": {
      "available_offline": "Offline",
      "cad_file_label": "CAD",
      "change_properties": {
        "approval": {
          "approval_date": "Review date",
          "approval_of_selected_document": "Review request of selected document",
          "approval_of_selected_documents": "Review request of selected documents",
          "approval_of_selected_plan": "Review request of selected plan",
          "approval_of_selected_plans": "Review request of selected plans",
          "cannot_update_approval_of_document": "The review of this document cannot be updated",
          "cannot_update_approval_of_documents": "For {filteredCount} of {totalCount} documents the review cannot be updated",
          "cannot_update_approval_of_plan": "The review of this plan cannot be updated",
          "cannot_update_approval_of_plans": "For {filteredCount} of {totalCount} plans the review cannot be updated",
          "edit_approval_date": "Edit review date",
          "edit_approval_of_selected_document": "Edit review requests of the selected document",
          "edit_approval_of_selected_documents": "Edit review requests of the selected documents",
          "edit_approval_of_selected_plan": "Edit review requests of the selected plan",
          "edit_approval_of_selected_plans": "Edit review requests of the selected plans",
          "edit_review_date_of_selected_document": "Edit review date of the selected document",
          "edit_review_date_of_selected_documents": "Edit review dates of the selected documents",
          "edit_review_date_of_selected_plan": "Edit review date of the selected plan",
          "edit_review_date_of_selected_plans": "Edit review dates of the selected plans",
          "hint_approver_required_documents": "Your selection contains documents that currently do not require a review. To apply your changes, please select at least one reviewer for all documents.",
          "hint_approver_required_plans": "Your selection contains plans that currently do not require a review. To apply your changes, please select at least one reviewer for all plans.",
          "label": "Review",
          "no_documents_to_update": "No documents to choose",
          "no_plans_to_update": "No plans to choose"
        },
        "author": {
          "label": {
            "documents": "Author",
            "plans": "Author"
          },
          "labels": {
            "documents": "Authors",
            "plans": "Authors"
          },
          "merge_warning": "Multiple authors will be merged irreversibly.",
          "property_details_header": "Set author {selectedItems} to:",
          "property_editor_header_document": "Set author of selected document to:",
          "property_editor_header_documents": "Set author of selected documents to:",
          "property_editor_header_plan": "Set author of selected plan to:",
          "property_editor_header_plans": "Set author of selected plans to:",
          "property_preview_header_document": "Author of selected document:",
          "property_preview_header_documents": "Authors of selected documents:",
          "property_preview_header_plan": "Author of selected plan:",
          "property_preview_header_plans": "Authors of selected plans:"
        },
        "cancel_btn": "cancel",
        "cannot_update_document": "This document cannot be updated",
        "cannot_update_documents": "{filteredCount} of {totalCount} documents cannot be updated",
        "cannot_update_plan": "This plan cannot be updated",
        "cannot_update_plans": "{filteredCount} of {totalCount} plans cannot be updated",
        "details_title": "{currentProperties} {selectedItems}",
        "irreversibleActionMessage": "Multiple {items} will be merged irreversibly.",
        "irreversibleActionMessageTags": "These tag changes are irreversible.",
        "makeDocumentsPublicWarningMessage": "Do you really want to make all selected documents public?",
        "make_offline": {
          "already_offline_count_one_file": "{cached} of 1 file already available offline",
          "already_offline_count_x_files": "{cached} of {total} files already available offline",
          "download_log_hint_documents": "A download is logged for every document that is loaded.",
          "download_log_hint_plans": "A download is logged for every plan that is loaded.",
          "download_size": "{size} to download",
          "downloaded_size": "{size} / {total} downloaded",
          "label": "Make available offline",
          "modal_title": "Load onto device",
          "no_file_to_download_document": "This document has no file to download",
          "no_file_to_download_documents": "For {filteredCount} of {totalCount} documents there is no file to download",
          "no_file_to_download_plan": "This plan has no file to download",
          "no_file_to_download_plans": "For {filteredCount} of {totalCount} plans there is no file to download",
          "offline_required": "An internet connection is required to make files available offline.",
          "property_preview_header": "Offline availability",
          "retry_failed": "Retry failed",
          "status_already_offline": "Already offline",
          "status_downloaded": "Downloaded",
          "status_downloading": "Downloading …",
          "status_failed": "Failed",
          "status_pending": "Waiting",
          "status_too_large": "Too large"
        },
        "modal_title": "Change property",
        "permission": {
          "property_editor_header_document": "Set access permission of selected document to:",
          "property_editor_header_documents": "Set access permission of selected documents to:",
          "property_preview_header_document": "Access permission of selected document:",
          "property_preview_header_documents": "Access permission of selected documents:"
        },
        "permission_only_editable_by_admins_or_document_authors": "Access permission can only be changed by admins or document authors",
        "phase": {
          "label": {
            "documents": "Document folder",
            "plans": "Plan folder"
          },
          "labels": {
            "documents": "Document folders",
            "plans": "Plan folders"
          },
          "property_details_header": {
            "documents": "Set folder {selectedItems} to:",
            "plans": "Set folder {selectedItems} to:"
          }
        },
        "phasetag": {
          "merge_warning_documents": "Multiple document folders will be merged irreversibly.",
          "merge_warning_plans": "Multiple plan folders will be merged irreversibly.",
          "property_editor_header_document": "Set document folder of selected document to:",
          "property_editor_header_documents": "Set document folder of selected documents to:",
          "property_editor_header_plan": "Set plan folder of selected plan to:",
          "property_editor_header_plans": "Set plan folder of selected plans to:",
          "property_preview_header_document": "Document folder of selected plan:",
          "property_preview_header_documents": "Document folders of selected plans:",
          "property_preview_header_plan": "Plan folder of selected plan:",
          "property_preview_header_plans": "Plan folders of selected plans:"
        },
        "property_list_title": {
          "documents": "Select document property:",
          "participants": "Select participant property:",
          "plans": "Select plan property:"
        },
        "review_already_got_answered_by_reviewers": "The review has already been answered by reviewers",
        "review_is_already_done": "Review is already done",
        "save_btn": {
          "default": "Update {count} {itemLabel}",
          "trashed": "Delete {count} {itemLabel}"
        },
        "selected_item": "of selected {item}",
        "selected_items": "of selected {item}",
        "tags": {
          "label": {
            "documents": "Tag",
            "plans": "Tag",
            "tasks": "Tag"
          },
          "labels": {
            "documents": "Tags",
            "plans": "Tags",
            "tasks": "Tag"
          },
          "no_tags_message": {
            "plural": {
              "documents": "Selected documents do not have any tags attached",
              "plans": "Selected plans do not have any tags attached"
            },
            "singular": {
              "documents": "Selected document does not have any tags attached",
              "plans": "Selected plan does not have any tags attached"
            }
          },
          "property_details_header": "Set tags {selectedItems} to:",
          "property_editor_header_document": "Set tags of selected document to:",
          "property_editor_header_documents": "Set tags of selected documents to:",
          "property_editor_header_plan": "Set tags of selected plan to:",
          "property_editor_header_plans": "Set tags of selected plans to:",
          "property_preview_header_document": "Tags of selected document:",
          "property_preview_header_documents": "Tags of selected documents:",
          "property_preview_header_plan": "Tags of selected plan:",
          "property_preview_header_plans": "Tags of selected plans:",
          "used_on_all_documents": "Used on every document:",
          "used_on_all_plans": "Used on every plan:",
          "used_on_some_documents": "Used on some documents:",
          "used_on_some_plans": "Used on some plans:"
        },
        "top_category": {
          "label": {
            "documents": "Top category",
            "plans": "Top category"
          },
          "labels": {
            "documents": "Top categories",
            "plans": "Top categories"
          },
          "merge_warning": "Multiple top categories will be merged irreversibly.",
          "property_editor_header_document": "Set top category of selected document to:",
          "property_editor_header_documents": "Set top category of selected documents to:",
          "property_editor_header_plan": "Set top category of selected plan to:",
          "property_editor_header_plans": "Set top category of selected plans to:",
          "property_preview_header_document": "Top category of selected document:",
          "property_preview_header_documents": "Top categories of selected documents:",
          "property_preview_header_plan": "Top category of selected plan:",
          "property_preview_header_plans": "Top categories of selected plans:"
        },
        "trashed": {
          "delete_server_error": "An error occurred - try again.",
          "label": {
            "documents": "Delete documents",
            "plans": "Delete plans"
          },
          "label_selected": {
            "documents": "Move selected document to bin",
            "plans": "Move selected plan to bin"
          },
          "label_selected_plural": {
            "documents": "Move selected documents to bin",
            "plans": "Move selected plans to bin"
          },
          "property_preview_header_document": "Move selected document to bin",
          "property_preview_header_documents": "Move selected documents to bin",
          "property_preview_header_plan": "Move selected plan to bin",
          "property_preview_header_plans": "Move selected plans to bin"
        },
        "x_of_y_already_updated": {
          "default": "{counter} of {total} {itemsLabel} updated",
          "trashed": "{counter} of {total} {itemsLabel} deleted"
        }
      },
      "documents": {
        "1_item_approval_due": "1 document approval due",
        "accessible_for_administrators": "Administrators",
        "accessible_for_creators": "Creator",
        "accessible_for_role": "Role",
        "approval": {
          "index_approved": "This version has been approved.",
          "index_corrections_available": "Version COMMENTED",
          "index_waiting_for_approval": "Version PENDING"
        },
        "click_on_link_to_create_item": "Click on 'Create new document' to upload a document.",
        "context_menu": {
          "add_approval": "Add review",
          "download_file": "Download <strong>{fileType}</strong>",
          "download_with_attachments": "Download …",
          "edit_approval": "Review",
          "edit_author": "Author",
          "edit_category": "Change top category",
          "edit_name_content": "Number/Content",
          "edit_permission": "Permission",
          "edit_phasetag": "Document folder",
          "edit_tags": "Tags",
          "new_and_prefill": "Use as template",
          "open_file": "Open <strong>{fileType}</strong>",
          "open_in_new_window": "Open in new window",
          "trash": "Delete",
          "un_trash": "Restore",
          "update_item": "Upload Revised",
          "update_item_in_new_window": "Upload in new window"
        },
        "create_document": "Upload New Document",
        "create_item": "Upload New Document",
        "delete_item_error": "An error occurred when moving document to trash - please try again.",
        "delete_item_message": "Document will be moved to trash.",
        "delete_item_question": "Delete document?",
        "delete_one_item": "Delete 1 document",
        "delete_x_items": "Delete {counter} documents",
        "download_item": "Download document",
        "download_items": "download {count} documents",
        "download_one_item": "Download 1 document",
        "download_x_items": "Download {counter} documents",
        "filter_categories": {
          "permission": "Access permission",
          "phases": "Document folder",
          "preset_items_from_me": "Documents from me",
          "roles_creator": "Roles / Author",
          "top_categories": "Top categories"
        },
        "group_import": {
          "back_to_selection": "back to document selection",
          "create_new_item": "Create as new document (document number/code has to get changed)",
          "create_new_revision": "Upload Revised Document (update the following document)",
          "how_should_item_get_imported": "How should this document get imported into the target project?",
          "import_from_other_project": "Import Documents",
          "import_item": "Import 1 document",
          "import_items": "Import {count} documents",
          "import_more_items": "Import further documents",
          "import_multiple_items": "Import multiple documents",
          "item_already_imported": "Document already imported!",
          "item_name_already_exists": "This document number/code already exists in the target project (project „{projectTitle}“)!",
          "item_trashed_in_target_project": "The document in the target project is in the bin.",
          "keep_selected_items_in_list": "Keep selected documents on filter change",
          "list_of_imported_items": "List of created documents",
          "list_of_imported_revisions": "List of updated documents",
          "multiple_approved_items_get_imported": "… {itemCounter} approved documents",
          "multiple_items_get_created": "{itemCounter} documents get created",
          "multiple_items_get_imported": "{itemCounter} documents get imported …",
          "multiple_items_get_updated": "{itemCounter} documents get updated",
          "multiple_restricted_items_get_imported": "… {itemCounter} documents with access permission",
          "multiple_selected_items_exists": "{conflictCounter} selected documents already exists in the target project",
          "no_items_with_open_approval_importable": "Documents with open review status cannot get imported!",
          "one_approved_item_gets_imported": "… 1 approved document",
          "one_item_gets_created": "1 document gets created",
          "one_item_gets_imported": "1 document gets imported",
          "one_item_gets_updated": "1 document gets updated",
          "one_restricted_item_gets_imported": "… 1 document with access permission",
          "one_selected_item_exists": "1 selected document already exists in the target project",
          "only_last_revisions_will_get_imported": "Only the last document version will get imported. The version-history will not be taken over.",
          "please_change_item_number": "The selected option requires the document number/code to be changed!",
          "running_import_leave_anyways": "There are still documents being uploaded. If you leave the page now the import is interrupted!",
          "select_one_or_more_items": "Select one or more documents",
          "selected_multiple_items": "{itemCounter} documents selected",
          "selected_one_item": "1 document selected",
          "successfully_imported": "successfully imported",
          "visible_for_admins": "only visible for administrators",
          "visible_for_everyone": "visible for everyone"
        },
        "items_loading": "Documents loading ...",
        "list_header": {
          "author": "Author",
          "content": "Content",
          "file": "File",
          "index": " Vers.",
          "name": "Number/Code",
          "phase": "Folder",
          "top_category": "Top category"
        },
        "modus": {
          "delete": {
            "headline_deleted_items": "Recycle bin – deleted documents",
            "trash_icon_label": "Deleted documents"
          },
          "edit": {
            "only_added_items_of_your_role": "You can only edit documents for which you or your role {role} is the document author."
          },
          "print": {
            "export_list": "Export the filtered documents list",
            "filter_none": "All documents",
            "filter_phasetags": "Document folders: {phasetags}",
            "group_by_none": "None",
            "group_by_phasetags": "Group by document folders",
            "group_by_roles": "Group by roles",
            "group_by_top_categories": "Group by top categories",
            "items_count": "Number/Code of documents:",
            "items_list": "Documents",
            "overlay_print_is_being_prepared": "Preparing documents list print … {renderedItemsLength} of {allItemsLength}",
            "print_list": "Print the filtered documents list",
            "show_comments": "Show version note",
            "show_item_url": "Show document URL",
            "show_permission_list_names": "Show access permission names"
          },
          "update": {
            "choose_item_to_update": "Select a document!",
            "headline_update_item": "Upload Revised Document",
            "no_item_create_a_new_item": "But you can create a document now",
            "no_items_to_update": "There are no documents with your role {role} {link}",
            "only_added_items_of_your_role": "You can only update documents for which you or your role {role} is the document author.",
            "update_current_item": "Upload Revised Document"
          }
        },
        "my_items": "My documents",
        "no_items_available": "No documents available",
        "one_item": "1 document",
        "only_accessible_for": "Only accessible by:",
        "permission_pill_author": "Author:",
        "restore_item_error": "An error occurred when restoring the document.",
        "restricted_document": "Öffentliches Dokument",
        "save_item_error": "An error occurred when saving the document.",
        "show_all_name_pills": "Show names",
        "show_items_list": "Show document list",
        "show_pill_summary": "Reduced view",
        "too_large_to_download_one_item": "1 document exceeds the maximum download size of {size}",
        "too_large_to_download_x_items": "{counter} documents exceed the maximum download size of {size}",
        "update_one_item": "Update 1 document",
        "update_x_items": "Update {counter} documents",
        "vault_access_restricted": "Restricted",
        "x_item_approvals_due": "{counter} document approvals due",
        "x_items": "{counter} documents",
        "x_of_y_items": "{filteredCounter} of {unfilteredCounter} documents",
        "you_need_help_creating_item": "Do you need help creating a document?"
      },
      "download": "download",
      "group_import": {
        "all_items_already_imported": "All {itemType} already imported",
        "approved_by_myself": "Approved by myself in the target project",
        "approved_green": "Approved (green)",
        "cannot_import_items_in_approval_process": "{itemType} that are in the review process cannot be imported",
        "cannot_import_items_with_open_approval_or_already_imported": "{itemType} that have already been imported or have an open review status cannot get imported!",
        "import_failed": "The import failed. Try again or contact our support team.",
        "import_individual_error": "Import could not get processed. Contact our support.",
        "import_settings": "Import settings",
        "index_placeholder": "Aa",
        "next_step": "Next step",
        "no_approval": "No review request",
        "no_items_to_import": "There are no {itemType} in this project to import",
        "take_over_with_approval": "take over approval",
        "take_over_without_approval": "take over without approval",
        "top_categories_deactivated_but_still_imported": "The top categories of the imported {itemType} are only displayed in the target project if the “Top categories“ feature is activated in the project settings!",
        "update_all": "update all"
      },
      "hint_shift_select": "Multiple selection with SHIFT key (⇧) pressed",
      "items": {
        "all_approvals_completed": "You have completed all reviews.",
        "approval": {
          "last_approval": "Last approval:",
          "with_annotations": "with annotations"
        },
        "filter_categories": {
          "approval_date": "Filter „Review date“",
          "approvals": "Reviews / Approvals",
          "approver": "Reviewer",
          "filter_approver": "Filter \"Reviewer\"",
          "filter_author": "Filter \"Author\"",
          "filter_participant": "Filter \"Participant\"",
          "preset_my_approvals": "My reviews",
          "tags": "Tags"
        },
        "list_header": {
          "approval_process": "Inspection period",
          "last_approval": "Last check activity",
          "last_upload": "Last upload",
          "tags": "Tags"
        },
        "modus": {
          "approval": {
            "close_approval_list": "Close list of my reviews",
            "headline_my_approval_list": "List of my reviews:"
          },
          "delete": {
            "close_recycling_bin": "Close recycle bin"
          },
          "print": {
            "content": "Content:",
            "csv_export": "CSV export",
            "error_download": "An error occurred while downloading – try again.",
            "filter_approvals": "Reviews: {approvals}",
            "filter_roles": "Roles: {roles}",
            "filter_tags": "Tags: {tags}",
            "filter_text_search": "Text search: {searchString}",
            "filtering": "Filter:",
            "project": "Project:",
            "show_comments": "Show comment",
            "state": "State:",
            "vcf_export": "VCF-Export",
            "xlsx_export": "XLSX export"
          }
        },
        "with_annotations": "with annotations",
        "you_want_to_adapt_folder_role_tags": "Want to customize the plan folders, roles, and tags in your project structure?"
      },
      "multi_action_labels": {
        "adjust_selection_label": "Adjust selection",
        "change_properties": "Edit",
        "close": "schließen",
        "download": "Download",
        "list_actions": "List actions",
        "restricted_items_message": "{count} selected {itemLabel} may NOT be changed by you!",
        "select_instruction": {
          "users": "Select one or more users"
        },
        "selected_count": "{count} {itemLabel} selected",
        "send": "Send",
        "title": {
          "documents": "Select documents …",
          "participants": "Select participants …",
          "plans": "Select plans …",
          "users": "Select user …"
        }
      },
      "participants": {
        "list_header": {
          "company": "Company",
          "email": "Email",
          "name": "Name",
          "role": "Role",
          "telephone": "Phone"
        }
      },
      "plans": {
        "1_item_approval_due": "1 plan approval due",
        "approval": {
          "index_approved": "This index has been approved.",
          "index_corrections_available": "Index COMMENTED",
          "index_waiting_for_approval": "Index PENDING"
        },
        "click_on_link_to_create_item": "Click on 'add plan' to upload a plan.",
        "context_menu": {
          "add_approval": "Add review",
          "download_file": "Download <strong>{fileType}</strong>",
          "download_with_attachments": "Download …",
          "edit_approval": "Review",
          "edit_author": "Plan creator",
          "edit_category": "Top category",
          "edit_name_content": "Number/Content",
          "edit_permission": "Permission",
          "edit_phasetag": "Plan folder",
          "edit_tags": "Tags",
          "new_and_prefill": "Use as template",
          "open_file": "Open <strong>{fileType}</strong>",
          "open_in_new_window": "Open in new window",
          "trash": "Delete",
          "un_trash": "Restore",
          "update_item": "Upload",
          "update_item_in_new_window": "Upload in new window"
        },
        "create_item": "Upload New Plan",
        "create_plan": "create plan",
        "delete_item_error": "An error occurred when moving plan to trash - please try again.",
        "delete_item_message": "Plan will be moved to trash.",
        "delete_item_question": "Delete plan?",
        "delete_one_item": "Delete 1 plan",
        "delete_x_items": "Delete {counter} plans",
        "download_item": "Download plan",
        "download_items": "Download {count} plans",
        "download_one_item": "Download 1 plan",
        "download_x_items": "Download {counter} plans",
        "filter_categories": {
          "phases": "Plan folder",
          "preset_items_from_me": "Plans from me",
          "roles_creator": "Roles / Plan creator",
          "top_categories": "Top categories"
        },
        "group_import": {
          "back_to_selection": "back to plan selection",
          "create_new_item": "Create as new plan (plan number has to get changed)",
          "create_new_revision": "Upload Revised Plan (update the following plan)",
          "how_should_item_get_imported": "How should this plan get imported into the target project?",
          "import_from_other_project": "Import Plans",
          "import_item": "Import 1 plan",
          "import_items": "Import {count} plans",
          "import_more_items": "Import further plans",
          "import_multiple_items": "Import multiple plans",
          "item_already_imported": "Plan already imported!",
          "item_name_already_exists": "This plan number already exists in the target project (project „{projectTitle}“)!",
          "item_trashed_in_target_project": "The plan in the target project is in the bin.",
          "keep_selected_items_in_list": "Keep selected plans on filter change",
          "list_of_imported_items": "List of created plans:",
          "list_of_imported_revisions": "List of updated plans:",
          "multiple_approved_items_get_imported": "… {itemCounter} approved plans",
          "multiple_items_get_created": "{itemCounter} plans get created",
          "multiple_items_get_imported": "{item_counter} plans get imported …",
          "multiple_items_get_updated": "{itemCounter} plans get updated",
          "multiple_selected_items_exists": "{conflictCounter} selected plans already exists in the target project",
          "no_items_with_open_approval_importable": "Plans with open review status cannot get imported!",
          "one_approved_item_gets_imported": "… 1 approved plan",
          "one_item_gets_created": "1 plan gets created",
          "one_item_gets_imported": "1 plan gets imported",
          "one_item_gets_updated": "1 plan gets updated",
          "one_selected_item_exists": "1 selected plan already exists in the target project",
          "only_last_revisions_will_get_imported": "Only the latest plan revision will get imported. The index history will not be imported.",
          "please_change_item_number": "The selected option requires the plan number/code to be changed!",
          "running_import_leave_anyways": "There are still plans being uploaded. If you leave the page now the import is interrupted!",
          "select_one_or_more_items": "Select one or more plans",
          "selected_multiple_items": "{itemCounter} plans selected",
          "selected_one_item": "1 plan selected",
          "successfully_imported": "successfully imported"
        },
        "items_loading": "Plans loading ...",
        "items_loading_error": "Plans could not be loaded – try again.",
        "list_header": {
          "author": "Author",
          "cad": "CAD",
          "content": "Content",
          "index": "Index",
          "name": "Number/Code",
          "phase": "Folder",
          "print": "Print",
          "top_category": "Top category"
        },
        "modus": {
          "delete": {
            "headline_deleted_items": "Recycle bin – deleted plans",
            "trash_icon_label": "Deleted plans"
          },
          "edit": {
            "only_added_items_of_your_role": "You can only edit plans for which you or your role {role} is the plan creator."
          },
          "print": {
            "export_list": "Export the filtered plan list",
            "filter_none": "All plans",
            "filter_phasetags": "Plan folders: {phasetags}",
            "group_by_none": "None",
            "group_by_phasetags": "Group by plan folders",
            "group_by_roles": "Group by roles",
            "group_by_top_categories": "Group by top categories",
            "items_count": "Number of plans:",
            "items_list": "Plans",
            "overlay_print_is_being_prepared": "Preparing plans list print … {renderedItemsLength} of {allItemsLength}",
            "print_list": "Print the filtered plan list",
            "show_comments": "Show index note",
            "show_item_url": "Show plan URL"
          },
          "update": {
            "choose_item_to_update": "Select a plan!",
            "headline_update_item": "Upload Revised Plan",
            "no_item_create_a_new_item": "But you can create a plan now",
            "no_items_to_update": "There are currently no plans for your role {role} {link}",
            "only_added_items_of_your_role": "You can only update plans for which you or your role {role} is the plan creator.",
            "update_current_item": "Upload Revised Plan"
          }
        },
        "my_items": "My plans",
        "no_items_available": "No plans available",
        "one_item": "1 plan",
        "restore_item_error": "An error occurred when restoring the plan.",
        "save_item_error": "An error occurred when saving the plan.",
        "show_items_list": "Show plan list",
        "too_large_to_download_one_item": "1 plan exceeds the maximum download size of {size}",
        "too_large_to_download_x_items": "{counter} plans exceed the maximum download size of {size}",
        "update_one_item": "Update 1 plan",
        "update_x_items": "Update {counter} plans",
        "x_item_approvals_due": "{counter} plan approvals due",
        "x_items": "{counter} plans",
        "x_of_y_items": "{filteredCounter} of {unfilteredCounter} plans",
        "you_need_help_creating_item": "Do you need help creating a plan?"
      },
      "print_attention": "ATTENTION!",
      "print_file_label": "PRINT",
      "print_use_button": "Use PLANFRED’s “print” button to optionally print out lists! This function is not available in the Recycle bin.",
      "printed_at": "printed at {date}",
      "send": "send",
      "to_be_approved_by_myself": "To be reviewed by myself",
      "top_category": "Top category"
    },
    "item_new": {
      "documents": {
        "author": {
          "placeholder": "Author"
        },
        "content": {
          "placeholder": "Document content"
        },
        "index": {
          "placeholder": "Version"
        },
        "name": {
          "placeholder": "Document number/coding",
          "validation_not_available": "A document with this number has already been created!",
          "validation_required": "Enter a document number/coding.",
          "validation_update_existing_item": "Update the existing document {itemName}"
        },
        "new_document": "New Document",
        "permission": {
          "placeholder": "Access permission"
        },
        "phase_tag": {
          "placeholder": "Document folder",
          "validation_required": "Select a document folder."
        },
        "revision": {
          "comment": {
            "placeholder": "Comment"
          },
          "placeholder": "New version",
          "placeholder_new": "First version"
        },
        "save_item": "Save document",
        "step_four": "Document description",
        "step_one": "Select file",
        "step_three": "Select document properties",
        "step_two": "Document number and version",
        "tags": {
          "placeholder": "Tags"
        },
        "top_category": {
          "placeholder": "Top category",
          "validation_required": "Select a top category."
        }
      },
      "plans": {
        "author": {
          "placeholder": "Plan author"
        },
        "content": {
          "placeholder": "Plan content"
        },
        "index": {
          "placeholder": "First index",
          "validation_required": "Enter an index."
        },
        "name": {
          "placeholder": "Plan number/coding",
          "validation_not_available": "A plan with this number has already been created!",
          "validation_required": "Enter a plan number/coding.",
          "validation_update_existing_item": "Update the existing plan {itemName}"
        },
        "new_plan": "New Plan",
        "phase_tag": {
          "placeholder": "Plan folder",
          "validation_required": "Select a plan folder."
        },
        "revision": {
          "comment": {
            "placeholder": "Comment"
          },
          "placeholder": "New index",
          "placeholder_new": "First index"
        },
        "save_item": "Save plan",
        "step_four": "Plan description",
        "step_one": "Select file(s)",
        "step_three": "Select plan properties",
        "step_two": "Separate plan number and index",
        "tags": {
          "placeholder": "Tags"
        },
        "top_category": {
          "placeholder": "Top category",
          "validation_required": "Select a top category."
        }
      }
    },
    "live_update": {
      "banner": {
        "dismiss": "Dismiss",
        "install": "Install now",
        "message_critical": "Important update installs on next page change",
        "title": "App update available"
      },
      "critical_reload": {
        "header": "Updating app",
        "message": "The app will now be updated and restarted."
      },
      "header": "Update available",
      "install_now": "Install now",
      "later": "Later",
      "message": "The app will restart to install the update."
    },
    "location_maps": {
      "add_location": "Add location",
      "add_location_layer": "Add location plan",
      "append_pin_to_task": "Assign pin to task",
      "assign_pin_to_photo": "Assign pin to photo",
      "assign_pin_to_task": "Assign pin to task",
      "back_to_location_layer_selection": "back to location plan selection",
      "click_on_create_button_to_enable_pinning": "To enable the location of tasks on the plan, at least one location plan must be created!",
      "confirm_delete_location_layer": "Do you want to permanently delete the location plan?",
      "change_location_layer": "Change location plan",
      "create_location_layer": "Create location plan",
      "delete_existing_pins": "Delete existing pins",
      "delete_location_layer": "Delete location plan",
      "delete_location_layer_pending_version": "This location plan can't be deleted while a version is still being processed.",
      "did_not_find_location_layer": "Did not find location plan",
      "edit_location_layer": "Edit location plan",
      "edit_pin": "Edit pin",
      "enter_location_layer_title": "Enter a title for this location plan.",
      "error_generating_map": "The location plan could not be generated.",
      "error_image_too_small": "The height and width of the image must be at least 512 pixels.",
      "error_invalid_extensions": "Invalid file extension. \nThe following extensions are allowed: {extensions}",
      "error_location_update_not_possible_because_its_inactive": "Location not possible as this location plan has been deactivated.",
      "error_multiple_file_upload": "Only {maxFiles} file can be uploaded.",
      "error_on_save": "There was an error saving the location plan - try again.",
      "existing_photo": "Existing photo",
      "existing_pins_will_be_deleted": "Existing pins are deleted permanently",
      "existing_task": "Existing task",
      "found_x_location_plans": "{x} possible location plans with this location found.",
      "go_to_location_map_settings": "Go to location settings",
      "label_not_set": "\"{label}\" not set",
      "location_layer_properties_info": "Only the location properties selected here can be selected when creating or editing a task / photo.",
      "location_layer_title": "Title:",
      "location_layers": "Location plans",
      "location_map_could_not_be_loaded": "The location plan could not be loaded.",
      "location_map_is_generating": "The location plan is being generated on the server. This may take several minutes.<br><br>You can now continue working with Planfred.",
      "location_map_is_generating_with_link": "The location plan is generated on the server - this can take several minutes. If you click on cancel, the location plan generation will continue in the background.<br><br>Create, edit and manage multiple location plans? ",
      "location_plan_already_exists": "A localization plan with this location already exists.",
      "location_property_inherited_from_layer": "\"{locationProperty}\" was taken over from the location plan and cannot be changed.",
      "location_tags": "Location tags",
      "location_tags_will_be_merged": "Different location tags will be merged irreversibly.",
      "location_tags_will_be_resetted": "Location tags are reset when the location plan gets changed!",
      "new_pin": "New pin",
      "new_pin_photo": "New pin (photo)",
      "new_pin_photo_short": "Pin (photo)",
      "new_pin_task": "New pin (task)",
      "new_pin_task_short": "Pin (task)",
      "no_location_layer": "No location plan",
      "no_location_layer_selected": "No location plan selected",
      "no_location_layers_available": "No location plans have been created yet",
      "no_location_set": "No location",
      "no_restriction": "No restriction",
      "not_assigned_to_any_location_layer": "Not assigned to a location plan",
      "open_in_location_layer": "open in location plan",
      "open_location_layer": "Open location plan",
      "plan_selection": "Plan selection",
      "save_location_layer_error": "An error occurred while deleting the location plan - try again.",
      "select_location_layer": "Select location plan",
      "select_location_layer_x": "Select localization plan “{title}”",
      "selectable_on_location_edit": "Can be selected on editing location",
      "show_location_plans": "Show localization plans",
      "status": "Status",
      "take_over_pins": "Take over pins",
      "title_already_in_use": "This location plan title is already in use.",
      "title_of_location_layer": "Title of the location plan",
      "transfer_pins_to_new_layer": "Transfer existing pins to new location plan",
      "update_location_failed": "Location update failed",
      "upload_file": "Upload a file.",
      "select_from_plans": "Plans",
      "select_plan": "Select a plan",
      "versions": "Versions",
      "version_tiling": "Processing tiles…",
      "version_error": "Processing failed",
      "new_version_available": "New version available",
      "location_layer_version": "Location plan version",
      "version_tiling_error": "An error occurred while processing the tiles for this version.",
      "version_not_available_offline": "This version is not available offline.",
      "version_impact": "Activating will move {tasks} and {photos} to the new version. Pins keep their position.",
      "version_impact_prefix": "Activating will move",
      "version_impact_between_tasks_and_photos": " and ",
      "version_impact_suffix": "to the new version. Pins keep their position.",
      "version_impact_tasks_only": "Activating will move {tasks} to the new version. Pins keep their position.",
      "version_impact_photos_only": "Activating will move {photos} to the new version. Pins keep their position.",
      "version_impact_tasks_singular": "1 task",
      "version_impact_tasks_plural": "{taskCount} tasks",
      "version_impact_photos_singular": "1 photo",
      "version_impact_photos_plural": "{photoCount} photos",
      "confirm_activate_version": "Are you sure you want to activate this version?",
      "activate_version": "Activate version",
      "activate_version_with_index": "Activate version {index}",
      "activate_version_failed": "Could not activate this version. Please try again.",
      "discard_version": "Discard version",
      "discard_version_with_index": "Discard version {index}",
      "discard_version_failed": "Could not discard this version. Please try again.",
      "confirm_discard_version": "Are you sure you want to discard this version?",
      "review_version": "Review & activate …",
      "compare_versions": "Compare versions",
      "compare": "Compare",
      "compare_version_label": "Version {index}",
      "view_version": "Show version",
      "new_version": "New version",
      "edit_title": "Edit title",
      "location_restrictions": "Location restrictions"
    },
    "mailer": {
      "preview": {
        "open": "Preview",
        "title": "Email preview",
        "loading": "Generating preview …",
        "error": "The preview could not be generated. Please try again.",
        "error_invalid_recipients": "The preview could not be generated. These participants are locked:",
        "error_not_possible": "The preview is not possible for these inputs:",
        "error_not_possible_unknown_reason": "The preview is not possible for these inputs. Please check your entries.",
        "error_participant_already_exists": "The preview is not possible: this participant already exists in the project.",
        "error_rate_limit": "Too many previews in a short time. Please wait a moment and try again.",
        "error_task_has_no_assignee": "The preview is not possible: the task has no assignee.",
        "error_user_is_disabled": "The preview could not be generated. This email address is locked:",
        "subject_label": "Subject:",
        "links_inactive_hint": "This is a preview, so the links here are not active."
      },
      "a_and_b_for_you": "{a} and {b} for you",
      "a_and_b_sent_to": "{a} and {b} successfully sent to:",
      "a_for_you": "{a} for you",
      "a_sent_to": "{a} successfully sent to:",
      "add_recipients": "Add recipients",
      "add_to_shipment": "Add to mailing",
      "default_subject": "{projectTitle} - Mailing:",
      "documents": {
        "add_items": "Add documents",
        "add_one_item": "Add 1 document",
        "add_x_items": "Add {counter} documents",
        "edit_selection": "Change document selection",
        "keep_selected_items_in_list": "Keep selected documents on filter change",
        "one_item": "1 document",
        "x_items": "{counter} documents"
      },
      "multiple_a_sent_to": "{a} successfully sent to:",
      "plans": {
        "add_items": "Add plans",
        "add_one_item": "Add 1 plan",
        "add_x_items": "Add {counter} plans",
        "edit_selection": "Change plan selection",
        "keep_selected_items_in_list": "Keep selected plans on filter change",
        "one_item": "1 plan",
        "restrict_access_to_print_file": "Restrict access to PRINT-FILE",
        "restrict_access_to_print_files": "Restrict access to PRINT-FILES",
        "x_items": "{counter} plans"
      },
      "resend_document": "Resend document",
      "resend_documents": "Resend documents",
      "resend_plan": "Resend plan",
      "resend_plans": "Resend plans",
      "resend_plans_and_documents": "Resend plans and documents",
      "reset_selection": "Reset selection",
      "sent_to": "Successfully sent to:",
      "sent_to_one_participant": "1 participant",
      "sent_to_x_participants": "{count} participants",
      "status": {
        "plan_and_document_sent_to": "One plan and one document sent to:",
        "plan_and_documents_sent_to": "One plan and multiple documents successfully sent to:",
        "plans_and_document_sent_to": "Multiple plans and one document successfully sent to:",
        "plans_and_documents_sent_to": "Plans and documents successfully sent to:"
      },
      "step_1": "Select plans and/or documents",
      "step_2": "Select recipient",
      "step_3": "Enter subject and message",
      "warnings": {
        "documents": {
          "or_items": "..or documents",
          "please_select_items": "Please select documents..."
        },
        "no_recipients": "No recipients selected",
        "plans": {
          "or_items": "..or plans",
          "please_select_items": "Please select plans..."
        }
      }
    },
    "mobile_app": {
      "breadcrumbs": {
        "detail": "Detail"
      },
      "documents": {
        "sorting": {
          "item_number": "Document number"
        }
      },
      "help": {
        "desired_functionality": "Desired features",
        "error_description": "Error Description",
        "our_developers_will_fix_the_error_soon": "Our developers try to fix the error as soon as possible and will contact you immediately.",
        "our_support_team_will_help": "Our support team will take care of it as soon as possible.",
        "question": "Question",
        "thanks_for_your_message": "Thank you for your message!",
        "we_will_take_improvements_seriously": "Your suggestions for improvement are a valuable part of the further development of PLANFRED. We will contact you as soon as your desired function has been integrated."
      },
      "item": {
        "approval": {
          "approval_comment": "Review note",
          "correction_attachment": "Attachment"
        }
      },
      "no_internet_connection": "No internet connection.",
      "no_internet_connection_content_may_be_outdated": "Content may be outdated and only partially available on device!",
      "plans": {
        "sorting": {
          "item_number": "Plan number"
        }
      },
      "project": {
        "do_you_really_want_to_switch_project": "Do you really want to switch to the project \"{projectTitle}\"?",
        "switch_project": "Switch project?"
      },
      "register_to_use_app": "To be able to use the PLANFRED app, you need a PLANFRED user account.",
      "register_via_web_browser": "You can easily register for it via your web browser.",
      "troubleshooting": {
        "cache": "Cache",
        "clear_all_local_data": "Clear all local data",
        "console": "Console",
        "content_will_be_resetted": "Content will get resetted to default values",
        "delete_all_local_data": "Should we clear all local data?",
        "delete_storage_key": "Delete storage key {storageKey}?",
        "device_storage_keys": "Device Storage Keys",
        "enable_manual_upload_sync": "Manual upload sync",
        "file_in_task_comment_of_unknown_task_got_annotated": "A file in the task comment of an unknown task has been annotated.",
        "file_in_task_got_edited": "A file in task {taskLink} has been annotated.",
        "file_in_unknown_task_got_edited": "A file in an unknown task has been annotated.",
        "files_will_get_deleted_permanently": "Files will be deleted permanently and cannot get restored",
        "filesystem_files": "Filesystem data",
        "location_layer_version_not_active_load_error": "The current location plan version could not be loaded.",
        "location_layer_version_not_active_photo": "The photo {photoLink} cannot be uploaded because the location plan version used while offline is no longer active.",
        "location_layer_version_not_active_preview": "The pins keep their coordinates on the current plan version. Compare both maps before continuing.",
        "location_layer_version_not_active_task": "The task {taskLink} cannot be uploaded because the location plan version used while offline is no longer active.",
        "network": "network",
        "network_sync_problem": "{itemType} hasn't been synced yet due to internet connection problems. Synchronization will be retried later.",
        "no_saved_files": "No saved files",
        "no_saved_keys": "No saved keys",
        "no_vuex_store_available": "No VUEX store available",
        "one_or_more_files_could_not_be_added": "One or more files could not be added.",
        "one_or_more_files_were_added_to_task": "One or more files have been added to task {taskLink}.",
        "one_or_more_files_were_added_to_task_comment_in_task": "One or more files have been added to a task comment in the task {taskLink}.",
        "one_or_more_files_were_added_to_task_comment_of_unknown_task": "One or more files have been added to a task comment of an unknown task.",
        "one_or_more_files_were_added_to_unknown_task": "One or more files were added to an unknown task.",
        "only_files_on_the_device_will_be_deleted": "All PLANFRED app related data on your device will be deleted. Including not yet uploaded tasks. Data on the server will remain untouched.",
        "photo_already_exists": "The photo {photoLink} already exists and cannot be uploaded again.",
        "photo_already_exists_with_different_file": "The photo {photoLink} already exists, but the file is not identical.",
        "photo_cannot_be_uploaded": "The photo {photoLink} cannot be uploaded.",
        "photo_cannot_be_uploaded_invalid_location_values": "The photo {photoLink} cannot be uploaded because its location is incomplete or invalid. Open the photo and correct the location to upload it.",
        "photo_got_annotated": "The photo {photoLink} has been annotated.",
        "photo_is_not_available_on_the_server_and_cannot_get_updated": "However, the photo is not yet available on the server and therefore cannot be updated.",
        "remove_local_version": "Discard local version",
        "remove_local_version_description": "The local version will be discarded and no longer synchronized.",
        "reset_vuex_store": "Reset VUEX store {storeName}?",
        "retry_upload": "Retry",
        "should_we_delete_the_files": "Should the files really get deleted?",
        "show_files": "Show files",
        "show_logs": "Show logs",
        "simulate_bad_network": "Simulate faulty network connection",
        "storage_content_will_be_deleted": "Storage content will get deleted and cannot be restored",
        "task_already_exists": "The task {taskLink} already exists and cannot be uploaded again.",
        "task_already_exists_with_different_files": "The task {taskLink} already exists, but the file is not identical.",
        "task_cannot_be_uploaded": "The task {taskLink} could not be uploaded.",
        "task_cannot_be_uploaded_invalid_location_values": "The task {taskLink} cannot be uploaded because its location is incomplete or invalid. Open the task and correct the location to upload it.",
        "task_comment_where_file_got_added_is_not_available_anymore": "The task comment to which the file was added is no longer available and therefore cannot be updated.",
        "task_comment_where_file_got_edited_is_not_available": "The task comment in which the file was edited is no longer available and therefore cannot be updated.",
        "task_is_not_available_on_server_and_cannot_be_updated": "However, the task is not yet available on the server and therefore cannot be updated.",
        "trigger_sync": "Trigger Upload Sync",
        "unknown_photo_got_edited": "An unknown photo has been annotated.",
        "unknown_sync_problem": "Unknown problem. Please contact our support or discard the local version.",
        "use_current_location_layer_version": "Update location",
        "vuex": "VUEX",
        "when_discarding_local_version_added_files_in_task_comment_will_be_lost": "When discarding the local version, the added files are not included in the task comment and thus the changes are discarded.",
        "when_discarding_local_version_added_files_in_task_will_be_deleted": "When discarding the local version, the added files are not added to the task and the changes are discarded.",
        "when_discarding_local_version_data_may_get_lost": "Discarding the local version may result in data loss.",
        "when_discarding_local_version_edited_file_in_task_comment_will_be_lost": "When discarding the local version, the file in the task comment is not replaced and the changes are therefore discarded.",
        "when_discarding_local_version_edits_may_get_lost": "When discarding the local version, locally stored changes may be lost.",
        "when_discarding_local_version_file_gets_lost": "When discarding the local version, the file in the task is not replaced and therefore discarded.",
        "when_discarding_local_version_nothing_gets_lost": "Discarding the local version does not result in any data loss.",
        "when_discarding_local_version_photo_will_be_lost": "When discarding the local version, the photo will not be uploaded and therefore discarded.",
        "when_discarding_local_version_task_will_be_lost": "When discarding the local version, the task will not be uploaded and therefore discarded.",
        "x_system_files": "{fileCounter} system files"
      },
      "update_app_to_continue": "Update the app in order to continue.",
      "update_now": "Update now"
    },
    "notification_settings": {
      "could_not_load_notification_settings": "Notification settings could not be loaded. The link may be outdated.",
      "due_date_report": {
        "approval_date": "Email approval date",
        "description": "Due dates for tasks as well as plan & document reviews",
        "headline": "Reminder for Due Dates",
        "reminder_on_due_dates": "Reminder on due dates (daily)"
      },
      "notification_settings": "Notification settings",
      "plan_doc_report": {
        "description": "Plans and documents to be reviewed by myself; Updates on approvals; Approval status updates",
        "headline": "Report – Plan & Document Reviews",
        "report_for_plan_and_document_reviews": "Report – Plan & Document Reviews (hourly)"
      },
      "task_report": {
        "description": "New tasks assigned to myself; Updates on tasks which are assigned to myself; Status updates and consultations",
        "headline": "Report – Tasks",
        "report_for_tasks": "Report – Tasks (hourly)"
      },
      "upload_alert": {
        "description": "All recently uploaded plans or documents",
        "headline": "Upload Alert – Plans & Documents",
        "upload_alert_with_plans_and_documents": "Upload Alert – Plans & Documents"
      },
      "week_start_report": {
        "description": "Plans and documents to be reviewed by myself; Tasks to be done or reviewed by myself (or by my role)",
        "headline": "Weekly Reminder",
        "reminder_for_document_reviews": "Reminder on documents to be reviewed",
        "reminder_for_plan_reviews": "Reminder on plans to be reviewed",
        "reminder_for_tasks_to_be_done": "Reminder on tasks to be done",
        "will_be_sent_between_x_and_y": "The e-mail will be sent on Monday between 00:00 and 06:00"
      }
    },
    "participants": {
      "cannot_update_approval_of_participant": "The role of this participant cannot be updated",
      "cannot_update_approval_of_participants": "For {filteredCount} of {totalCount} participants the role cannot be updated",
      "cannot_update_participant": "This participant cannot be updated",
      "cannot_update_participants": "{filteredCount} of {totalCount} participants cannot be updated",
      "contact_details": {
        "add_optional_contact_data": "add optional contact information",
        "change_optional_contact_data": "change optional contact details",
        "change_phone_and_address": "Change phone number/address",
        "company_label": "Company:",
        "company_placeholder": "Company",
        "company_validation_required": "Enter a company.",
        "email_label": "Email:",
        "email_label_account": "Email (User account):",
        "first_name_label": "First Name:",
        "first_name_last_name_validation_required": "Enter a name.",
        "first_name_placeholder": "First Name",
        "first_name_validation_required": "Enter a firstname.",
        "label_address_optional": "Address:",
        "label_city": "City:",
        "label_country": "Country:",
        "label_street": "Address:",
        "label_zip": "ZIP:",
        "last_name_label": "Last Name:",
        "last_name_placeholder": "Last Name",
        "last_name_validation_required": "Enter a lastname.",
        "note_label": "Note:",
        "optional_contact_data": "Optional contact information",
        "role_label": "Role:",
        "select_country": "Select country…",
        "telephone_label": "Phone number:",
        "telephone_placeholder": "Phone number"
      },
      "context_menu": {
        "contact": "Contact",
        "disable_participant": "Delete participant",
        "edit_contact_data": "Contact details",
        "edit_email_notification_settings": "Change email notification",
        "edit_permission": "Permission",
        "edit_role": "Role",
        "enable_participant": "Restore participant",
        "export_contact": "Export contact",
        "grant_approval_permission": "Grant permission to review plans ",
        "revoke_approval_permission": "Revoke permission to review plans ",
        "upload_alert_headline": "Upload notifier"
      },
      "delete_one_participant": "Delete 1 participant",
      "delete_x_participants": "Delete {counter} participants",
      "detail": {
        "activities_link": "View this participant's activities",
        "activities_of_external_participant": "Activities of this external participant",
        "activities_of_participant": "Activities of this participant",
        "address": "Address:",
        "company": "Company:",
        "edit": {
          "email_notifications_header": "Email notification settings for this project",
          "error_save_contact_data": "When saving an error has occurred. \nPlease try again.",
          "unauthorized_to_edit_hint": "You do not have permission to change other notification settings."
        },
        "edit_address": "Edit address",
        "edit_address_server_error": "An error occurred while saving the address.",
        "edit_company": "Edit company",
        "edit_company_server_error": "An error occurred saving the company – try again.",
        "edit_name": "Edit name",
        "edit_name_server_error": "An error occurred saving the name – try again.",
        "edit_permission_server_error": "An error occurred saving the permissions – try again.",
        "edit_phone_address_server_error": "There was an error saving - try again.",
        "edit_telephone": "Edit phone number",
        "edit_telephone_server_error": "An error occurred saving the phone number – try again.",
        "email": "Email:",
        "got_added_by_unknown": "Got added to this project",
        "got_added_to_project_by": "Got added to this project by {userName}",
        "got_added_via_mail_by": "Has been added by email by {userName}",
        "got_invited_by_unknown": "Received project invitation",
        "has_created_project": "{userName} has created this project",
        "has_no_project_access": "NO login",
        "has_project_access": "has project access",
        "insert_address": "Enter address",
        "insert_company": "Enter company",
        "insert_name": "Enter name",
        "insert_telephone": "Enter phone number",
        "invite_and_back_to_list": "invite & back to list",
        "invitation_email_bounced": "The project invitation email was rejected by the recipient's mail server.",
        "invitation_email_delivered": "Project invitation email successfully delivered.",
        "invitation_email_processing": "Project invitation email on its way - delivery confirmation can take a while.",
        "invitation_email_send_failed": "Sending the project invitation email failed.",
        "invitation_email_unknown": "There is no delivery confirmation for the project invitation email. Whether it was delivered is unknown.",
        "last_planfred_login": "Last planfred login:",
        "last_project_login": "Last project login:",
        "login_data": "Login information:",
        "name": "Name:",
        "never_logged_in_into_planfred": "Never logged into PLANFRED.",
        "never_logged_in_into_project": "Never logged into this project.",
        "new_invitation_got_sent": "A new project invitation was successfully sent to '{email}'.",
        "new_invitation_got_sent_server_error": "An error occurred sending the project invitation – try again.",
        "not_authorized_to_edit_owner": "You are not permitted to edit the project owner.",
        "not_authorized_to_edit_participant": "You are not permitted to edit other participants.",
        "note": "Note:",
        "participant_activities_message_box": "The activities page has been revised!",
        "phone": "Phone:",
        "project_access": "Project access:",
        "project_access_got_granted_by": "Project access got granted by {userName}",
        "project_access_got_revoked_by": "Project access got revoked by {userName}",
        "project_invitation_from": "Project invitation from {userName}",
        "reinvite_participant": "Invite participant again",
        "save_and_back_to_list": "save & back to list",
        "save_and_invite": "save & invite to project"
      },
      "edit": {
        "back_to_list": "back to participant list",
        "can_approve_revisions": {
          "heading": "Plan review permissions settings of the selected participants",
          "heading_prop_editor_pl": "Change plan review permissions of the selected participants to the following setting:",
          "heading_prop_editor_sg": "Change plan review permission of the selected participant to the following setting:",
          "off": "Is not allowed to review revisions",
          "on": "Is allowed to review revisions",
          "save_error_can_approve_revisions_error": "An error occurred while saving the plan review permissions settings.",
          "title": "Plan Review Permission"
        },
        "contact_details": "Contact details:",
        "delete_participant": "Delete participant",
        "disable_participant_info": "To disable/delete this participant, click on the red button 'Delete participant' at the bottom.",
        "edit_contact_data": "Edit contact details",
        "edit_participant": "Edit participant",
        "edit_participant_role": "Edit participant role",
        "email_already_invited_to_project": "This email address already exists in the project – also check the recycle bin.",
        "email_cannot_be_changed": "The email address can not be changed later.",
        "email_does_not_exist": "This email address does not exist. Check for typos.",
        "email_not_deliverable": "There are problems with the deliverability of this e-mail address. Please check the correct spelling or contact our support.",
        "email_notifier": "Email notifier",
        "email_notifier_myself": "My Email notifier",
        "email_placeholder": "Email address",
        "error_email_is_invalid": "This email address cannot be reached – contact the email administrator.",
        "error_general": "An error occurred. The participant could not be invited.",
        "error_participant_already_exists": "This participant already exists.",
        "error_select_or_add_role": "Select a role or add a new role.",
        "import_participant_from_other_project": "Import participant from project",
        "invite": "invite to project",
        "invite_and_create_new": "invite + create new participant",
        "label_email_can_not_be_changed": "Email cannot be changed!",
        "modal": {
          "permission": {
            "header": "Edit permission"
          },
          "role": {
            "header": "Edit role"
          }
        },
        "permission": {
          "admin_feature_access_to_settings": "Access to Settings and Backup feature",
          "admin_feature_edit_all_project_data": "Edit the project structure and all project data",
          "admin_feature_insight_to_project_data": "Access to all project data",
          "admin_feature_login_for_project": "Login for this project",
          "admin_feature_participant_management": "Participant Management (Invite participants, manage permissions, enable/disable participants)",
          "admin_feature_short_description": "Access to all data and settings",
          "cant_activate_participant_with_invalid_email": "The email address of this participant is not valid and can not be activated. Contact our support!",
          "changing_plan_approval_permission_is_unauthorized_hint": "You are not allowed to change plan review permissions.",
          "disabled_participant_has_no_project_access": "This participant does NOT have access to this project!",
          "edit_permission": "Edit permission",
          "error_validation": "Fill in all the missing participant details, before you change the permission.",
          "notifications": "notifications",
          "owner_feature_create_or_delete_projects": "Create further projects or delete existing ones",
          "owner_feature_legal_owner": "Legal owner of the project",
          "participant_disabled": "disabled",
          "participant_enabled": "enabled",
          "participant_feature_insight_to_project_data": "Access to all project data except documents with access permission and tasks assigned to other roles",
          "participant_feature_login_for_project": "Login for this project",
          "participant_feature_short_description": "Upload of plans and documents",
          "participant_feature_upload_and_edit_in_assigned_role": "Upload and edit only in the assigned role",
          "participant_only_allowed_to_invite_silent_participants": "You are only allowed to invite participants without login.",
          "plan_approval_permission": "Plan review permission",
          "plan_approval_permission_revoked": "Plan review permission has been revoked",
          "revoking_plan_approval_permission_affects_future_approvals": "Revoking the plan review permission only affects future versions.",
          "silent_feature_no_login": "NO access to this project",
          "silent_feature_receive_download_links": "Receive data via download link by email",
          "silent_feature_short_description": "No Login. Data only via email",
          "time_in_timezone": "({time} in project timezone {timezone})",
          "title_permission": "Permission",
          "upload_alert": "Upload notifications for plans & documents",
          "upload_alert_will_be_sent_at": "The email is sent daily at {time}.",
          "you_want_to_transfer_ownership": "You want to transfer the project ownership to another participant? Then go to {link}."
        },
        "personal_message_to_new_participant": "Personalized message:",
        "previous_participant_invited": "Project invitation sent to '{email}'.",
        "previous_participant_without_login_invited": "„{email}“ was added to the project as participant without login.",
        "restore_participant": "Re-Activate",
        "role_details": "Role:",
        "save_and_create_new": "save + add another participant",
        "show_participant": "Show participant",
        "upload_alert": {
          "daily": "Daily",
          "heading": "Upload alert settings of the selected participants",
          "heading_prop_editor_pl": "Change upload alert settings of the selected participants to the following:",
          "heading_prop_editor_sg": "Change upload alert setting of the selected participant to the following:",
          "hourly": "Hourly",
          "off": "Off",
          "save_error_upload_alert_error": "An error occurred while saving the upload alert settings.",
          "title": "Upload Alert - Plans & Documents"
        }
      },
      "export_contact": {
        "address_city": "City:",
        "address_street": "Address:",
        "address_zip": "ZIP:",
        "company": "Company:",
        "email": "Email:",
        "export_contact": "Export contact",
        "export_contact_to_phone": "Create contact on device",
        "export_contact_to_phone_short": "Create on device",
        "export_contact_via_qr_code": "Show QR code",
        "export_contact_via_qr_code_short": "QR code",
        "name": "Name:",
        "note": "Note:",
        "phone": "Phone:",
        "scan_with_smartphone": "Scan QR-Code with smartphone",
        "vcf_export": "VCF-Export"
      },
      "filter_categories": {
        "access_permission": "Access permission",
        "roles": "Roles"
      },
      "keep_selected_participants_in_list": "Keep selected participants on filter change",
      "list": {
        "add_first_participant": "Click on 'New participant' to add the first participant to the project.",
        "city": "City:",
        "country": "Country:",
        "create_new_participant": "New participant",
        "do_you_need_help_to_create_participant": "Do you need help creating participants?",
        "headline_deleted_participants": "Recycle bin - deleted participants",
        "its_me": "Me",
        "not_authorized_to_create_participant": "You are not entitled to invite new participants!",
        "permission": "Permission",
        "server_error_can_approve_revisions": "An error occurred saving the plan review permission – try again.",
        "server_error_enabled": "The participant could not be deleted/restored – try again.",
        "server_error_invitation_email_does_not_exist": "The invitation could not be sent. The email does not exist",
        "server_error_upload_alert_status": "An error occurred saving the upload notifier status of the participant. Try again",
        "street": "Address:",
        "trash_icon_label": "Deleted participants",
        "without_role": "Without role",
        "zip": "ZIP:"
      },
      "modus": {
        "print": {
          "additional_infos": "Additional infos:",
          "export_list": "Export the participant list",
          "filter_none": "All participants",
          "filter_permissions": "Access permissions: {permissions}",
          "filter_roles": "Roles: {roles}",
          "filter_text_search": "Text search: {searchString}",
          "filtering": "Filtering:",
          "group_by": "Group by:",
          "group_by_none": "None",
          "group_by_permissions": "Permissions",
          "group_by_roles": "Roles",
          "participants_count": "Number:",
          "participants_list": "Participants",
          "print_list": "Print the filtered participant list",
          "project": "Project:",
          "state": "State:"
        },
        "trash": {
          "close_recycling_bin": "Close recycle bin"
        }
      },
      "one_item": "1 participant",
      "only_added_participants_of_your_role": "You can only edit participants for which you or your role {role} is the participant creator.",
      "overlay": {
        "all_participants_imported": "All participants of this project have already been invited to your project.",
        "all_participants_imported_from_all_projects": "All participants have already been invited to your project.",
        "all_plans_or_docs_imported": "All plans or documents of this project have already been imported to your project.",
        "choose_a_participant": "Select a participant"
      },
      "participant_group_import": {
        "accept": "Keep settings",
        "adjust_permissions": "Adjust permissions",
        "admins_become_project_participants": "Admins become project participants",
        "admins_plural": "{counter} Administrators",
        "admins_singular": "{counter} Administrator",
        "all_off": "all OFF",
        "all_on_daily": "For all DAILY",
        "all_participants_of_project_imported": "All participants have already been imported",
        "approval_keep_settings": "Keep plan review permission settings",
        "approval_permission": "Plan review permission",
        "close_window": "Close",
        "deactivate": "Deactivate",
        "import_admins_as_participants": "Import admins as participants",
        "import_all_as_silent": "Import all as participants without login",
        "import_another_group": "Import other participants",
        "import_as_silent_info_box_text_1": "With this setting, all selected participants are imported into the new project as 'Participants without login'.",
        "import_as_silent_info_box_text_2": "No invitation emails will be sent!",
        "import_as_silent_participant": "Import without login",
        "import_as_silent_submit_button_text": "Import participants without login",
        "import_participants": "Import {participantsCounter} participants",
        "import_participants_from_another_project": "Import Participants",
        "import_participants_from_VCF_file": "Import .vcf",
        "import_participants_report": "Import process completed",
        "import_participants_silent": "Import {participantsCounter} participants without login",
        "import_participants_single": "Import {participantsCounter} participant",
        "import_participants_single_silent": "Import {participantsCounter} participant without login",
        "info_message_no_more_options_1": "ATTENTION – You import all participants as ‘Participants without login’!",
        "info_message_no_more_options_2": "The imported participants therefore have no project access.",
        "info_message_no_more_options_3": "Upload notifications and review permission will be deactivated.",
        "info_message_no_more_options_4": "The imported participants do not receive an invitation email.",
        "keep_settings": "Keep access permission settings",
        "message": "Message",
        "next_step": "Next step",
        "no_admins": "No administrators",
        "no_participants": "No Participants",
        "no_silent": "No participants without login",
        "participant_group_import": "Import multiple participants",
        "participant_is_imported": "{counter} Participant is imported …",
        "participant_selected": "{participantsCounter} Participant selected",
        "participants_are_imported": "{counter} Participants are imported …",
        "participants_plural": "{counter} Participants",
        "participants_selected": "{participantsCounter} Participants selected",
        "participants_singular": "{counter} Participant",
        "permissions_in_target_project": "Authorizations in the target object:",
        "plan_approval_permission": "{counter} Plan review permission",
        "plan_approval_permissions": "{counter} Plan review permissions",
        "project_selection": "Project selection",
        "result_list_header": "List of imported participants:",
        "select_a_project": "First select a project",
        "select_one_or_more_participants": "Select one or more participants",
        "silent_participants_no_invitation_email_info_box_text": "Participants without a login will not receive a deposit email",
        "silent_plural": "{counter} Participants without login",
        "silent_singular": "{counter} Participant without login",
        "upload_notifier": "Upload notifier",
        "upload_notifier_off": "{counter} Upload notifier off",
        "upload_notifier_on": "{counter} Upload notifier on"
      },
      "participant_import": {
        "drop_vcf_infoscreen_headline": "Import participants from .vcf file",
        "import_participant_button": "Import participant from …",
        "import_participant_from_device": "Contacts",
        "import_participant_from_project": "other project",
        "import_participant_from_vcf": ".vcf file"
      },
      "participant_import_from_device": {
        "permission_hint": "Contacts permission is required to pick a contact.",
        "permission_how_to_grant_app_access": "You have previously denied this permission. Please open your device’s App Settings and enable Contacts access for this app."
      },
      "participant_selector": {
        "external_participant_assign_role": "Role only",
        "external_participant_needs_role": "'Participants without login' as author needs a role.",
        "external_participant_no_role_assigned": "No role assigned yet",
        "external_participants": "Participants without login + Role",
        "new_external_first_name": "First name",
        "new_external_last_name": "Last name",
        "new_external_mail": "Email address",
        "new_external_role_empty": "No role",
        "participants": "Participants with login + Role",
        "search_label": "Search participants by name, email or role",
        "select_external_without_role": "Select 'Participant without login' without role.",
        "without_name": "Without name",
        "without_role": "without role"
      },
      "permission_labels": {
        "owner": "Owner",
        "admin": "Admin",
        "participant": "Participant",
        "silent": "No login"
      },
      "permission_states": {
        "admin": "Project administrator",
        "admins": "Project administrators",
        "owner": "Project owner",
        "participant": "Project participant",
        "participants": "Project participants",
        "silent": "Participant without login",
        "silents": "Participants without login"
      },
      "property_edit_revision_messages": {
        "admin_must_not_edit_his_own_permission": "You as administrator must not change your own permission.",
        "owner_must_not_be_disabled": "The project owner must not be deleted.",
        "owner_permission_must_not_be_changed": "The permission of the project owner must not be changed.",
        "owners_role_must_not_be_changed": "You must not change the role of the project owner.",
        "participant_must_not_disable_himself": "You must not delete your own participant account.",
        "silent_participant_missing_mandatory_fields": "Please fill in the mandatory fields for the participant without login."
      },
      "property_editor_header_participant": "Set role of selected participant to:",
      "property_editor_header_participant_permission": "Set permission of selected participant to:",
      "property_editor_header_participants": "Set role of selected participants to:",
      "property_editor_header_participants_permission": "Set permission of selected participants to:",
      "property_preview_header_participant_delete": "Move selected participant to bin",
      "property_preview_header_participants_delete": "Move selected participants to bin",
      "property_preview_header_permission": "Permission of selected participants",
      "property_preview_header_roles": "Roles of selected participants",
      "save_edit_permission_error": "There was an error saving the permission.",
      "save_edit_role_error": "There was an error saving the role.",
      "save_participant_error_message": "An error occurred while saving the participant.",
      "update_one_participant": "Update 1 participant",
      "update_x_participants": "Update {counter} participants",
      "upload_notifier": {
        "options": {
          "daily": "Daily",
          "hourly": "Hourly",
          "off": "Off",
          "on": "On",
          "select": "Select"
        }
      },
      "week_start_report": {
        "options": {
          "off": "Off",
          "on": "On"
        }
      },
      "x_items": "{counter} participants"
    },
    "photo": {
      "1_photo_captured": "1 photo captured",
      "1_photo_selected": "1 photo selected",
      "all_photos": "All photos",
      "annotate_image": "Annotate image",
      "author_of_selected_photo": "Author of selected photo:",
      "author_of_selected_photos": "Author of selected photos:",
      "capture_date": "Capture date",
      "click_on_link_to_create_photo": "Click on \"Upload photo\" to create a photo.",
      "context_menu": {
        "delete": "Delete",
        "go_to_detail": "Detail page (with activities)",
        "note": "Note",
        "photo_album": "Album",
        "photo_author": "Author",
        "restore": "Restore",
        "share": "Share",
        "title": "Title",
        "use_as_template": "Use as template"
      },
      "create_new_photo": "Create new photo",
      "delete_1_photo": "Delete 1 photo",
      "delete_photo": "Delete photo",
      "delete_photo_question": "Delete photo?",
      "delete_x_photos": "Delete {x} photos",
      "deleted_photos": "Deleted photos",
      "detail": {
        "save_title_server_error": "There was an error saving the title – try again."
      },
      "download": {
        "resolution": "Resolution",
        "resolution_labels": {
          "large": "Full HD (1920 px)",
          "medium": "Compact (1280 px)",
          "original": "Original"
        }
      },
      "download_as": "Download photo as …",
      "download_photo": "Download photo",
      "duplicate_photo": "Duplicate photo",
      "edit_album_of_selected_photo": "Set photo album of selected photos to:",
      "edit_album_of_selected_photos": "Set photo album of selected photos to:",
      "edit_author": "Edit photo author",
      "edit_author_of_selected_photo": "Set author of selected photo to:",
      "edit_author_of_selected_photos": "Set author of selected photos to:",
      "edit_note": "Edit note",
      "edit_photo": "Edit photo",
      "edit_photo_album": "Edit photo album",
      "edit_photo_title": "Edit title",
      "edit_tags_of_selected_photo": "Set tags of selected photo to:",
      "edit_tags_of_selected_photos": "Set tags of selected photos to:",
      "edit_location_of_selected_photo": "Set location of selected photo to:",
      "edit_location_of_selected_photos": "Set location of selected photos to:",
      "mixed_location_layers_warning": "The selected photos are on different location plans. You can merge all selected photos onto a single location plan.",
      "current_location_of_selected_photo": "Current location of the selected photo:",
      "current_locations_of_selected_photos": "Current locations of the selected photos:",
      "server_error_save_photo_location": "An error occurred when saving the photo location.",
      "filter_capture_date": "Filter \"capture date\"",
      "further_properties": "More properties",
      "group_by_album": "Group by photo album",
      "group_by_location_layer": "Group by location plan",
      "group_by_none": "None",
      "not_assigned_to_any_album": "Not assigned to a photo album",
      "hide_1_selected_photo": "Hide 1 selected photo",
      "hide_x_selected_photos": "Hide {x} selected photos",
      "keep_selected_items_in_list": "Keep selected photos on filter change",
      "list": {
        "modus": {
          "print": {
            "as_of": "As of:",
            "create_print_job_error": "Error creating the print job.",
            "description": "Description:",
            "file_name": "File name:",
            "generate_pdf": "Generate PDF",
            "grouping": "Grouping:",
            "image_quality": "Image quality",
            "image_quality_high": "High",
            "image_quality_low": "Low",
            "image_quality_medium": "Medium",
            "last_modified": "last modified",
            "loading_error": "An error occurred while loading",
            "location": "Location:",
            "max_one_photo_per_page": "Max. 1 photo per page",
            "no_photos_to_print": "No photos found for printing.",
            "none": "none",
            "number_and_title": "No. + Title:",
            "overlay_print_is_being_prepared": "Preparing photos list print … {renderedItemsLength} of {allItemsLength}",
            "pdf_generation_limit_exceeded": "A maximum of {maxPhotos} photos can be generated as a PDF. Please reduce your selection. Printing via the browser is still possible.",
            "pdf_generation_pending": "The PDF is being generated. This may take a few moments...",
            "photo_print_settings": "Photo print settings ({count})",
            "photos_count": "Photos:",
            "preview_load_error": "The print preview could not be loaded. You can still download the PDF.",
            "preview_title": "Photo print preview",
            "print_menu_button": "Print menu",
            "print_photos": "Print photos",
            "print_preview_button": "Print preview",
            "selection": "Selection",
            "share_pdf": "Download PDF",
            "tags": "Tags:"
          }
        },
        "no_photos_available": "No photos available"
      },
      "maybe_photo_got_trashed_or_is_not_available": "The photo may have been deleted or is no longer available.",
      "move_selected_photo_into_trash": "Move selected photo to bin",
      "move_selected_photos_into_trash": "Move selected photos to bin",
      "multiple_photo_albums_will_be_merged": "Multiple photo albums will be merged irreversibly.",
      "new_photo": "New photo",
      "new_photos": "New photos",
      "add_photos": "Add photos",
      "new_photo_album": "New photo album",
      "no_note_available": "No note available",
      "no_photo_create_a_new_photo": "But you can create a photo now",
      "no_photos_in_this_view_available": "There are no photos available in this view.",
      "no_photos_to_edit": "There are currently no photos in your role {role} {link}",
      "only_added_photos_of_your_role": "You can only update photos for which you or your role {role} is the photo author.",
      "open_photo": "Open photo",
      "photo_activities": "Photo activities",
      "photo_album_of_selected_photo": "Photo album of the selected photo:",
      "photo_albums": "Photo albums",
      "photo_albums_of_selected_photos": "Photo albums of the selected photos:",
      "photo_author": "Author",
      "photo_authors": "Roles / Photo authors",
      "photo_can_be_selected_after_upload": "Photo can be selected once the upload is complete.",
      "photo_getting_uploaded": "Photo currently uploading",
      "photo_not_available": "Photo not available",
      "photo_not_uploaded_yet": "Photo not uploaded yet.",
      "photo_size": "Photo size",
      "photo_tag": "Photo Tag",
      "photo_title_placeholder": "Photo title",
      "photo_will_be_moved_to_trash": "Photo will be moved to trash",
      "photo_will_be_permanently_deleted": "Photo will be permanently deleted",
      "photos_count": "Number of photos",
      "processing_photo": "Processing photo …",
      "restore_photo": "Restore photo",
      "save_and_add_another_photo": "save + add another photo",
      "save_photo": "Save photo",
      "save_title_server_error": "There was an error saving the title – try again.",
      "save_x_photos": "Save {x} photos",
      "select_photos": "Select photos ...",
      "selected_photo_has_no_tags_assigned": "Selected photo does not have any tags attached",
      "selected_photos_have_no_tags_assigned": "Selected photos do not have any tags attached",
      "server_error_lost_access_to_photo": "Please reload the page. You no longer have access to this photo.",
      "server_error_photo_currently_uploading": "Photo is being uploaded. Try again later.",
      "server_error_photo_delete": "The photo could not be deleted - try again.",
      "server_error_photo_restore": "The photo could not be restored - try again.",
      "server_error_save_note": "An error occurred when saving the note - try again.",
      "server_error_save_photo": "An error occurred when saving the photo. Try again.",
      "server_error_save_photo_album": "An error occurred when saving the photo album.",
      "show_1_selected_photo": "Show 1 selected photo",
      "show_details": "Show details",
      "show_photo_infos": "Detail page (with activities)",
      "show_x_selected_photos": "Show {x} selected photos",
      "sort_by": "Sort by",
      "tags_of_selected_photo": "Tags of selected photo:",
      "tags_of_selected_photos": "Tags of selected photos:",
      "trashbin_trashed_photos": "Recycle bin – deleted photos",
      "unsaved_album_warning": "Add „{album}“ before saving.",
      "upload_photos": "Upload photos",
      "use_inputs_from_latest_photo": "Use inputs from latest photo",
      "use_photo_as_template": "Use photo as a template",
      "create_task_with_photo": "Create task with photo",
      "used_in_all_photos": "Used on every photo:",
      "used_in_some_photos": "Used on some photos:",
      "warning_add_photos": "Add photos",
      "warning_select_photo_album": "Select a photo album.",
      "x_of_y_photos": " {filteredCounter} of {unfilteredCounter} Photos",
      "x_photo_captured": "{x} photos captured",
      "x_photos_selected": "{x} photos selected"
    },
    "photo_properties": "Photo properties",
    "project": {
      "dashboard": {
        "heading_administration": "Administration",
        "heading_content": "Content",
        "heading_my_project_profile": "My Project Profile",
        "link_backup": "Project backup",
        "link_contact_data": "Contact details",
        "link_settings": "Settings"
      },
      "go_to_account_settings": "Go to user account",
      "go_to_project_list": "Go to project list",
      "maybe_you_have_no_project_access": "Maybe you don't have the required project access permissions anymore.",
      "project_not_available": "Project not available",
      "switch_project": "Switch project",
      "two_factor_auth_required_message": "Please enable Two-factor authentication in your user account settings.",
      "two_factor_auth_required_title": "Project requires Two-factor authentication"
    },
    "project_header": {
      "clipboard": {
        "all_files": "All files",
        "assign_files_from_clipboard": "assign {badge} from clipboard",
        "assigned": "assigned",
        "button": {
          "multiple_uploads_running": "{count} uploads running …",
          "my_clipboard": "My clipboard",
          "one_upload_running": "1 upload running …"
        },
        "drag_files_here": "Just drag files in here …",
        "drag_files_to_clipboard": "Just drag files in here …",
        "file_assigned": "assigned",
        "file_name": "File name",
        "file_not_visible_in_project": "not visible in the project yet!",
        "file_status": "Status",
        "file_type": "Type",
        "info_box": {
          "click_or_drag": "Click on 'select files' or drag the files directly to the clipboard.",
          "how_clipboard_makes_pf_easier": "How the clipboard makes working with PLANFRED easier"
        },
        "manage_my_clipboard": "Manage my clipboard",
        "no_files_in_clipboard": "There are no files in the clipboard which can be assigned",
        "no_running_uploads": "No running uploads",
        "not_assigned": "not assigned",
        "or_drop_files_here": "or just drop it here!",
        "remove_all_files": "empty current list",
        "remove_files": "empty list",
        "running_uploads": "running uploads …",
        "running_uploads_leave_anyways": "There are still documents being uploaded. If you leave the page now the upload is cancelled!",
        "running_uploads_logout_anyways": "Logout and cancel all running uploads?",
        "select_files": "Select files",
        "select_files_from_pc": "Select files from PC"
      },
      "flap": {
        "currently_no_uploads": "No plans or documents uploaded yet",
        "document_upload": "Documents",
        "last_upload": "Latest uploads",
        "my_upload_notifier": "My upload-notifier",
        "plan_upload": "Plans",
        "week_start_report": "Start Of The Week Report"
      },
      "settings_link": "Settings",
      "tab_nav_bar": {
        "activities": "Activities Log",
        "documents": "Documents",
        "general": "General",
        "mailer": "Mailing",
        "notifications": "Email Notifier",
        "participants": "Participants",
        "photodoc": "PhotoLog",
        "photodoc_trashed": "PhotoLog trash",
        "plans": "Plans",
        "project_transfer_ownership": "Project transfer",
        "settings": "Settings",
        "tasks": "Tasks",
        "to_be_approved_by_me": " …to be<br>reviewed by me"
      }
    },
    "project_list": {
      "create_first_new_project": "Create your first project",
      "create_new_demo_project": "Create new demo project",
      "create_new_project": "New project",
      "need_help_with_project_organization": "Do you need help with project organization?",
      "new_revision_available_notification_documents": "New documents available!",
      "new_revision_available_notification_link": "Reload list",
      "new_revision_available_notification_plans": "New plans available!",
      "no_project_participations": "No project participations yet",
      "no_uploads_yet": "No plans or documents uploaded yet",
      "own_projects": "My projects",
      "project_favorites": "Favorites",
      "project_list": "Project list",
      "project_participations": "Project participations",
      "project_updated_at": "Last plan/doc upload {updatedAt}",
      "projects": "Projects",
      "reorder_server_error": "An error occurred while reordering – try again.",
      "sort_created_at": "Recent first",
      "sort_label": "Sorting:",
      "sort_lastrevisionupload": "Last modified",
      "sort_title_asc": "Title ascending (A-Z)",
      "sort_title_desc": "Title descending (Z-A)",
      "update_server_error": "An error occurred while updating a favorite – try again.",
      "welcome_account_is_active": "Your user account is now active!",
      "welcome_congratulations": "Congratulations!"
    },
    "project_new": {
      "button_create_project": "Create project",
      "button_create_project_pending": "Creating project",
      "error_submit_server": "An error occurred – try again.",
      "free_without_obligation": "Enjoy a free and absolutely non-binding trial period.",
      "how_to_change_settings": "These settings can be adjusted at any time after the project has been created",
      "how_to_change_settings_in_app": "These settings can be adjusted on the web app (app.planfred.com) at any time after the project has been created",
      "import": "Import",
      "import_overlay": {
        "select_project": "Select a project"
      },
      "import_project_settings": "Apply from another project",
      "import_settings": "Apply settings",
      "import_settings_preview": "Settings preview",
      "international_project": "International project",
      "my_project": "My project:",
      "my_role": "My role in the project",
      "my_role_error_required": "Select your role in the project or add a suitable role.",
      "policy_consent_needed": "After your {trialPeriodDays}-day trial period you can decide whether you want to sign up for a paid PLANFRED plan.",
      "project_language": "Project language",
      "project_settings": "Project settings",
      "project_timezone": "Project time zone",
      "project_timezone_error_required": "Select a project time zone",
      "project_title_error_required": "Enter a project title.",
      "project_title_placeholder": "Enter project title",
      "settings_preview": {
        "document_phase": "Document folder",
        "document_phases": "Document folders",
        "document_tag": "Document tag",
        "document_tags": "Document tags",
        "document_top_categories": "Document top categories",
        "document_top_category": "Document top category",
        "documents_tagging_restricted_for_users": "Participants are not allowed to create new document tags",
        "documents_tagging_restricted_for_users_toggle_label": "Participants are allowed to create document tags",
        "edit_project_settings": "Edit Project",
        "location_tag": "Location tag",
        "location_tags": "Location tags",
        "no_tags_available": "No tags yet.",
        "photo_tags": "Photo tags",
        "plan_phases": "Plan folders",
        "plan_tag": "Plan tag",
        "plan_tags": "Plan tags",
        "plan_top_categories": "Plan top categories",
        "plans_tagging_restricted_for_users": "Participants are not allowed to create new plan tags",
        "plans_tagging_restricted_for_users_toggle_label": "Participants are allowed to create plan tags",
        "role_of_participant": "Role of participant",
        "roles_of_participants": "Roles of participants",
        "show_document_top_categories": "Show documents top categories",
        "show_plan_top_categories": "Show plans top categories",
        "task_tag": "Task tag",
        "task_tags": "Task tags"
      },
      "show_details": "Details",
      "your_first_project": "You are creating your first project"
    },
    "project_settings": {
      "backup": {
        "and_open_locally": "and open on your PC!",
        "backup_size": "~{size} compressed",
        "click_download_button": "Click the 'Download backup' button",
        "click_on_open_backup": "In the extracted project folder, double-click the “Open Project” file.",
        "complete_copy_will_be_downloaded": "When creating a project backup, a complete copy of your project is generated as an executable web app and downloaded. This project copy can be opened locally in any modern browser and used independently of the PLANFRED servers — no internet connection required.",
        "download_project": "Download project",
        "how_backup_works": "How does the project backup work?",
        "manual": "Manual:",
        "open_project_locally": "Open project locally",
        "project_backup": "Project backup",
        "project_size_on_server": "Project size on server:",
        "project_backup_size_estimated": "Estimated backup size:",
        "project_backup_size": "The final size of the project backup depends on its content and meta data.",
        "save_project_locally": "Save project locally",
        "unzip_file": "Unzip the downloaded file.",
        "unzip_file_headline": "Unzip file"
      },
      "banner_ownership_transfer": {
        "accept_project": "Accept project",
        "confirm_agb_to_accept": "The project ownership transfer can be accepted, as soon as you confirmed our T&Cs and GDPR.",
        "decline_project": "Decline project",
        "project_transfer": "Project transfer '{projectTitle}'",
        "project_transfer_successful": "The project transfer has been successfully completed.",
        "server_error": "An error occurred while saving – try again.",
        "wants_to_transfer_project": "{participantLink} would like to transfer the project '{projectTitle}' to you and make you the new project owner.",
        "what_happens_during_project_transfer": "What happens when a project is transferred?",
        "you_are_now_owner_of_project": "You are now the new owner of the project "
      },
      "base_error": "An error has occurred. \nTry again.",
      "delete": {
        "confirm_delete_by_enter_word": "Confirm the deletion by entering the word '{deleteWord}'",
        "create_backup_before_delete": "Create backup file before deleting.",
        "delete_project": "Delete project",
        "delete_project_forever": "Permanently delete project.",
        "delete_server_error": "An error occurred while deleting the project – try again.",
        "demo_cant_get_deleted": "The demo project can not be deleted.",
        "hint": "Tip:"
      },
      "delete_item": "Delete item?",
      "delete_label": "Delete {label}",
      "delete_message": "'{value}' will get deleted permanently",
      "edit_project_title": "Edit project title",
      "project_title": "Project title",
      "email_notifier": "Email Notifier",
      "email_notifier_extended": "My Email Notifier for this project",
      "email_notifier_headline": "My Email Notifier",
      "error_could_not_save_project_title": "An error occurred saving the project title – try again.",
      "import": {
        "already_imported_message": "All tags “{property}” from this project already imported.",
        "import_all_button_label": "Import all",
        "import_all_from_button_label": "Import all from “{property}”",
        "import_from_project": "Import from project",
        "import_properties_from_another_project": "Import “{property}”",
        "no_items_available_message": "No tags “{property}” available in this project."
      },
      "my_project": "My project:",
      "nav": {
        "documents": "Documents",
        "general": "General",
        "locations": "Locations",
        "participants": "Participants",
        "photos": "PhotoLog",
        "plans": "Plans",
        "tasks": "Tasks"
      },
      "not_allowed_to_edit": "You have no permissions to edit the project settings.",
      "ownership_transfer": {
        "1_description": "The new project owner must be a project participant and have an active PLANFRED package (invite the user to the project and assign a package to the user account if required).",
        "1_title": "Preparations",
        "2_title": "Begin transfer",
        "3_description": "The project transfer is completed once the new owner confirms acceptance of the project (via email).\nThe previous owner is then automatically assigned the role of project administrator.",
        "3_title": "New owner confirmation",
        "abort_transfer": "Abort project transfer",
        "abort_transfer_server_error": "An error occurred aborting the project transfer – try again.",
        "choose_new_owner": "Select a new project owner:",
        "current_owner": "Current project owner:",
        "manual_link_text": "To the manual “S2 Project transfer – change of project owner”",
        "not_allowed_to_transfer": "You are not authorized to transfer this project because you are not, or are no longer, the project owner.",
        "owner_becomes_admin_after_transfer": "A project owner can transfer a project to a participant at any time.\nAll project data remains fully intact; only the project owner is changed.\nOnce a user account is no longer assigned as the project owner, the trial period or billing obligation ends. In this case, the package can be switched to “FREE”.",
        "project_transfer": "Project transfer",
        "start_transfer": "Start transfer",
        "transfer_only_to_participants_with_plan": "The project can only be transferred to a participant with an active paid PLANFRED subscription.",
        "transfer_pending": "The project ownership transfer has been started and waits for approval by the new owner.",
        "transfer_project_to": "Transfer project to …",
        "transfer_server_error": "An error occurred starting the project transfer – try again."
      },
      "plan_tags": {
        "edit_plan_tag": "Edit plan tag"
      },
      "project_language": {
        "language_for_participants_individually": "Everyone involved can set the language of their user interface individually (see footer).",
        "no_translation_for_tags_etc": "When changing the project language, the settings (plan folders, roles, tags, etc.) are not translated – However, all emails will be sent in the chosen project language.",
        "phasetag_tag_roles_dont_get_translated": "Plan folders, roles and tags are not translated.",
        "please_check_if_necessary": "Check and translate them if necessary.",
        "server_error": "An error occurred saving the language – try again."
      },
      "project_owner_label": "Project owner:",
      "project_timezone": {
        "edit_timezone": "Edit timezone",
        "no_timezone_selected": "No timezone selected",
        "server_error": "An error occurred saving the timezone – try again."
      },
      "project_transfer": "Project transfer",
      "settings_and_backup": "Project settings",
      "two_factor_auth_required_headline": "Project access",
      "two_factor_auth_required_toggle_label": "2FA required for project access",
      "two_factor_auth_required_description": "Project participants must have two-factor authentication (2FA) enabled to access this project.",
      "two_factor_auth_required_not_enabled_title": "2FA is not enabled on your user account.",
      "two_factor_auth_required_enable_first": "Enable two-factor authentication on your user account to use this setting.",
      "two_factor_auth_required_go_to_settings": "Go to user account settings",
      "two_factor_auth_required_go_to_2fa": "Go to Two-factor authentication",
      "two_factor_auth_required_server_error": "An error occurred saving the setting – try again.",
      "tag_manager": {
        "add_server_error": "'{label}' could not be added – try again.",
        "delete_server_error": "'{label}' could not be deleted – try again.",
        "edit_server_error": "'{label}' could not be changed – try again.",
        "minimum_one_document_phasetag": "The last document folder can not be deleted.",
        "minimum_one_document_top_category": "The last document top category can not be deleted.",
        "minimum_one_plan_phasetag": "The last plan folder can not be deleted.",
        "minimum_one_plan_top_category": "The last plan top category can not be deleted.",
        "new_document_phase": "New document folder",
        "new_plan_phase": "New plan folder",
        "new_role": "New role",
        "new_tag": "New tag",
        "new_top_category_documents": "New document top category",
        "new_top_category_plans": "New plan top category",
        "no_document_tags_defined": "There have no document tags been created yet.",
        "no_photo_tags_defined": "There have no photo tags been created yet.",
        "no_plan_tags_defined": "There have no plan tags been created yet.",
        "no_task_tags_defined": "There have no task tags been created yet.",
        "reorder_server_error": "An error occurred while reordering – try again."
      },
      "tasks": {
        "activate_location_property": "Location property “{locationProperty}”",
        "cannot_delete_last_location_property": "The last location property cannot get deleted",
        "edit_task_location": "Edit Task locations",
        "enable_tasks_tab": "Enable tasks in this project",
        "enable_tasks_tab_cannot_be_disabled_hint": "Tasks can not be disabled after activation.",
        "location_tags": "Location tags",
        "new_task_type": "New task category",
        "save_task_location_label_server_error": "An error occurred while saving the location – try again.",
        "task_location": "Task location",
        "task_location_info": "You can find the settings under ”Locations“ (see above!).",
        "task_type": "Task category",
        "task_types": "Task categories"
      },
      "permission_owner": "Owner",
      "permission_admin": "Admin"
    },
    "revision_compare": {
      "compare_indexes": "Compare indexes",
      "compare_indexes_hint": "NEW: Compare two indexes of this plan and spot differences at a glance.",
      "loading": "Loading plans …",
      "revision_load_error": "The index could not be loaded.",
      "unsupported_file": "This PDF file could not be read.",
      "unsupported_file_type": "{type} files cannot be compared. The comparison only supports PDFs.",
      "unsupported_file_format": "This file format cannot be compared. The comparison only supports PDFs.",
      "no_print_file": "This index has no print file to compare.",
      "password_protected": "This index is password-protected and cannot be compared.",
      "not_comparable": "This index cannot be compared.",
      "page_position": "Page {current} of {total}",
      "too_many_changes": "Too many differences were found on this page to mark them individually.",
      "changes_detection_error": "This page could not be checked for differences.",
      "changes_dimension_mismatch": "The page sizes differ – differences cannot be marked.",
      "page_added_short": "new",
      "page_removed_short": "del.",
      "page_not_in_revision": "This page does not exist in this index.",
      "overlay_single_page_title": "Overlay not possible",
      "overlay_single_page": "This page exists in only one of the two indexes. It must exist in both to be overlaid.",
      "current_revision": "Current index",
      "swap_indexes": "Swaps the two indexes",
      "change_detection_notice_title": "Notice on the automatic difference markers",
      "change_detection_notice_title_short": "Notice",
      "change_detection_notice_text": "The difference markers are generated automatically by comparing the images of both indexes and are an aid to orientation only. Very small deviations are not marked, and the detection may miss differences or mark spots where nothing has changed. <strong>The difference markers therefore do not replace your own careful review of the plans.</strong>",
      "change_detection_notice_sensitivity_label": "Detection sensitivity:",
      "change_detection_notice_sensitivity_text": "A higher sensitivity also marks more spots where nothing has changed. The setting applies until you close the comparison.",
      "change_detection_notice_sensitivity_coarse": "Coarse",
      "change_detection_notice_sensitivity_coarse_description": "Marks only clear differences",
      "change_detection_notice_sensitivity_medium": "Medium",
      "change_detection_notice_sensitivity_medium_description": "Default – also marks smaller differences",
      "change_detection_notice_sensitivity_fine": "Fine",
      "change_detection_notice_sensitivity_fine_description": "Examines large plans more closely, takes longer",
      "change_detection_notice_details": "How the difference detection works",
      "change_detection_notice_details_method_title": "How the difference markers are created",
      "change_detection_notice_details_threshold_title": "Why not every difference is marked",
      "change_detection_notice_details_limits_title": "What this means for you",
      "change_detection_notice_details_method": "Both indexes are rendered page by page as images at the same resolution and compared pixel by pixel. Deviations that lie close together are combined into a single difference marker, which may therefore cover several differences. Only what is visibly displayed on the page is compared – hidden layers and file properties are not taken into account. The detection does not assess whether a difference is significant in substance.",
      "change_detection_notice_details_threshold": "When a PDF file is generated again, its rendering often deviates slightly even though the content of the plan has not changed – for example in hatching, line weights, color shades, or slightly shifted lines and text. If all of these deviations were marked, large areas of the plan would be covered with difference markers and they would lose their value as an aid. The detection therefore deliberately ignores deviations below defined thresholds, in particular very small, isolated or faint deviations.",
      "change_detection_notice_details_limits": "As a result, not every difference between the two indexes is marked. Small differences in particular – such as individual characters in labels or dimensions, short thin lines or small symbols – may remain unmarked. If a page contains a very large number of differences or the page sizes differ, no difference markers are shown. If no differences are found, this does not mean that the two indexes are identical.",
      "change_detection_notice_sketch_old": "Older index",
      "change_detection_notice_sketch_new": "Newer index",
      "change_detection_notice_sketch_marked": "Difference marker",
      "change_detection_notice_sketch_unfiltered": "Without threshold",
      "change_detection_notice_sketch_filtered": "With threshold",
      "change_detection_notice_sketch_missed": "Differing dimension stays unmarked",
      "change_detection_notice_sketch_note": "Schematic illustration",
      "change_detection_notice_confirm": "Understood, mark differences",
      "change_detection_notice_error": "Your confirmation could not be saved. Check your internet connection and try again.",
      "change_detection_notice_contact_support": "In case of incorrect detection, contact support",
      "report_problem": "Report a problem",
      "report_problem_title": "Report a problem with the index comparison",
      "report_problem_question": "What problem did you encounter?",
      "report_problem_debug_data_hint": "Data to help us fix the problem will be sent to PLANFRED along with your message."
    },
    "sharing": {
      "no_permission_to_open_view": "No permission to open this view.",
      "sharing_auth_token_missing": "This view requires a sharing token"
    },
    "sheet_compare": {
      "load_error": "The view could not be loaded.",
      "render_error": "The view could not be displayed in full. It may be too large for this device.",
      "dimension_mismatch": "Different dimensions – the overlay may not line up exactly.",
      "mode_split": "Split",
      "mode_overlay": "Overlay",
      "highlight_changes": "Mark differences found automatically",
      "changes": "Mark differences",
      "changes_none": "No differences found",
      "previous_change": "Previous difference marker",
      "next_change": "Next difference marker",
      "play": "Play",
      "pause": "Pause"
    },
    "support_bar": {
      "email_topics": {
        "defect": "I noticed a defect",
        "new_function": "I wan to have a new functionality",
        "question": "I have another question"
      },
      "prime_links": "<sup>*)</sup> Support via Screensharing only for <a href=\"https://www.planfred.com/en/pricing/\" target=\"_blank\">PRIME</a>-customers. <a href=\"https://planfred.whereby.com/schulung\" target=\"_blank\">Visit our Prime Online-Room</a>",
      "send_another_support_mail": "Send another support request",
      "send_email": "Send email",
      "subject": "Question",
      "support_box": {
        "links": {
          "faq": "FAQ (frequently asked)",
          "features": "New features",
          "in_app_support": "InApp Support (Book appointment) *",
          "manuals": "Manuals & Tips",
          "support": "Personal support"
        },
        "title": "Do you have any questions about PLANFRED? We are happy to answer them!"
      },
      "support_form": {
        "browser_outdated": "Your outdated browser version may be the cause of the error. Please update your browser. Thanks!",
        "message_required": "Enter a message.",
        "submit_error": "An error occurred sending your support request – try again.",
        "submit_success": "Thank you for reaching out!",
        "title": "… or simply contact us.",
        "topics": {
          "defect": "Describe the error that occurred.",
          "new_feature": "Describe your desired functionality.",
          "question": "Your question about PLANFRED."
        }
      },
      "support_message": "Please write us a message"
    },
    "task": {
      "detail": {
        "add_photo_or_file": "Add photo/file",
        "answer_question": "Answer clarification",
        "assign_task_before_publish": "Assign the task to a participant before publishing it.",
        "assign_task_to_another_participant": "Assign task to another participant",
        "assigned_to": "Assignee:",
        "attachments": "Photos/Attachments:",
        "can_only_delete_files_from_latest_comment": "Only files of the most recent comment can be deleted. A newer comment already exists.",
        "cannot_edit_files_from_clipboard": "Pictures from the clipboard can only be edited after they have been saved.",
        "change_history": "Change history",
        "change_history_is_loading": "Change history is loading …",
        "change_task_state_to": "Switch status to „{stateNew}“",
        "click_icon_to_reorder": "To reorder drag the icon {icon}!",
        "comment_change_log_could_not_be_loaded_server_error": "There was an error loading the changelog – try again.",
        "comment_history": "Comment history",
        "confirm_delete_task_draft": "Do you want to permanently delete the draft?",
        "could_not_complete_upload_of_file_x": "File \"{fileName}\" could not be uploaded.",
        "create_location_value_and_assign": "Create {locationValue} and assign",
        "creator": "Creater:",
        "current_comment_version": "Current version",
        "delete_description_empty_error": "The description cannot get removed, as the content of the task would be empty.",
        "delete_draft": "Discard",
        "delete_file_server_error": "An error occurred while saving the file – try again.",
        "delete_file_task_empty_error": "There must be at least 1 file, otherwise the content of the task would be empty.",
        "delete_item_message": "Task will be moved to trash.",
        "delete_task": "Delete task",
        "delete_task_draft_question": "Delete draft?",
        "delete_task_question": "Delete task?",
        "delete_task_server_error": "The task could not be deleted. \nTry again.",
        "delete_title_server_error": "The title cannot get deleted, otherwise the content of the task would be empty.",
        "description": "Description:",
        "download_file_server_error": "An error occurred while downloading the file – try again.",
        "due_date": "Due date:",
        "due_date_short": "Due:",
        "duplicate_task": "Duplicate task",
        "edit_assignee": "Edit assignee",
        "edit_attachments": "Edit attachments",
        "edit_comment": "Edit comment",
        "edit_description": "Edit description",
        "edit_due_date": "Edit due date",
        "edit_image": "Annotate image",
        "edit_location": "Edit location",
        "edit_message": "Edit message",
        "edit_tags": "Edit tags",
        "edit_task": "Edit task",
        "edit_text": "Edit text",
        "edit_title": "Title",
        "edit_type": "Edit category",
        "enter_done_message": "Enter completion message …",
        "enter_done_message_add_comment": "Add comment…",
        "enter_message": "Enter message …",
        "enter_question": "Enter question …",
        "file_gets_deleted_and_is_not_visible_anymore": "File will get deleted and is not visible to others anymore.",
        "files_currently_uploading": "Files currently uploading …",
        "files_not_uploaded_yet": "Files not uploaded yet.",
        "image": "Image",
        "is_edited": "Task was edited.",
        "location": "Location",
        "location_label": "Location:",
        "location_pin_label": "Location pin:",
        "location_pins_label": "Location pins:",
        "maybe_no_permission_to_view_task": "Maybe you don't have the required permission to view this task.",
        "missing_permission_to_add_location_values": "Only project admins und owners are able to add locations. Maybe you are missing the required permission.",
        "new_message": "New message",
        "new_task": "New task",
        "new_version": "New version",
        "no_assignee": "No assignee",
        "no_description": "No description available",
        "no_due_date_set": "No due date",
        "no_location_layer": "No location plan",
        "no_location_set": "No location",
        "no_location_tags_assigned": "No location tags",
        "no_location_values_defined_yet": "No entries defined yet",
        "no_message_available": "No text available",
        "no_messages_yet": "No messages yet",
        "no_photos": "No photos/attachments",
        "no_task_title": "No title",
        "no_type_set": "No category",
        "not_assigned": "not assigned",
        "old_state_does_not_match_server_error": "The task status has been changed in the meantime.",
        "old_version": "Old version",
        "please_select_an_assignee_to_publish": "Select an assignee in the following step to publish the task.",
        "publish_now": "Publish now",
        "publish_task": "Publish task",
        "published_label": "Created (published):",
        "put_to_trash": "Delete",
        "really_delete_file": "Really delete file?",
        "remove_assignee": "Remove assignee",
        "remove_due_date": "Remove date",
        "reorder_attachments": "Reorder attachments",
        "restore_task": "Restore task",
        "restore_task_server_error": "An error occurred while restoring the task – try again.",
        "save_assignee_server_error": "An error occurred while saving the assignee – try again.",
        "save_attachments_server_error": "An error occurred while saving the attachments – try again.",
        "save_author_server_error": "There was an error saving responsibility. \nTry again.",
        "save_comment_server_error": "An error occurred while saving the comment – try again.",
        "save_description_server_error": "An error occurred while saving the description – try again.",
        "save_document_folder_server_error": "An error occurred while saving the document folder – try again.",
        "save_due_date_server_error": "An error occurred while saving the due date – try again.",
        "save_location_server_error": "An error occurred while saving the location – try again.",
        "save_plan_folder_server_error": "An error occurred while saving the plan folder – try again.",
        "save_status_update_server_error": "An error occurred while saving the status update – try again.",
        "save_tags_server_error": "An error occurred while saving the tags – try again.",
        "save_title_server_error": "There was an error saving the title – try again.",
        "save_type_server_error": "An error occurred while saving the category – try again.",
        "send_task_reminder_header": "Send reminder",
        "state": "State:",
        "status_update_server_error": "An error occurred while saving the status update – try again.",
        "task_activities": "Task history",
        "task_assignee_missing": "Assign task",
        "task_assignee_missing_please_assign": "You must assign task before publishing. Assign now?",
        "task_currently_uploading": "Currently uploading …",
        "task_currently_uploading_error": "Task is being uploaded. Try again later.",
        "task_detail": "Task detail",
        "task_draft_will_get_deleted_permanently": "Task draft will get deleted permanently.",
        "task_messages": "Task messages",
        "task_not_available": "Task not available",
        "task_not_uploaded_yet": "Task not uploaded yet.",
        "task_publish_server_error": "An error occurred while publishing the task – try again.",
        "task_sync_server_error": "There was an error during the upload. To restart the synchronization process, restart the App.",
        "task_title_placeholder": "Task title",
        "task_type_task_state": "Category / State",
        "tasks_currently_syncing_delete_afterwards": "Task is currently syncing. Delete the file after the sync is finished.",
        "there_is_a_newer_comment_server_error": "This comment cannot get updated. There is a newer one.",
        "title_image": "Title image",
        "title_label": "Title:",
        "type": "Category:",
        "update_state": "Update status",
        "upload_file_server_error": "An error occurred while uploading the file – try again.",
        "validation_enter_message_or_add_file": "Enter a message, or add a file."
      },
      "download_table_cols_definitions": {
        "assignee": "Assignee",
        "assignee_email": "Assignee Email",
        "assignee_name": "Assignee Name",
        "assignee_role": "Assignee Role",
        "chats": "Chat messages",
        "consecutive_number": "Nr.",
        "created_at": "Created at",
        "creator": "Creator",
        "creator_email": "Creator Email",
        "creator_name": "Creator Name",
        "creator_role": "Creator Role",
        "description": "Description",
        "due_date": "Due date",
        "images": "Photos/Attachments",
        "location": "Location",
        "state": "Status",
        "tags": "Tags",
        "task_url": "Task-URL",
        "title": "Title",
        "type": "Category",
        "updated_at": "Updated at"
      },
      "export": {
        "task_list": "Task-List"
      },
      "list": {
        "can_select_task_after_upload": "Task can be selected once the upload is complete.",
        "click_on_link_to_create_task": "Click on 'New task' to add a task.",
        "context_menu": {
          "delete_task": "Delete",
          "duplicate_task": "Duplicate",
          "edit_assignee": "Assignee",
          "edit_description": "Description",
          "edit_due_date": "Due date",
          "edit_location": "Location",
          "edit_tags": "Tags",
          "edit_title": "Title",
          "edit_type": "Category",
          "new_and_prefill": "Use as template",
          "open_in_new_window": "Open in new window",
          "restore_task": "Restore",
          "send_task_reminder": "Send reminder",
          "update_task_in_new_window": "Update in new window"
        },
        "could_not_load_list_server_error": "Could not load project list.",
        "create_item": "New task",
        "document_mailer": {
          "send_task_to": "Send task to …",
          "send_tasks_to": "Send {count} tasks to …"
        },
        "done_tasks": "Completed Tasks",
        "drafts": "Drafts",
        "filter": {
          "1_task_due": "1 task due",
          "assignee": "Assignee",
          "creator": "Creator",
          "currently_no_tasks": "There are currently no tasks which can get filtered.",
          "currently_no_tasks_with_assignees": "There are currently no tasks assigned to participants.",
          "due_date": "Due date",
          "filter": "Filter",
          "filter_assignee": "Filter \"Assignee\"",
          "filter_creator": "Filter \"Creator\"",
          "filter_due_date": "Filter \"Due date\"",
          "filter_location_layers": "Filter \"Location plans\"",
          "filter_location_tags": "Filter \"Location tags\"",
          "location": "Location",
          "preset_question": "Clarification",
          "preset_tasks_for_me": "My Tasks",
          "preset_tasks_from_me": "Tasks from me",
          "reset": "Reset all filters",
          "select_due_date_range": "Select date range",
          "state": "Status",
          "task_state": "Task status",
          "type": "Category",
          "x_hits": "{x} hits",
          "x_tasks_due": "{counter} tasks due",
          "zero_hits": "0 Hits"
        },
        "hide_1_more_attachment": "1 additional attachment hidden",
        "hide_x_more_attachments": "{x} additional attachments hidden",
        "keep_selected_items_in_list": "Keep selected tasks on filter change",
        "list_header": {
          "assignee": "Assignee",
          "consecutive_number": "Number",
          "creator": "Creator",
          "description": "Description",
          "due_date": "Due date",
          "last_update": "Last update",
          "location": "Location",
          "status": "Status",
          "title": "Title",
          "type": "Category"
        },
        "load_and_search_one_old_done_task": "Load and search 1 completed task older than 60 days",
        "load_multiple_old_done_tasks": "Load and search {counter} completed tasks older than 60 days",
        "load_one_old_done_task": "Load 1 completed task older than 60 days",
        "modus": {
          "delete": {
            "headline_deleted_items": "Recycle bin - deleted tasks",
            "trash_icon_label": "Deleted tasks"
          },
          "print": {
            "card_view": "Large (detail print)",
            "export_list": "Export the filtered task list",
            "filter_locations": "Locations: {locations}",
            "filter_none": "All tasks",
            "filter_states": "Status: {states}",
            "filter_types": "Categories: {types}",
            "group_by_location_layer": "Group by location plan",
            "group_by_none": "None",
            "group_by_type": "Group by category",
            "list_view": "Small (list view)",
            "one_task_per_page": "Max. 1 task per page",
            "overlay_print_is_being_prepared": "Preparing tasks list print … {renderedItemsLength} of {allItemsLength}",
            "print_list": "Print the filtered task list",
            "show_all_task_images": "Show all images/attachments",
            "show_task_description": "Show task description",
            "show_task_log": "Show task history (with attachments)",
            "show_task_url": "Show task URL",
            "task_list": "Tasks",
            "tasks_count": "Number of tasks:"
          },
          "send": {
            "mark_tasks_to_send": "… select the desired tasks in the list!",
            "send_or_download_multiple_tasks": "Send or download multiple tasks"
          },
          "update": {
            "choose_task_to_update": "Select a task",
            "headline_update_item": "Update task",
            "no_task_create_a_new_task": "You can create a new task",
            "only_added_tasks_of_your_role": "You can only update tasks for which you or your role {role} is the task creator.",
            "update_current_task": "Update task"
          }
        },
        "my_drafts": "My drafts",
        "newest_first": "Newest first",
        "no_tasks_available": "No tasks available",
        "no_tasks_in_this_view_available": "There are no tasks available in this view.",
        "oldest_first": "Oldest first",
        "one_task": "1 Task",
        "print_task_list": "Print",
        "published_tasks": "Published tasks",
        "search_by_task_number": "Search by task number",
        "search_hits_in_comments": "Matches in comments:",
        "search_hits_in_description": "Matches in description:",
        "search_picker_no_results": "No task found with this number",
        "select_due_date_range": "Select date range ...",
        "state_update": "Update status",
        "tasks_loading": "Tasks loading ...",
        "tasks_to_be_done": "All Open Tasks",
        "update_list": "Update list",
        "x_of_y_tasks": "{filteredCounter} of {unfilteredCounter} Tasks",
        "x_tasks": "{counter} Tasks"
      },
      "multi_edit": {
        "1_task_selected": "1 Task selected",
        "assignee_of_selected_task": "Assignee of selected task:",
        "assignee_of_selected_tasks": "Assignee of selected tasks:",
        "cannot_restore_deleted_drafts": "Deleted drafts cannot be restored",
        "category_of_selected_task": "Category of selected task",
        "category_of_selected_tasks": "Categories of selected tasks",
        "delete_drafts_permanently": "Permanently delete drafts",
        "delete_one_task": "Delete 1 task",
        "delete_selected_task_draft": "Permanently delete the selected task draft",
        "delete_selected_task_drafts": "Permanently delete selected task drafts",
        "delete_x_tasks": "Delete {counter} tasks",
        "discard": "Discard",
        "discard_1_draft": "Discard 1 draft",
        "discard_x_drafts": "Discard {counter} drafts",
        "current_location_of_selected_task": "Current location of the selected task:",
        "current_locations_of_selected_tasks": "Current locations of the selected tasks:",
        "dueDate_of_selected_task": "Due date of selected task:",
        "dueDate_of_selected_tasks": "Due date of selected tasks:",
        "edit_due_date_of_selected_task": "Edit due date of selected task to:",
        "edit_due_date_of_selected_tasks": "Edit due date of selected tasks to:",
        "edit_location_of_selected_task": "Set location of selected task to:",
        "edit_location_of_selected_tasks": "Set location of selected tasks to:",
        "mixed_location_layers_warning": "The selected tasks are on different location plans. You can merge all selected tasks onto a single location plan.",
        "hide_1_selected_task": "Hide 1 selected task",
        "hide_x_selected_tasks": "Hide {count} selected tasks",
        "move_selected_task_to_trash": "Move selected task to bin",
        "move_selected_tasks_to_trash": "Move selected tasks to bin",
        "no_tasks_to_edit": "There are currently no tasks in your role {role} {link}",
        "publish": "Publish",
        "publish_1_task": "Publish 1 task",
        "publish_selected_draft": "Publish selected task draft",
        "publish_selected_drafts": "Publish selected task drafts",
        "publish_x_tasks": "Publish {counter} tasks",
        "removes_existing_due_dates": "Removes existing due dates",
        "select_task_property": "Select task property:",
        "select_tasks": "Select tasks ...",
        "selected_task_have_no_tags_attached": "Selected task does not have any tags attached",
        "selected_tasks_have_no_tags_attached": "Selected tasks do not have any tags attached",
        "server_error_publish_tasks": "An error occurred while publishing tasks - try again.",
        "server_error_save_task_location": "An error occurred when saving the task location.",
        "server_error_update_assignee": "An error occurred while saving the assignee. Assignee could not be changed.",
        "server_error_update_category": "An error occurred while saving the task category. Category could not be saved.",
        "server_error_update_dueDate": "An error occurred while saving the due-date. Due-date could not be changed.",
        "set_assignee_of_selected_task_to": "Set assignee of selected task to:",
        "set_assignee_of_selected_tasks_to": "Set assignee of selected tasks to:",
        "set_tags_of_selected_task": "Set tags of selected task to:",
        "set_tags_of_selected_tasks": "Set tags of selected tasks to:",
        "set_task_category_of_selected_task": "Set task category of selected task to:",
        "set_task_category_of_selected_tasks": "Set task category of selected tasks to:",
        "set_tasks_due_date_to": "Set tasks due date to",
        "show_1_selected_task": "Hide 1 selected task",
        "show_x_selected_tasks": "Show {count} selected tasks",
        "tags_of_selected_task": "Tags of selected task:",
        "tags_of_selected_tasks": "Tags of selected tasks:",
        "task_already_published": "The task is already published",
        "task_assignees_will_be_merged": "Multiple assignees will be merged irreversibly.",
        "task_categories_will_be_merged": "Multiple task categories will be merged irreversibly.",
        "task_leave_due_dates_remove": "Remove tasks due dates",
        "task_not_assigned_to_anyone": "The task is not yet assigned to any participant",
        "tasks_cannot_be_published": "{filteredCount} of {totalCount} Tasks cannot be published because they are not assigned yet",
        "tasks_cannot_be_updated": "{filteredCount} of {totalCount} Tasks cannot be updated",
        "this_task_cannot_be_published": "This task cannot be published because it is not assigned yet",
        "this_task_cannot_be_updated": "This task cannot be updated",
        "update_1_task": "Update 1 task",
        "update_x_tasks": "Update {counter} tasks",
        "used_on_all_tasks": "Used on every task:",
        "used_on_some_tasks": "Used on some tasks:",
        "x_of_y_drafts_discarded": "{counter} of {total} drafts discarded",
        "x_of_y_tasks_published": "{counter} of {total} tasks published",
        "x_task_selected": "{count} Tasks selected"
      },
      "new": {
        "add_location": "New location",
        "add_title_or_description_or_attachment": "Enter a title or a description or add an attachment.",
        "create_new_task": "Create new task",
        "create_server_error": "An error occurred while saving the task – try again.",
        "error_could_not_load_attachments": "Some attachments could not be loaded and were not added to the task.",
        "no_assignment": "Not set",
        "no_due_date": "Not set",
        "no_type": "None",
        "or_a_description": "… or a description …",
        "or_an_attachment": "… or add an attachment.",
        "please_enter_a_title": "Enter a title …",
        "publish": "Publish",
        "publish_directly": "Publish immediately",
        "publish_visibility_info": "This task will be visible for the assignee and his role as well as for all project administrators when it is published!",
        "save_draft": "Save draft",
        "save_draft_and_close_tab": "Save draft and close tab",
        "save_draft_and_create_new": "Save + create new task",
        "save_publish_and_close_tab": "Publish and close tab",
        "save_publish_and_create_new": "Publish + create new task",
        "search_or_add_location": "Search / Add {locationProperty}",
        "step_one": "Title / Description / Photos",
        "step_three": "Task additional information",
        "step_two": "Select task properties"
      },
      "open_task": "Open task",
      "state_changes": {
        "button_labels": {
          "answer": "Answer",
          "clarification": "Clarification",
          "comment": "Comment",
          "comment_verb": "Comment",
          "complete": "Complete"
        },
        "comment_done": "Note on completed task",
        "comment_new": "Comment on task",
        "comment_reopen": "Reopen task",
        "done": "Mark task as done",
        "question_add_question": "Comment on clarification",
        "question_answer_question": "Answer clarification",
        "question_new": "Start clarification for task",
        "question_reopen": "Reopen task and start clarification"
      }
    },
    "unsaved_changes": {
      "confirmation_question": "Do you want to discard your changes?",
      "title": "Unsaved changes"
    },
    "upload_alert": {
      "continue_in_project": "continue to project",
      "go_to_participant_detail": "Go to the participants details view",
      "participant": "Participant:",
      "personal_responsibility_notice": "Note: Unsubscribing from automatic email notifications is your own responsibility!",
      "project": "Project:",
      "successfully_disabled": "Upload notifier deactivated successfully",
      "successfully_enabled": "Upload notifier activated successfully",
      "update_server_error": "Upload notifier state could not be updated – try again.",
      "user_account": "User account:",
      "want_to_deactivate": "Want to deactivate the upload notifier?",
      "want_to_reactivate": "Want to reactivate the upload notifier?"
    },
    "uploader": {
      "cad_file": "CAD file",
      "clipboard": "Clipboard",
      "drop_file_here": "Drop the file here or select ...",
      "error_dropped_file": "Dropped file is invalid.",
      "error_file_could_not_be_added": "1 file could not be added",
      "error_file_empty": "{fileName} - File is empty.",
      "error_file_is_no_image": "The file could not be uploaded because it is not an image.",
      "error_no_extension": "{fileName} - File has no file extension.",
      "error_no_files_selected": "There are no files selected – try again.",
      "error_only_one_file_allowed": "Only 1 file can be uploaded.",
      "error_reason_could_not_open": "Could not be opened",
      "error_reason_empty": "Empty",
      "error_reason_too_large": "Larger than 20 MB",
      "error_x_files_could_not_be_added": "{counter} files could not be added",
      "file": "File",
      "file_system": "Local file",
      "file_system_mobile": "Photo or file",
      "from_clipboard": "from Clipboard",
      "from_file_system": "from local file",
      "modal_multiple_files": {
        "drag_files_into_doc_drop_area": "Create a .zip archive to upload multiple files in one document.",
        "drag_files_into_drop_area": "Drag <strong>one</strong> file each into the corresponding field for PRINT and CAD.",
        "here_is_the_clipboard_manual": "Click here for the instructions 'Multi-upload with clipboard'",
        "only_one_file_allowed": "Multiple files at once in one upload field is not allowed."
      },
      "or_drop_here": "or just drag over here!",
      "photo_attachment": "Photo / Attachment",
      "photo_picker_load_error": "The photos could not be loaded. Please try again.",
      "print_file": "PRINT file",
      "ready_to_save": "ready to save",
      "reset_upload": "Reset upload",
      "select_from_photodoc": "From PhotoLog",
      "select_photos": "Select photos",
      "select_photos_from_photodoc": "Select photos from PhotoLog",
      "select_x_photo": "Select {count} photo",
      "select_x_photos": "Select {count} photos",
      "server_error_upload_failed": "An error occurred while uploading – try again.",
      "upload_in_progress": "Upload in progress …",
      "upload_retry": "Upload again",
      "validation_error_general": "The file name must not contain permitted special characters.",
      "validation_error_minimum_one_file": "Upload at least one file.",
      "validation_error_no_special_character": "The file name must not contain special characters (;,/?:{'@'}&=+$)!",
      "validation_error_one_file": "Upload a file.",
      "validation_error_same_extension": "The files must not have the same file extension.",
      "validation_error_same_name": "The files must not have the same file name.",
      "warning_cad_file_in_print": "Warning: There is a CAD-File in the PRINT-Field",
      "warning_print_file_in_cad": "Warning: There is a Print-File in the CAD-Field",
      "you_want_to_upload_multiple_documents": "You want to upload multiple documents?",
      "you_want_to_upload_multiple_plans": "You want to upload multiple plans?"
    }
  },
  "layout": {
    "1_photo": "1 photo",
    "1_pin": "1 Pin",
    "1_task": "1 task",
    "add": "add",
    "all_conflicts_resolved": "All conflicts resolved",
    "and": "AND",
    "apply": "apply",
    "approval_date": "Review date",
    "approve_until": "to review until",
    "attachments": "Photo/Attachment:",
    "author": "Author",
    "back": "back",
    "back_to_overview": "Back to overview",
    "beta": "Beta",
    "big": "Big",
    "cancel": "cancel",
    "cancel_and_close": "cancel and close tab",
    "change": "change",
    "choose": "select",
    "close": "close",
    "confirm": "confirm",
    "content_and_settings": "Content & settings",
    "copy": "copy",
    "copy_url": "Copy URL",
    "copied_to_clipboard": "Copied to clipboard",
    "country_codes": {
      "at": "Austria",
      "au": "Australia",
      "be": "Belgium",
      "bg": "Bulgaria",
      "br": "Brazil",
      "ca": "Canada",
      "ch": "Switzerland",
      "cy": "Cyprus",
      "cz": "Czech Republic",
      "de": "Germany",
      "dk": "Denmark",
      "ee": "Estonia",
      "es": "Spain",
      "fi": "Finland",
      "fr": "France",
      "gb": "United Kingdom",
      "gr": "Greece",
      "hk": "Hong Kong",
      "hr": "Croatia",
      "hu": "Hungary",
      "ie": "Ireland",
      "in": "India",
      "it": "Italy",
      "jp": "Japan",
      "li": "Liechtenstein",
      "lt": "Lithuania",
      "lu": "Luxembourg",
      "lv": "Latvia",
      "mt": "Malta",
      "mx": "Mexico",
      "my": "Malaysia",
      "nl": "Netherlands",
      "no": "Norway",
      "nz": "New Zealand",
      "pl": "Poland",
      "pt": "Portugal",
      "ro": "Romania",
      "se": "Sweden",
      "sg": "Singapore",
      "si": "Slovenia",
      "sk": "Slovakia",
      "us": "United States"
    },
    "country_reset": "No selection",
    "created": "Created",
    "date_shortcuts": {
      "7days": "In 7 days",
      "end_of_next_week": "End of next week",
      "end_of_this_week": "End of this week",
      "last_week": "Last week",
      "next_monday": "Next monday",
      "next_week": "Next week",
      "this_week": "This week",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "yesterday": "Yesterday"
    },
    "deactivate": "Deactivate",
    "delete": "Delete",
    "delete_lowercased": "delete",
    "dictation_insert": "Insert text",
    "dictation_mode_for_ipad": "Dictation mode",
    "dictation_placeholder": "Tap the microphone on your keyboard and start dictating …",
    "discard_changes": "Discard input",
    "document_reviews": "Document reviews",
    "done": "Done",
    "download": "Download",
    "download_as": "Download as …",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "edit_multiple_props": "Edit",
    "edited": "Edited",
    "email_label": "Email:",
    "error": {
      "could_not_download_file": "Could not download file – try again.",
      "could_not_open_file": "Could not open file.",
      "could_not_load_data_server_error": "Could not load data. Please try again.",
      "could_not_save_settings": "The setting could not be saved. Contact our support.",
      "delete_data_error_try_again": "An error occurred while deleting the data – try again.",
      "delete_error": "Delete error",
      "delete_file_error_try_again": "An error occurred while deleting the file – try again.",
      "download_error": "Download error",
      "email_required": "Enter an email address.",
      "email_validation": "Enter a valid email address!",
      "error": "ERROR",
      "file_could_not_get_replaced": "The file could not be replaced.",
      "file_not_available_offline": "This file was not saved for offline use. You need an internet connection to access it.",
      "general": "An error occurred! Try again.",
      "live_update_check_error": "Update check failed",
      "load_error": "Load error",
      "max_upload_file_size_20mb": "The maximum allowed filesize is 20 MB",
      "offline_check_your_connection": "You are currently offline. Check your connection.",
      "open_error": "Open file error",
      "restore_error": "Restore error",
      "save_error": "Save error",
      "send_error": "Send error",
      "share_error": "Sharing error",
      "sharing_only_in_app_possible": "The sharing feature is only available in the mobile app.",
      "sync_error": "Synchronization error",
      "there_was_an_error_reordering_files": "There was an error while downloading this file – try again.",
      "unauthenticated_error": "Access not allowed",
      "upload_error": "Upload error",
      "upload_is_already_done": "The upload has already been completed.",
      "view_360_not_supported": "The 360° view is not supported on this device.",
      "wait_until_file_got_downloaded": "Wait until the file got fully downloaded."
    },
    "error_on_upload": "Error uploading.",
    "export": "Export",
    "file_loading": "Loading …",
    "file_not_found": "File not found",
    "filter_by_text": "Filter by search term …",
    "footer": {
      "any_questions": "Need help?",
      "our_support_team_is_available_for_you": "Our support team is happy to help you!",
      "planfred_email": "Email: {email}",
      "planfred_hotline": "PLANFRED Customer Support: {number}",
      "visit_us_at": "Visit us at {domain}"
    },
    "from_to_to": "to",
    "fullscreen": "Fullscreen",
    "go_to_top": "Go to TOP",
    "go_to_website": "go to homepage",
    "go_to_website_url": "https://{hostname}/en/",
    "group_by": "Group by",
    "header": {
      "nav": {
        "check_for_updates": "Check for updates",
        "company_list": "Company",
        "help": "Help",
        "logout": "Logout",
        "profile": "Profile",
        "project_list": "Projects",
        "troubleshooting": "Troubleshooting",
        "user_account": "User account"
      },
      "promotion_element": {
        "apply_plan_settings": {
          "description": "New plans can now receive the properties of the last uploaded plan.",
          "title": "Apply settings from last plan"
        },
        "compare_indexes": {
          "description": "Two indexes of a plan side by side or overlaid – spot differences at a glance.",
          "title": "NEW: Compare indexes!"
        },
        "enhanced_manuals": {
          "description": "Online on the homepage, as a PDF for easy printing or as video tutorials on YouTube.",
          "title": "Enhanced Support: PLANFRED Updates its User Guides"
        },
        "features_2021": {
          "description": "The ease of use of PLANFRED has been increased enormously in the last year …",
          "title": "All new features at a glance"
        },
        "inline_edit": {
          "edit_items_faster": "Edit plans and documents faster … directly in the list!",
          "edit_via_right_click": "Edit plan folders, tags and more via right-click"
        },
        "learn_more": "Learn more",
        "task_location": {
          "description": "ToDos and defects can now be localized even more precisely using a pin",
          "title": "NEW: Task location directly on the plan!"
        },
        "tasks_is_here": {
          "description": "Now included free of charge in all PLANFRED packages",
          "title": "Tasks - PLANFRED's to-do list is here!"
        },
        "top_categories": {
          "description": "Admins can turn on top categories for plans or documents in the project settings.",
          "title": "Top categories: Break down projects into objects"
        }
      }
    },
    "hint": "HINT:",
    "item_approval_date_presets": {
      "not_set": "No due date",
      "overdue": "Overdue"
    },
    "item_types": {
      "activities": "Activities",
      "activities_dative": "Activities",
      "activity": "Activity",
      "document": "Document",
      "document_dative": "Document",
      "documents": "Documents",
      "documents_dative": "Documents",
      "file": "File",
      "files": "Files",
      "files_dative": "Files",
      "locationLayer": "Location plan",
      "locationLayers": "Location plans",
      "locationLayers_dative": "Location plans",
      "participants": "Participants",
      "participants_dative": "Participants",
      "permission": "access permission",
      "permissions": "access permissions",
      "photo": "Photo",
      "photos": "Photos",
      "photos_dative": "Photos",
      "plan": "Plan",
      "plan_dative": "Plan",
      "plans": "Plans",
      "plans_dative": "Plans",
      "project": "Project",
      "projects": "Projects",
      "projects_dative": "Projects",
      "role": "Role",
      "roles": "Roles",
      "roles_dative": "Roles",
      "task": "Task",
      "tasks": "Tasks",
      "tasks_dative": "Tasks",
      "users": "Users",
      "users_dative": "Users"
    },
    "keep_editing": "Keep editing",
    "Label": "Label",
    "last_update": "Last update",
    "list": "List",
    "list_view": "List view",
    "location_layer": "Location plan",
    "menu": "Menu",
    "message": "Message:",
    "more": "Other",
    "newest_first": "Newest first",
    "next": "next",
    "next_one": "Next",
    "next_step": "Next step",
    "no": "no",
    "no_activities_yet": "No activities yet",
    "no_description": "No description",
    "no_files_present": "No files present",
    "no_grouping": "No grouping",
    "no_message": "No message",
    "no_note_available": "No note available",
    "no_tags": "No tags",
    "none": "None",
    "not_set": "Not set",
    "note": "Note",
    "note_comment": "Add comment",
    "ok": "Ok",
    "oldest_first": "Oldest first",
    "open": "Open",
    "or": "OR",
    "photo": "Photo",
    "photo_album": "Photo album",
    "pins": "Pins",
    "plan_reviews": "Plan reviews",
    "preview": "Preview",
    "previous_one": "Previous",
    "print": "Print",
    "print_being_completed": "Printing process is being completed",
    "print_capitalized": "Print",
    "print_click_to_close_dialog": "Click to close print dialog",
    "print_settings": "Print settings:",
    "thumbnail": "Thumbnails",
    "detailed": "Detail view",
    "privacy_policy": "Privacy Policy",
    "problem": "Problem",
    "package_edit_hint_text": "Login via your web browser and go to the user account page.",
    "package_edit_hint_title": "Want to edit your plan selection or billing address?",
    "project_title": "Project Title",
    "published": "Published",
    "read_more": "… read more",
    "remove": "Remove",
    "rename": "Rename",
    "reopen": "Re-Open",
    "report_problem": "In case of unexpected assignments contact support",
    "reset": "Reset",
    "reset_filter": "Reset filter",
    "reset_settings": "Reset settings",
    "restore": "Restore",
    "save": "Save",
    "save_and_close_tab": "Save and close tab",
    "save_and_submit": "Save and submit",
    "search": "Search",
    "select_all": "Select all",
    "select_all_added_participants": "Select all new participants",
    "select_all_admins": "Select all project admins",
    "select_all_owners": "Select all project owners",
    "select_all_participants": "Select all project participants",
    "select_all_participants_without_login": "Select all participants without login",
    "select_files": "Select file(s)",
    "select_photos": "Select photos",
    "send": "Send",
    "sent_message": "Message sent:",
    "set_filter": "Set filter",
    "should_the_form_entries_be_discarded": "Should the input be discarded?",
    "show_all": "Show all",
    "show_all_activities": "Show all activities",
    "show_details": "Show details",
    "show_less": "Show less",
    "show_x_hits": "Show {hitsCounter} hits",
    "since": "since",
    "slow_connection": "Slow internet connection.",
    "small": "Small",
    "solve_conflict": "Resolve conflict",
    "solve_conflicts": "Resolve conflicts",
    "sort_by": "Sort by:",
    "sort_selected_first": "Selected first",
    "sort_selected_last": "Selected last",
    "switch_to_list": "Switch to lists view",
    "task_due_date_presets": {
      "not_set": "No due date",
      "overdue": "Overdue",
      "upcoming": "Upcoming"
    },
    "task_states": {
      "done": "Completed",
      "draft": "Draft",
      "execution": "in Progress",
      "open": "unaffected",
      "question": "in Clarification"
    },
    "task_states_reaction": {
      "done": "Complete",
      "draft": "Draft",
      "execution": "Annotate",
      "open": "Open",
      "question": "Consult"
    },
    "terms_and_imprint": "Terms & Imprint",
    "text_search": "Text search",
    "title": "Title",
    "unknown_file": "Unknown File",
    "unlimited": "Unlimited",
    "up_to_date": "You're up to date",
    "update_1_photo": "Update 1 photo",
    "update_x_photos": "Update {x} photos",
    "upload": "Upload",
    "upload_as_soon_as_connection_is_stable": "Upload starts when connection is stable.",
    "url_copied_to_clipboard": "URL copied to clipboard",
    "view_full_size": "View full-size",
    "view_fullscreen": "Fullscreen",
    "view_in_browser": "Open in browser viewer",
    "view_in_embedpdf": "Open in standard viewer",
    "view_settings": "Display settings",
    "with_note": "With note",
    "without_note": "Without note",
    "x_of_y": "{x} of {y}",
    "x_of_y_already_imported": "{counter} of {total} imported",
    "x_photos": "{x} photos",
    "x_pins": "{x} Pins",
    "x_tasks": "{x} tasks",
    "yes": "yes",
    "zoom_in": "Zoom in",
    "zoom_out": "Zoom out"
  },
  "page_titles": {
    "account": "Account",
    "activities": "Activities",
    "changelog": "Changelog",
    "confirm_password": "Confirm password",
    "dashboard": "Project",
    "dashboard_long": "Project dashboard",
    "dashboard_settings": "Project",
    "documents": "Documents",
    "documents_new": "New document",
    "documents_trashed": "Documents trash",
    "download": "Download",
    "email_notifier": "Email Notifier",
    "forgot_password": "Forgot password",
    "general": "General",
    "login": "Login",
    "mailer": "Mailing",
    "no_account": "No Account yet?",
    "notification_settings": "Notification settings",
    "notifications": "Email Notifier",
    "participants": "Participants",
    "participants_new": "New participant",
    "participants_trashed": "Participants trash",
    "photodoc": "PhotoLog",
    "photos_new": "New photo",
    "plans": "Plans",
    "plans_new": "New plan",
    "plans_trashed": "Plans trashed",
    "project_dashboard": "Dashboard",
    "project_settings": "Project settings",
    "project_transfer": "Project transfer",
    "projects": "Projects",
    "projects_new": "Create project",
    "registration": "Register",
    "settings": "Settings",
    "tasks": "Tasks",
    "tasks_new": "New task",
    "tasks_trashed": "Tasks trashed",
    "upload_alert": "Upload-alert"
  },
  "project_manager": {
    "project_manager_category": "Category"
  }
}
